const OurProductData = [
  {
    id: 0,
    img: require("../assets/ourproductsimages/guitarcomp.png"),
    name: "Guitar Components",
    slug: "guitar-components",
    subname: "Nut, Saddles, Pics, Bridge Pics, Sliders & Inlay In Bone & Horn",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/guitar11-removebg-preview.png"),
        name: "Bone Nut",
        subname: "White, Dyed & Vintage",
        insidelink: "/products?headslug=bone-nut",
      },
      {
        img: require("../assets/ourproductsimages/guitar12-removebg-preview.png"),
        name: "Bone Saddle",
        subname: "White, Dyed & Vintage",
        insidelink: "/products?headslug=bone-saddle",
      },
      {
        img: require("../assets/ourproductsimages/guitar13-removebg-preview.png"),
        name: "Bridge Pins & Bridge Pin Blank",
        subname: "More",
        insidelink: "/products?headslug=bridge-pin",
      },
      {
        img: require("../assets/ourproductsimages/guitar14-removebg-preview.png"),
        name: "Guitar Inlay",
        subname: "Letter Opener With Many Colors",
        insidelink: "/products?headslug=guitar-inlay-slides",
      },
      {
        img: require("../assets/ourproductsimages/guitar15-removebg-preview.png"),
        name: "Guitar Inlay Bids",
        subname: "With Multi Colors",
        insidelink: "/products?headslug=guitar-inlay-slides",
      },
      {
        img: require("../assets/ourproductsimages/guitar16-removebg-preview.png"),
        name: "Guitar Slides",
        subname: "With Multi Colors",
        insidelink: "/products?headslug=guitar-inlay-slides",
      },
      {
        img: require("../assets/ourproductsimages/guitar17-removebg-preview.png"),
        name: "Horn Nut",
        subname: "In More Colors",
        insidelink: "/products?headslug=guitar-horn-nut-saddle-pics",
      },
      {
        img: require("../assets/ourproductsimages/guitar18-removebg-preview.png"),
        name: "Horn Saddle",
        subname: "In More Colors",
        insidelink: "/products?headslug=guitar-horn-nut-saddle-pics",
      },
      {
        img: require("../assets/ourproductsimages/guitar19-removebg-preview.png"),
        name: "Horn Picks",
        subname: "With Multi Colors",
        insidelink: "/products?headslug=guitar-horn-nut-saddle-pics",
      },
    ]
  },
  {
    id: 1,
    img: require("../assets/ourproductsimages/DSC_0046.png"),
    name: "Knife Handle",
    slug: "Knife-Handle",
    subname: "Bone, Horn, Wood, X-grip & Recon stone",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/camel1.png"),
        name: "Camel Bone Knife Handles",
        subname: "White, Dyed, Jigged, Stag, Acrylic Infused, Batik & Art Carving",
        insidelink: "/products?headslug=camel-bone-knife-handle",
      },
      {
        img: require("../assets/ourproductsimages/camel2.png"),
        name: "Water Buffalo Horn Knife Handles",
        subname: "Natural, Dyed, Jigged, Bark & Burnt etc.",
        insidelink: "/products?headslug=water-buffalo-horn",
      },
      {
        img: require("../assets/ourproductsimages/camel3.png"),
        name: "Giraffe Bone Look",
        subname: "Looking of Giraffe Pattern",
        insidelink: "/products?headslug=giraffe-bone-recone-true-x-grip",
      },
      {
        img: require("../assets/ourproductsimages/camel4.png"),
        name: "Recon Stone/True Stone Handles",
        subname: "Colorful Stones",
        insidelink: "/products?headslug=giraffe-bone-recone-true-x-grip",
      },
      {
        img: require("../assets/ourproductsimages/camel5.png"),
        name: "OX-Zebu Horn Knife Handles",
        subname: "Different Structure Knife Handle",
        insidelink: "/products?headslug=zebu-sheep-wood-horn-handle",
      },
      {
        img: require("../assets/ourproductsimages/camel6.png"),
        name: "Sheep Horn Knife Handles",
        subname: "Sheep, Ram's & More",
        insidelink: "/products?headslug=zebu-sheep-wood-horn-handle",
      },
      {
        img: require("../assets/ourproductsimages/camel7.png"),
        name: "Stabilized Wood Handles",
        subname: "Ebony, Walnut Wood, & More",
        insidelink: "/products?headslug=zebu-sheep-wood-horn-handle",
      },
      {
        img: require("../assets/ourproductsimages/camel8.png"),
        name: "X-Grip Handles",
        subname: "Colorful & Attractive",
        insidelink: "/products?headslug=giraffe-bone-recone-true-x-grip",
      },
    ]
  },
  {
    id: 2,
    img: require("../assets/ourproductsimages/vikingcraft.png"),
    name: "Viking Craft",
    slug: "knife-handle",
    subname: "Combs, Drinking Horn, Bone Dice, Etc.",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/vikingcraft1-removebg-preview.png"),
        name: "Viking Comb",
        subname: "In Bone, Horn & Wood",
        insidelink: "/products?headslug=viking-combs",
      },
      {
        img: require("../assets/ourproductsimages/vikingcraft2-removebg-preview.png"),
        name: "Drinking Horn & Engraved",
        subname: "Only In Horn With Engraved",
        insidelink: "/products?headslug=drinking-horn",
      },
      {
        img: require("../assets/ourproductsimages/vikingcraft3-removebg-preview.png"),
        name: "Bone Dice",
        subname: "Only In Bone",
        insidelink: "/products?headslug=bone-dice",
      },
      {
        img: require("../assets/ourproductsimages/vikingcraft4-remove.png"),
        name: "Bone Weaving Plate",
        subname: "Only In Bone",
        insidelink: "/products?headslug=bone-weaving-plate",
      },
      {
        img: require("../assets/ourproductsimages/vikingcraft5-removebg-preview.png"),
        name: "Viking Cloak Pins",
        subname: "In Bone & Horn",
        insidelink: "/products?headslug=viking-cloak-pins",
      },
      {
        img: require("../assets/ourproductsimages/vikingcraft6-removebg-preview.png"),
        name: "Bone Needle",
        subname: "Only In Bone",
        insidelink: "/products?headslug=bone-needle",
      },
    ]
  },
  {
    id: 3,
    img: require("../assets/ourproductsimages/NAtive.png"),
    name: "Native American Craft",
    slug: "native-american-craft",
    subname: "Bone & Horn ",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/hairpipebeads1-removebg-preview.png"),
        name: "Bone Hair Pipes Beads",
        subname: "In Bone",
        insidelink: "/products?headslug=bone-beads",
      },
      {
        img: require("../assets/ourproductsimages/hairpipebeads2-removebg-preview.png"),
        name: "Horn Hair Pipes Beads",
        subname: "In Horn",
        insidelink: "/products?headslug=horn-beads",
      },
      {
        img: require("../assets/ourproductsimages/hairpipebeads3-removebg-preview.png"),
        name: "Bone Spacers",
        subname: "In Bone",
        insidelink: "/products?headslug=bone-spacer",
      },
      {
        img: require("../assets/ourproductsimages/hairpipebeads4-removebg-preview.png"),
        name: "Horn Spacers",
        subname: "In Horn",
        insidelink: "/products?headslug=horn-spacer",
      },
      {
        img: require("../assets/ourproductsimages/hairpipebeads5-removebg-preview.png"),
        name: "Buffalo Teeth",
        subname: "Buffalo Bone",
        insidelink: "/products?headslug=buffalo-teeth",
      },

    ]
  },
  {
    id: 4,
    img: require("../assets/ourproductsimages/DSC_0001.png"),
    name: "Teflon Folder",
    slug: "teflon-folder",
    subname: "Bone, Horn, Wood & Teflon",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/teflon1-removebg-preview.png"),
        name: "Bone Folder",
        subname: "White, Batik, Dyed & More",
        insidelink: "/products?headslug=teflon-bone-folder",
      },
      {
        img: require("../assets/ourproductsimages/teflon2-removebg-preview.png"),
        name: "Teflon folder",
        subname: "Teflon, Burnisher, Rib",
        insidelink: "/products?headslug=teflon-folder",
      },
      {
        img: require("../assets/ourproductsimages/teflon3-removebg-preview.png"),
        name: "Horn Folder",
        subname: "Horn With Many Colors",
        insidelink: "/products?headslug=horn-folder",
      },
      {
        img: require("../assets/ourproductsimages/teflon4-removebg-preview.png"),
        name: "Wood Folder",
        subname: "Ebony, Walnut & More",
        insidelink: "/products?headslug=wood-folder",
      },
      {
        img: require("../assets/ourproductsimages/teflon5-removebg-preview.png"),
        name: "Agate Burnisher",
        subname: "White, Batik, Dyed & More",
        insidelink: "/products?headslug=agate-burnisher",
      },

    ]
  },
  {
    id: 5,
    img: require("../assets/ourproductsimages/cuestickcomponet.png"),
    name: "Cue Stick Components",
    slug: "cue-stick-components",
    subname: "Ferrules, Joint Collar, Butt Caps, Inlay Slabs & Rods and Dowels All Are in Bone & Horn",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/cuestick1-removebg-preview.png"),
        name: "Cue ferrules",
        subname: "White, Dyed & Vintage",
        insidelink: "/products?headslug=cue-ferrules",
      },
      {
        img: require("../assets/ourproductsimages/cuestick2-removebg-preview.png"),
        name: "Joint Collar",
        subname: "Black & More",
        insidelink: "/products?headslug=joint-collor",
      },
      {
        img: require("../assets/ourproductsimages/cuestick3-removebg-preview.png"),
        name: "Butt Caps",
        subname: "Black & More",
        insidelink: "/products?headslug=butt-caps",
      },
      {
        img: require("../assets/ourproductsimages/cuestick4-removebg-preview.png"),
        name: "Inlay Slabs",
        subname: "In many colors & materials",
        insidelink: "/products?headslug=inlay-slabs-cue-components",
      },
      {
        img: require("../assets/ourproductsimages/cuestick5-removebg-preview.png"),
        name: "Rods & Dowels",
        subname: "In Many Colors",
        insidelink: "/products?headslug=rods-dowels-cue-components",
      },

    ]
  },
  {
    id: 6,
    img: require("../assets/ourproductsimages/beadscraft.png"),
    name: "Beads Crafts",
    slug: "beads-crafts",
    subname: "Pandent, Horn Beads, Bone Beads, Wood Beads, Glass Beads Etc...",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/beads11-removebg-preview.png"),
        name: "Pandent",
        subname: "Only In Bone",
        insidelink: "/products?headslug=pandent-beads",
      },
      {
        img: require("../assets/ourproductsimages/beads22-removebg-preview.png"),
        name: "Horn Beads",
        subname: "Only In Horn",
        insidelink: "/products?headslug=horn-beads",
      },
      {
        img: require("../assets/ourproductsimages/beads33-removebg-preview.png"),
        name: "Bone Beads",
        subname: "Only In Bone",
        insidelink: "/products?headslug=bone-beads",
      },
      {
        img: require("../assets/ourproductsimages/beads55.png"),
        name: "Wood Beads",
        subname: "In Wood",
        insidelink: "/products?headslug=/",
      },
      {
        img: require("../assets/ourproductsimages/beads44.png"),
        name: "Glass Beads",
        subname: "In Glass ",
        insidelink: "/products?headslug=/",
      },

    ]
  },
  {
    id: 7,
    img: require("../assets/ourproductsimages/pen-blank.png"),
    name: "Pen Blank & Turning Scale",
    slug: "pen-blank-turning-scale",
    subname: "In Bone, Horn, Wood, X-Grip & Recon Stone",
    OurProductInsideData: [
      {
        img: require("../assets/ourproductsimages/pbh01.png"),
        name: "Bone Pen Blank",
        subname: "Only In Bone",
        insidelink: "/products?headslug=bone-pen-blank",
      },
      {
        img: require("../assets/ourproductsimages/pbh02.png"),
        name: "Horn Pen Blank",
        subname: "Only In Horn & More",
        insidelink: "/products?headslug=horn-pen-blank",
      },
      {
        img: require("../assets/ourproductsimages/pbh03.png"),
        name: "Wood Pen Blank",
        subname: "Only In Wood & More",
        insidelink: "/products?headslug=wood-pen-blank",
      },
      {
        img: require("../assets/ourproductsimages/pbh04.png"),
        name: "X-Grip Blank & Turning Block",
        subname: "In Multi Color",
        insidelink: "/products?headslug=x-grip-pen-blank",
      },
      {
        img: require("../assets/ourproductsimages/pbh05.png"),
        name: "Recone Stone Blank & Turning Block",
        subname: "In Multi Color",
        insidelink: "/products?headslug=recone-stone-pen-blank",
      },
    ]
  },
  {
    id: 8,
    img: require("../assets/ourproductsimages/boneclasp.png"),
    name: "Bone Clasps",
    subname: "Bone Clasps...",
    link: "/products?headslug=bone-clasp"
  },
  {
    id: 9,
    img: require("../assets/ourproductsimages/horn-bone-spoon.png"),
    name: "Horn Cutlery Spoon",
    subname: "Horn Spoon ...",
    link: "/products?headslug=/"
  },
  {
    id: 10,
    img: require("../assets/ourproductsimages/piono-organs.png"),
    name: "Piano & Organ Keys",
    subname: "Only In Bone ...",
    link: "/products?headslug=piono-organ-keys"
  },
  {
    id: 10,
    img: require("../assets/ourproductsimages/homedecor.png"),
    name: "Home Decor",
    subname: "Bone, Horn & Wood Items ...",
    link: "/products?headslug=home-decor"
  },
  {
    id: 11,
    img: require("../assets/ourproductsimages/bone-buttons.png"),
    name: "Bone Button",
    subname: "Bone Items ...",
    link: "/products?headslug=stag-bone-button"
  },
  {
    id: 12,
    img: require("../assets/ourproductsimages/bonedominoes.png"),
    name: "Dominoes Set",
    subname: "Bone & Horn Items ...",
    link: "/products?headslug=dominoes-set"
  },
  {
    id: 14,
    img: require("../assets/ourproductsimages/shoe-horn.png"),
    name: "Shoe Horn",
    subname: "In Bone, Horn, & Wood Matter",
    link: "/products?headslug=shoe-horn"
  },
  {
    id: 13,
    img: require("../assets/ourproductsimages/knife-handle.png"),
    name: "Antique Knife Handles",
    subname: "Bone & Horn Items ...",
    link: "/products?headslug=antique-bone-knife"
  },
]

const ConstantData = [
  // Bone Nut product All Data
  {
    head: "Guitar Bone Nut",
    headslug: "bone-nut",
    dec: "Unleash the tone of your guitar with our premium bone nuts, crafted from sustainably sourced animal bones. Our expert luthiers carefully select and shape each nut to bring out its unique characteristics, resulting in a rich, warm sound. From camel bones to buffalo horns, each nut is precision-made to fit your guitar perfectly. Experience the harmonic resonance and sustain of our bone nuts, designed to enhance your music and inspire your creativity. Upgrade your guitar with our eco-friendly, handcrafted bone nuts and discover a new level of tone and playability",
    mainData: [
      {
        id: 0,
        img: require("../assets/guitar-components/whitebonenut1.jpg"),
        title: "White Bone Nut Blank",
        usbData: [
          {
            prodId: "RC-WNB-01",
            name: "White Bone Martin Style Shaped Bone Nut Blank (Bleached Bone)",
            size1: "46mm x 10 x 6.35mm",
            size2: "3/4″ x 3/8″ x 1/4″",
            images: [require("../assets/guitar-components/RC-WNB-1.jpg"),]
          },
          {
            prodId: "RC-WNB-02",
            name: "White bone nut Slant Cut Bone Nut Blank (Bleached Bone)",
            size1: "52.5mm x 9.5mm x 6.35mm",
            size2: "2″ x 3/8″ x 1/4″",
            images: [require("../assets/guitar-components/RC-WNB-2.1.jpg"), require("../assets/guitar-components/RC-WNB-2.2.jpg"),]
          },
          {
            prodId: "RC-WNB-03",
            name: "White Belched Bone Nut Blank (Bleached Bone)",
            size1: "56mm x 11mm x 6.6mm",
            size2: "25/32″ x 1/2″ x 1/4″",
            images: [require("../assets/guitar-components/RC-WNB-3.1.jpg"), require("../assets/guitar-components/RC-WNB-3.2.jpg")]
          },
          {
            prodId: "RC-WNB-04",
            name: "White bone Oversize Bone Nut Blank (Bleached Bone)",
            size1: "65mm x 5mm x 10mm",
            size2: "5/8″ x 3/8″ x 3/16″",
            images: [require("../assets/guitar-components/RC-WNB-4.1.jpg"), require("../assets/guitar-components/RC-WNB-4.2.jpg"),]
          },
          {
            prodId: "RC-WNB-05",
            name: "Fender Nut Blank (Bleached Bone)",
            size1: "47mm x 7mm x 3.20mm",
            size2: "13/4″ x 0.275″ x 0.125″",
            images: [require("../assets/guitar-components/RC-WNB-5.1.jpg"), require("../assets/guitar-components/RC-WNB-5.2.jpg"),]
          },
          {
            prodId: "RC-WNB-06",
            name: "White bone nut Slant Cut Bone Nut Blank (Bleached Bone)",
            size1: "52.5mm x 9.5mm x 6.35mm",
            size2: "12.06″ x 0.374″ x 0.25″",
            images: [require("../assets/guitar-components/RC-WNB-6.1.jpg"), require("../assets/guitar-components/RC-WNB-6.2.jpg"),]

          },
          {
            prodId: "RC-WNB-07",
            name: "Large Bone Nut Blank for Guitars or Brasses (Bleached bone)",
            size1: "56mm x 11mm x 6.5mm",
            size2: "21/5″ x 11/32″ x 1/4″",
            images: [require("../assets/guitar-components/RC-WNB-7.jpg"), require("../assets/guitar-components/RC-WNB-7.jpg"),]
          },
          {
            prodId: "RC-WNB-08",
            name: "Bone Nut Blank (Bleached Bone)",
            size1: "51mm x 10mm x 3.5mm",
            size2: "2″ x .4″ x 1.4″",
            images: [require("../assets/guitar-components/RC-WNB-8.jpg"), require("../assets/guitar-components/RC-WNB-8.jpg"),]
          },
          {
            prodId: "RC-WNB-09",
            name: "Bone Nut Blank (Bleached Bone)",
            size1: " 56mm x 12mm x 6.5mm",
            size2: "2.2″ x .47″ x .25″",
            images: [require("../assets/guitar-components/RC-WNB-9.jpg"), require("../assets/guitar-components/RC-WNB-9.jpg"),]
          },
          {
            prodId: "RC-WNB-10",
            name: "Fender Nut Blank (Bleached Bone)",
            size1: " 51mm x 10mm x 3.20 mm",
            size2: "1/8″ x .375″ x 2″",
            images: [require("../assets/guitar-components/RC-WNB-10.1.jpg"), require("../assets/guitar-components/RC-WNB-10.2.jpg"),]

          },
          {
            prodId: "RC-WNB-11",
            name: "Small Standard White Bone Nut Blank (Bleached Bone)",
            size1: " 55mm x 12mm x 5.70 mm",
            size2: "2.2″ x .470″ x .225″",
            images: [require("../assets/guitar-components/RC-WNB-11.jpg"), require("../assets/guitar-components/RC-WNB-11.jpg"),]
          },
          {
            prodId: "RC-WNB-12",
            name: "Bone Guitar Nut Blank (Regular Size Nut Blank) (Bleached Bone)",
            size1: "54mm x 9mm x 6.35mm ",
            size2: "11/32″ x 1/4″ x 2.1/8″)",
            images: [require("../assets/guitar-components/RC-WNB-12.jpg"), require("../assets/guitar-components/RC-WNB-12.jpg"),]
          },
          {
            prodId: "RC-WNB-13",
            name: "White Nut Blank Bone (Bleached Bone)",
            size1: "90 x 12 x 8mm ",
            size2: "31/2″ x 1/2″ x 5/10″)",
            images: [require("../assets/guitar-components/RC-WNB-13.jpg"), require("../assets/guitar-components/RC-WNB-13.jpg"),]
          },
          {
            prodId: "RC-WNB-14",
            name: "White Nut Blank Bone (Bleached Bone)",
            size1: "76 x 12 x 6mm ",
            size2: "3″ x 1/2″ x 1/4″)",
            images: [require("../assets/guitar-components/RC-WNB-14.jpg"), require("../assets/guitar-components/RC-WNB-14.jpg"),]
          },
          {
            prodId: "RC-WNB-15",
            name: "White Bone Nut Blank (Bleached Bone)",
            size1: "55 x 8.7 x 6.3mm",
            size2: "2.3/16″ x 1/4″ x 11/32″",
            images: [require("../assets/guitar-components/RC-WNB-15.jpg"), require("../assets/guitar-components/RC-WNB-15.jpg"),]
          },
          {
            prodId: "RC-WNB-16",
            name: "White Bone Nut Blank (Bleached Bone)",
            size1: "65 x 12 x 6.30mm",
            size2: "29/16″ x 15/32″ x 1/4″))",
            images: [require("../assets/guitar-components/RC-WNB-16.jpg"), require("../assets/guitar-components/RC-WNB-16.jpg"),]
          },
          {
            prodId: "RC-WNB-17",
            name: "Bone Nut Corian (Bleached Bone)",
            size1: "56 x 10.3 x 6.3mm",
            size2: "2.1/4″ x 13/32″ x 1/4″",
            images: [require("../assets/guitar-components/RC-WNB-17.jpg"), require("../assets/guitar-components/RC-WNB-17.jpg"),]
          },
          {
            prodId: "RC-WNB-18",
            name: "White Fender Style Nut (Bleached Bone)",
            size1: "56 x 10.3 x 6.3mm",
            size2: "2.1/4″ x 13/32″ x 1/4″",
            images: [require("../assets/guitar-components/RC-WNB-18.jpg"), require("../assets/guitar-components/RC-WNB-18.jpg"),]
          },
        ],
      },
      {
        id: 1,
        img: require("../assets/guitar-components/dyedbonenut1.jpg"),
        title: "Dyed Bone Nut Blank",
        usbData: [
          {
            prodId: "RC-DNB-01",
            name: "Dyed stabilized Red Bone Oversize Bone Nut Blank",
            size1: "65mm x 5mm x 10mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn01.jpg"), require("../assets/guitar-components/dbn02.jpg"), require("../assets/guitar-components/dbn03.jpg"),]

          },
          {
            prodId: "RC-DNB-02",
            name: "Dyed stabilized Brown Bone nu for LP Folk Classical Acoustic Guitar Bass",
            size1: "52mm x 9mm x 6mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn04.jpg"), require("../assets/guitar-components/dbn05.jpg"),]

          },
          {
            prodId: "RC-DNB-03",
            name: "Dyed stabilized Gray Bone nut is a great replacement parts for acoustic guitars",
            size1: "52mm x 6mm x 10mm(Approx)",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn06.jpg"), require("../assets/guitar-components/dbn07.jpg"),]

          },
          {
            prodId: "RC-DNB-04",
            name: "Dyed stabilized Gray Bone nut is a great replacement parts for acoustic guitars",
            size1: "52mm x 6mm x 10mm(Approx)",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn06.jpg"), require("../assets/guitar-components/dbn07.jpg"),]

          },
          {
            prodId: "RC-DNB-05",
            name: "Fossil Walrus Ivory Look like,Stabilized Camel bone Stabilized Bone Nut Blank for Dobro",
            size1: "53.98mm x 19.05mm x 4.76mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn011.jpg"), require("../assets/guitar-components/dbn012.jpg"),]

          },
          {
            prodId: "RC-DNB-06",
            name: "Fossil Walrus Ivory Look like,Stabilized Camel bone Stabilized Gibson Guitar,Will fit Gibson,Taylor, Santa Cruz",
            size1: "235+mm X .420mm X 2.0mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn013.jpg"), require("../assets/guitar-components/dbn013.jpg"),]
          },
          {
            prodId: "RC-DNB-07",
            name: "Dyed Bone Brown Nut Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn014.jpg"), require("../assets/guitar-components/dbn015.jpg"),]

          },
          {
            prodId: "RC-DNB-08",
            name: "Dyed Bone Nut Light Red",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn016.jpg"), require("../assets/guitar-components/dbn017.jpg"),]

          },
          {
            prodId: "RC-DNB-09",
            name: "Dyed Bone Nut Ivory Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/dbn018.jpg"), require("../assets/guitar-components/dbn019.jpg"),]

          },
        ],
      },
      {
        id: 2,
        img: require("../assets/guitar-components/vintagbonnut1.jpg"),
        title: "Vintage Bone Nut Blank (Unbleached Bone)",
        usbData: [
          {
            prodId: "RC-VBN-01",
            name: "Fender Nut Blank (Unbleached Bone)",
            size1: "51 x b10 x 3.20mm",
            size2: " 1/8″ x .375 x 2″",
            images: [require("../assets/guitar-components/rc31.jpg"), require("../assets/guitar-components/rc32.jpg"), require("../assets/guitar-components/rc33.jpg"), require("../assets/guitar-components/rc34.jpg"),]

          },
          {
            prodId: "RC-VBN-02",
            name: "Small Standard Bone Nut Blank (Unbleached Bone)",
            size1: "55 x 12 x 5.70mm",
            size2: "2.2″ x  .470″ x 0.225",
            images: [require("../assets/guitar-components/rc35.jpg"), require("../assets/guitar-components/rc36.jpg"),]

          },
          {
            prodId: "RC-VBN-03",
            name: "Large Bone Nut Blank For Guitar Or Basses (Unbleached Bone)",
            size1: "55 x 12 x 5.70mm",
            size2: "2.2″ x .470″ x .225″",
            images: [require("../assets/guitar-components/rc37.jpg"), require("../assets/guitar-components/rc38.jpg"),]

          },
          {
            prodId: "RC-VBN-04",
            name: "Bone Nut Blank (Unbleached Bone)",
            size1: "51 x 10 x 3.5mm",
            size2: "2″ x .4″ x 1.4″",
            images: [require("../assets/guitar-components/rc39.jpg"), require("../assets/guitar-components/rc39.jpg"),]
          },
          {
            prodId: "RC-VBN-05",
            name: "Bone Guitar Nut Blank (Regular Size Nut Blank) (Unbleached Bone)",
            size1: "54 x 9 x 6.35mm ",
            size2: "11/32″ x 1/4″ x 2.1/8″",
            images: [require("../assets/guitar-components/rc40.jpg"), require("../assets/guitar-components/rc40.jpg"),]
          },
          {
            prodId: "RC-VBN-06",
            name: "Extra Tall Bone Dorro Nut Blank (Unbleached Bone)",
            size1: "58 x 22 x 5.80mm ",
            size2: "7/8 x 15/64″ z 21/4″",
            images: [require("../assets/guitar-components/rc41.jpg"), require("../assets/guitar-components/rc41.jpg"),]
          },
          {
            prodId: "RC-VBN-07",
            name: "Bone Nut Corian (Unbleached Bone)",
            size1: "56 x 10.3 x 6.3mm",
            size2: "2.1/4″ x 13/32″ x 1/4″",
            images: [require("../assets/guitar-components/rc42.jpg"), require("../assets/guitar-components/rc42.jpg"),]
          },
          {
            prodId: "RC-VBN-08",
            name: "Bone Nut Blank (Unbleached Bone)",
            size1: "6.5 x 12 x 6.30mm",
            size2: "29/16″ x 15/32″ x 1/4″",
            images: [require("../assets/guitar-components/rc43.jpg"), require("../assets/guitar-components/rc43.jpg"),]
          },
          {
            prodId: "RC-VBN-09",
            name: "Bone Nut Blank (Unbleached Bone)",
            size1: "55 x 8.7 x 6.3mm",
            size2: "2.3/16″ x 1/4″ x 11/32″",
            images: [require("../assets/guitar-components/rc44.jpg"), require("../assets/guitar-components/rc44.jpg"),]
          },
          {
            prodId: "RC-VBN-10",
            name: "Nut Blank Bone (Unbleached Bone)",
            size1: "90 x 12 x 8mm",
            size2: "31/2″ x 1/2″ x 5/10″",
            images: [require("../assets/guitar-components/rc45.jpg"), require("../assets/guitar-components/rc45.jpg"),]
          },
          {
            prodId: "RC-VBN-11",
            name: "Fender Style Nut (Unbleached)",
            size1: "All size Available",
            size2: "All size Available",
            images: [require("../assets/guitar-components/rc46.jpg"), require("../assets/guitar-components/rc46.jpg"),]
          },
        ],
      },
      {
        id: 3,
        img: require("../assets/guitar-components/boneshapednut1.jpg"),
        title: "Bone Shaped & Slotted Nut",
        usbData: [
          {
            prodId: "RC-BSS-01",
            name: "Bone Shaped & Slotted Nut",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/boneshapednut1.jpg"), require("../assets/guitar-components/boneshapednut1.jpg")]
          },
        ],
      },

    ],
  },
  // Bone Saddle product All Data
  {
    head: "Guitar Bone Saddle",
    headslug: "bone-saddle",
    dec: "Enhance your guitar's resonance with our premium bone saddles crafted from ethically sourced animal bones. Our skilled artisans meticulously shape each saddle to optimize tone and sustain, delivering a warm, rich sound. Whether crafted from camel bones or buffalo horns, each saddle is precision-made to perfectly complement your instrument. Experience enhanced harmonic richness and playability with our eco-friendly bone saddles, designed to elevate your music and inspire creativity.",
    mainData: [
      {
        id: 4,
        img: require("../assets/guitar-components/wsb1.jpg"),
        title: "White Bone Saddle Blank",
        usbData: [
          {
            prodId: "RC-WSB-01",
            name: "White Bleched bone Steel String & Classical Guitar Bone Saddle",
            size1: "85mm x 10.0mm x 2.5mm",
            size2: "3.34″ x 0.393″ x 0.098",
            images: [require("../assets/guitar-components/wsb1.jpg"), require("../assets/guitar-components/wsb1.jpg"),]
          },
          {
            prodId: "RC-WSB-02",
            name: "Bridge Saddle For Guitar Extra Long (Bleached Bone)",
            size1: "10.2 x 11.9 x 2.40mm",
            size2: "4″ x 3/32″ x 15/32″",
            images: [require("../assets/guitar-components/wsb4.jpg"),]
          },
          {
            prodId: "RC-WSB-03",
            name: "Bridge Saddle F0r Classical Guitar (Bleached Bone)",
            size1: "81 x 9.5 x 2.5mm",
            size2: "3.3/16″ x 3/32″ x 3/8″",
            images: [require("../assets/guitar-components/wsb7.jpg"), require("../assets/guitar-components/wsb7.jpg"),]
          },
          {
            prodId: "RC-WSB-04",
            name: "Large Bone Acoustic Saddle Blank (Bleached Bone)",
            size1: "108 x 12.6 x 3.5mm",
            size2: "41/4″ x 1/2″ x 9/64″",
            images: [require("../assets/guitar-components/wsb8.jpg"),]
          },
          {
            prodId: "RC-WSB-05",
            name: "Bone Acoustic Guitar Saddle Blank (Bleached Bone)",
            size1: "90 x 11 x 3.5mm ",
            size2: "31/2″ x 7/16″ x 1/8″",
            images: [require("../assets/guitar-components/wsb9.jpg"),]
          },
          {
            prodId: "RC-WSB-06",
            name: "3/32 Martin Saddle Blank (Bleached Bone)",
            size1: "108 x 12 x 2.40mm",
            size2: "3/32″ x .470″ x 4.25″",
            images: [require("../assets/guitar-components/wsb10.jpg"),]
          },
          {
            prodId: "RC-WSB-07",
            name: "Bone Saddle Blank ( Bleached Bone)",
            size1: "3.20 x 11.90 x 108mm",
            size2: "1/8″ x .470″ x 4.25″",
            images: [require("../assets/guitar-components/wsb11.jpg"),]
          },
          {
            prodId: "RC-WSB-08",
            name: "PRS- Size Bone Saddle Blank (Large Size White Bone Black) (Bleached Bone)",
            size1: "90 x 12.70  x 4.30mm",
            size2: ".170″ x .500″ x 3.5″",
            images: [require("../assets/guitar-components/wsb12.jpg"),]
          },
          {
            prodId: "RC-WSB-09",
            name: "Enoch Large Bone Guitar Saddle (Bleached Bone)",
            size1: "107 x 16.5 x 4mm",
            size2: "160″ x .650″ x 4.25″",
            images: [require("../assets/guitar-components/wsb13.jpg"),]
          },
          {
            prodId: "RC-WSB-10",
            name: "Colossal Bone Large Guitar Saddle (Bleached Bone)",
            size1: "90 x 16.25 x 7.65mm",
            size2: ".300″ x .650″ x 3.50″",
            images: [require("../assets/guitar-components/wsb14.jpg"),]
          },
          {
            prodId: "RC-WSB-11",
            name: "Tall Bone Guitar Saddle Blank (Bleached Bone)",
            size1: "83 x 12.70 x 3.24mm",
            size2: "1/2″ x 1/8″ x 3-1/4″",
            images: [require("../assets/guitar-components/wsb15.jpg"),]
          },
          {
            prodId: "RC-WSB-12",
            name: "Guitar Bone Saddle Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/guitarsaddleblank00001.jpg")]
          },
          {
            prodId: "RC-WSB-13",
            name: "Guitar Saddle for Blueridge Guitar",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ghs3.png")]
          },
        ],
      },
      {
        id: 5,
        img: require("../assets/guitar-components/dyedbonesaddle1.jpg"),
        title: "Dyed Bone Saddle Blank",
        usbData: [
          {
            prodId: "DB-LRS-01",
            name: "Dyed Bone Light Right Saddles",
            size1: "All Kind of Size Available",
            size2: "All Kind of Size Available",
            images: [require("../assets/guitar-components/lrs1.jpg"),]
          },
          {
            prodId: "DB-LRS-02",
            name: "Dyed Bone Saddles Brown",
            size1: "All Kind of Size Available",
            size2: "All Kind of Size Available",
            images: [require("../assets/guitar-components/lrs2.jpg"),]
          },
          {
            prodId: "DB-LRS-03",
            name: "Dyed Bone Saddles Warlus",
            size1: "All Kind of Size Available",
            size2: "All Kind of Size Available",
            images: [require("../assets/guitar-components/lrs3.jpg"),]
          },
        ],
      },
      {
        id: 6,
        img: require("../assets/guitar-components/vsb5.jpg"),
        title: "Vintage Bone Saddle Blank",
        usbData: [
          {
            prodId: "RC-VSB-01",
            name: "Large Bone Acoustic Saddle Blank (Unbleached Bone)",
            size1: " 108 x 12.6 x 3.5mm ",
            size2: "41/4″ x 1/2″ x 9/64″",
            images: [require("../assets/guitar-components/vsb1.jpg"),]
          },
          {
            prodId: "RC-VSB-02",
            name: "Bone Acoustic Guitar Saddle Blank (Unbleached Bone)",
            size1: " 90 x 11 x 3.5mm",
            size2: ".31/2″ x 7/16″ x 1/8″",
            images: [require("../assets/guitar-components/vsb2.jpg"),]
          },
          {
            prodId: "RC-VSB-03",
            name: "3/32 Martin Saddle Bone Blank (Unbleached Bone)",
            size1: "108 x 12 x 2.40mm",
            size2: ".3/32″ x .470 x 4.25″",
            images: [require("../assets/guitar-components/vsb3.jpg"),]
          },
          {
            prodId: "RC-VSB-04",
            name: "Bone Saddle Blank (Unbleached Bone)",
            size1: "3.20 x 11.90 x 10.8mm",
            size2: "1/8″ x .470″ x 4.25″",
            images: [require("../assets/guitar-components/vsb4.jpg"),]
          },
          {
            prodId: "RC-VSB-05",
            name: "PRS – Size Bone Saddle Blank (Large Size Bone Blank) (Unbleached Bone)",
            size1: "90 x 12.70 x 4.30mm",
            size2: ".170″ x .500″ x 3.5″",
            images: [require("../assets/guitar-components/vsb5.jpg"),]
          },
          {
            prodId: "RC-VSB-06",
            name: "Colossal Bone Large Guitar Saddle (Unbleached Bone)",
            size1: "90 x 16.25 x 7.65mm",
            size2: ".300″ x .650″ x 3.50″",
            images: [require("../assets/guitar-components/vsb6.jpg"),]
          },
          {
            prodId: "RC-VSB-07",
            name: "Over Size Saddle Blank (Unbleached Bone)",
            size1: "127 x 12.5 x 12.5mm",
            size2: "1/2″ x 1/2″ 5″",
            images: [require("../assets/guitar-components/vsb7.jpg"),]
          },
          {
            prodId: "RC-VSB-08",
            name: "Tall Bone Guitar Saddle Blank (Unbleached Bone)",
            size1: "83 x 12.70 x 3.24mm ",
            size2: "1/2″ x 1/8″ x 3-1/4″",
            images: [require("../assets/guitar-components/vsb8.jpg"),]
          },
          {
            prodId: "RC-VSB-09",
            name: "Bridge Saddle For Classical Guitar (Unbleached Bone)",
            size1: " 81 x 9.5 x 12.5mm ",
            size2: "3.3/16″ x 3/32″ x 3/8″",
            images: [require("../assets/guitar-components/vsb9.jpg"),]
          },
          {
            prodId: "RC-VSB-10",
            name: "Bridge Saddle For Guitar Extra Long (Unbleached Bone)",
            size1: "102 x 11.9 x 2.40mm ",
            size2: "4″ x 3/32″ x 15/32″",
            images: [require("../assets/guitar-components/vsb10.jpg"),]
          },
        ],
      },
      {
        id: 7,
        img: require("../assets/guitar-components/hornsaddle44.jpeg"),
        title: "Bone Shaped & Slotted Nut",
        usbData: [
          {
            prodId: "RC-BSS-01",
            name: "Bone Shaped & Slotted Nut",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/boneshapednut1.jpg")]
          },
        ],
      },
    ],
  },
  // Bridge Pin & Bridge Pin Blank product All Data
  {
    head: "Guitar Bridge Pin & Bridge Pin Blank",
    headslug: "bridge-pin",
    dec: "Elevate your guitar's tone with our premium animal bone bridge pins and blanks, crafted from ethically sourced materials. Our skilled artisans carefully shape each pin and blank to optimize resonance and sustain, delivering a rich, warm sound. Whether crafted from camel bones, buffalo horns, or fossilized ivory, each piece is precision-made to perfectly complement your instrument. Experience enhanced harmonic richness and playability with our eco-friendly animal bone bridge pins and blanks, designed to elevate your music and inspire creativity.",
    mainData: [
      {
        id: 8,
        img: require("../assets/guitar-components/bp5.jpg"),
        title: "Bridge Pin",
        usbData: [
          {
            prodId: "BP-001",
            name: "Bridge Pin Bone With Ablone Eye",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bp1.jpg"), require("../assets/guitar-components/bp51.jpg")]
          },
          {
            prodId: "BP-002",
            name: "Bone Bridge Pin Palin",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bp2.jpg")]
          },
          {
            prodId: "BP-003",
            name: "Bone Bridge Pin Mop Dot Eye",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bp3.jpg")]
          },
          {
            prodId: "BP-004",
            name: "Rose Wood Palin Bridge Pin",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bp4.jpg"), require("../assets/guitar-components/bp41.jpg"), require("../assets/guitar-components/bp42.jpg")]
          },
          {
            prodId: "BP-005",
            name: "Acoustic Bone Bridge ",
            size1: "Pin -3 Mm Abalone Dot .215",
            size2: "(5.46mm) 5degrèe Taper",
            images: [require("../assets/guitar-components/bp0005.jpg"), require("../assets/guitar-components/bp52.jpg"), require("../assets/guitar-components/bp53.jpg")]
          },
          {
            prodId: "BP-006",
            name: "MOP Dot Buffalo Horn Bridge",
            size1: "Pin -3mm .203",
            size2: "(5.15mm) 3degrèe Taper",
            images: [require("../assets/guitar-components/bp6.jpg"), require("../assets/guitar-components/bp61.jpg"), require("../assets/guitar-components/bp62.jpg")]
          },
          {
            prodId: "BP-007",
            name: "MOP Dot Buffalo Horn Bridge",
            size1: "Pin -3mm .210",
            size2: "(5.33mm) -3degrèe Taper",
            images: [require("../assets/guitar-components/bp7.jpg"), require("../assets/guitar-components/bp71.jpg")]
          },
          {
            prodId: "BP-008",
            name: "Bone Bridge Pins Abalone Dot",
            size1: "Pin -3mm .210",
            size2: "(5.33mm) 3degrèe Taper",
            images: [require("../assets/guitar-components/bp8.jpg"), require("../assets/guitar-components/bp81.jpg"), require("../assets/guitar-components/bp82.jpg")]
          },
          {
            prodId: "BP-009",
            name: "Bone Bridge Pins Abalone Dot",
            size1: "Pin -3mm .203",
            size2: "(5.15mm) 3 Degree Taper",
            images: [require("../assets/guitar-components/bp9.jpg"), require("../assets/guitar-components/bp91.jpg")]
          },
          {
            prodId: "BP-0010",
            name: "Bone Bridge Pin With Abalone Dot",
            size1: "Pin -3mm .220",
            size2: "(5.58mm) 5 Degree Taper",
            images: [require("../assets/guitar-components/bp10.jpg"), require("../assets/guitar-components/bp101.jpg")]
          },
          {
            prodId: "BP-0011",
            name: "Guitar Bridge Pin",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gep2.webp"), require("../assets/guitar-components/gb002.jpg"), require("../assets/guitar-components/gp003.jpg")]
          },
          {
            prodId: "BP-0012",
            name: "Horn Bridge Pin Palin",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bp111.jpg"), require("../assets/guitar-components/bp121.jpg")]
          },
          {
            prodId: "BP-0013",
            name: "Horn Bridge Pin Abalone Dot",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/hbpa1.jpg"), require("../assets/guitar-components/hbpw1.jpg")]
          },

          {
            prodId: "BP-0014",
            name: "Ebony Wood Bridge Pin With Diamond Cut Stone Eye",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bp72.jpg")]
          },
          {
            prodId: "BP-0015",
            name: "Guitar Bridge Pin Brass",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gbbrass1.jpg"), require("../assets/guitar-components/gbbrass2.jpg")]
          },
          {
            prodId: "BP-0016",
            name: "Rose Wood Bridge Pin MOB Dot",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/rosepinn1.jpg")]
          },
        ],
      },
      {
        id: 9,
        img: require("../assets/guitar-components/bpb2.jpg"),
        title: "Bridge Pin Blank",
        usbData: [
          {
            prodId: "BPB-001",
            name: "Red Wood Bridge Pin Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb1.jpg"),]
          },
          {
            prodId: "BPB-002",
            name: "White bone bridge pin blank bleached",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb2.jpg"),]
          },
          {
            prodId: "BPB-003",
            name: "Dyed Bone Light Amber Bridge Pin Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb3.jpg"),]
          },
          {
            prodId: "BPB-004",
            name: "Dyed Bone Bridge Pin Blank Solid Dark Blue",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb4.jpg"),]
          },
          {
            prodId: "BPB-005",
            name: "Wulnut Wood Bridge Pin Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb5.jpg"),]
          },
          {
            prodId: "BPB-006",
            name: "Ox Horn Natural Blond Bridge Pin Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb6.jpg"),]
          },
          {
            prodId: "BPB-007",
            name: "Blood Wood Bridge Pin Blank",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb7.jpg"),]
          },
          {
            prodId: "BPB-008",
            name: "Dyed Bone Bridge Pin Blank Black",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/bpb8.jpg"),]
          },

        ],
      },
      {
        id: 10,
        img: require("../assets/guitar-components/gep1.jpg"),
        title: "Guitar End Pin",
        usbData: [
          {
            prodId: "GEP-001",
            name: "Bone Natural",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gep1.jpg"), require("../assets/guitar-components/gep3.jpg"), require("../assets/guitar-components/gep4.jpg")]
          },
        ],
      },

    ]
  },
  // Guitar Inlay & Guitar Inlay Bids Both page data single
  {
    head: "Guitar Inlay, Guitar Inlay Bids and Guitar Slides",
    headslug: "guitar-inlay-slides",
    dec: "Transform your guitar's sound with our premium Guitar animals Inlay, crafted from sustainably sourced materials. Our skilled artisans carefully design each inlay to optimize resonance and sustain, delivering a rich, vibrant tone. Whether crafted from intricate animal designs, exotic woods, or precious stones, each piece is precision-made to perfectly complement your instrument. Experience enhanced playability and sonic richness with our eco-friendly Guitar animals Inlay, designed to elevate your music and inspire creativity.",
    mainData: [
      {
        id: 12,
        img: require("../assets/guitar-components/gi1.jpg"),
        title: "Guitar Inlay",
        usbData: [
          {
            prodId: "RC-GI-01",
            name: "Green Abalone Dots Iridescentround Inlay For Fretboard Position Markers",
            size1: "4mm, 5mm, 6mm, 6.35mm, (1/4″), 7mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gi1.jpg")]
          },
          {
            prodId: "RC-GI-02",
            name: "MOP Shell Pearl Golden Yellow Inlay Dots Guitar Fingerboard Luthier",
            size1: "4mm, 5mm, 6mm, 6.35mm, (1/4″), 7mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gi2.jpg")]
          },
          {
            prodId: "RC-GI-03",
            name: "Inlay Sticker Fret Markers for Guitars & Bass- Planets, F-022PL",
            size1: "(228 x 105 x 3 mm)",
            size2: "8.98″ x 4.13″ x 0.12″ ",
            images: [require("../assets/guitar-components/gi3.jpg")]
          },
        ],
      },
      {
        id: 13,
        img: require("../assets/guitar-components/gib1.jpg"),
        title: "Guitar Inlay Bids",
        usbData: [
          {
            prodId: "RC-GIB-01",
            name: "Abalone Shell Guitar Inlay Fingerboard Dots",
            size1: "4mm, 5mm, 6mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gib1.jpg")]
          },
          {
            prodId: "RC-GIB-02",
            name: "Pearl Shell Inlay Dots for Guitar Bass Ukulele Banjo",
            size1: "3mm, 4mm, 6mm, 6.35mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gib2.jpg")]
          },
          {
            prodId: "RC-GIB-03",
            name: "Pearl Guitar Fretboard Inlay Dots, White Pearl",
            size1: "4x2mm, 5x2mm, 6x2mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gib3.jpg")]
          },
        ],
      },
      {
        id: 14,
        img: require("../assets/guitar-components/g1111.png"),
        title: "Guitar Slides",
        usbData: [
          {
            prodId: "RC-GS-01",
            name: "The ″T- Bone″ Solid Cow Bone Guitar Slide",
            size1: "27/16 (62mm)",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gs1.jpg")]
          },
          {
            prodId: "RC-GS-02",
            name: "The Redbone Hound Solid Bone Slide for Cigar Box",
            size1: "21/2 (63.5mm)",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gs21.jpg")]
          },
          {
            prodId: "RC-GS-03",
            name: "Wood guitar slides hand made",
            size1: "All size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/gs3.jpeg")]
          },
        ],
      },
    ]
  },
  //  Horn Nut , Horn Pics, Horn Saddle both page data single
  {
    head: "Guitar Horn Nut, Horn Pics and Horn Saddle",
    headslug: 'guitar-horn-nut-saddle-pics',
    dec: "Elevate your guitar's sound with our premium guitar horn nut, crafted from sustainably sourced materials. Our skilled artisans carefully design each component to optimize resonance and sustain, delivering a rich, vibrant tone. Whether crafted from intricate designs, exotic woods, or precious stones, each piece is precision-made to perfectly complement your instrument. ",
    mainData: [
      {
        id: 15,
        img: require("../assets/guitar-components/ghn1.jpg"),
        title: "Guitar Horn Nut",
        usbData: [
          {
            prodId: "RC-GHN-01",
            name: "Buffalo Horn Nut (Black Buffalo Horn)",
            size1: "(6.4 mm X 12 mm X 55mm)",
            size2: "1/4  X .470 X 2.2 ",
            images: [require("../assets/guitar-components/ghn1.jpg")]
          },
          {
            prodId: "RC-GHN-02",
            name: "Buffalo Horn Nut Blank JUMBO",
            size1: "(8.9mm X 17.7mm X 114 mm)",
            size2: ".350 X .70 X 4.5",
            images: [require("../assets/guitar-components/ghn2.jpg")]
          },
        ],
      },
      {
        id: 16,
        img: require("../assets/guitar-components/ghn3.jpg"),
        title: "Guitar Horn Saddle",
        usbData: [
          {
            prodId: "RC-GHS-01",
            name: "Guitar Bone & Horn Saddles",
            size1: "55 X 10 X 6mm",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ghs1.webp")]
          },
          {
            prodId: "RC-GHS-02",
            name: "Buffalo Horn Guitar Saddle Blanks",
            size1: " (8.9mm X 17.7mm X 114 mm)",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ghn3.jpg")]
          },
        ],
      },
      {
        id: 17,
        img: require("../assets/guitar-components/ghp11.jpg"),
        title: "Guitar Bone, Wood & Horn Pics",
        usbData: [
          {
            prodId: "RC-GBP-01",
            name: "Guitar Bone Pics White",
            size1: "All kind of size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ghp1.jpg")]
          },
          {
            prodId: "RC-GWP-02",
            name: "Guitar Wood Pics Brown",
            size1: "All kind of size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ghp2.jpg")]
          },
          {
            prodId: "RC-GHP-03",
            name: "Guitar Horn Pics Transparent",
            size1: "All kind of size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ghp3.jpg")]
          },
        ],
      },

    ],
  },
  // Camle Bone Knife Handle 
  {
    head: "Camel Bone Knife Handle",
    headslug: 'camel-bone-knife-handle',
    dec: "Elevate your guitar's sound with our premium guitar horn nut, crafted from sustainably sourced materials. Our skilled artisans carefully design each component to optimize resonance and sustain, delivering a rich, vibrant tone. Whether crafted from intricate designs, exotic woods, or precious stones, each piece is precision-made to perfectly complement your instrument. ",
    mainData: [
      {
        id: 18,
        img: require("../assets/guitar-components/cws2.jpg"),
        title: "White Smooth Radius Bone",
        wsize: ["1/4″x1-1/2″x5″ – (127x38x6.35mm)", "1/4″x1-3/8″x4-1/2″ – (115x35x6.35mm)", "1/4″x1-1/4″x4-1/2″- (115x32x6.35mm)", "3/16″x1-1/4″x4-1/4″- (108x32x5mm)", "3/16″x1-1/4″x3-1/2″ – (90x32x5mm)", "3/16″x1″x3-1/2″ – (90x26x5mm)", "3/16″x1-1/2″x5″ – (127x38x5mm)", "3/16″x1-1/4″x4-1/2″ – (115x32x5mm)", "3/16″x11/8″x4″ – (102x29x5mm)", "3/16″x1″x3.5″ – (90x26x5mm)", "3/16″x1″x3″ – (76x26x5mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CSB-01",
            name: "White Smooth Radius Bone​",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/cws1.jpg"), require("../assets/guitar-components/cws2.jpg"), require("../assets/guitar-components/cws3.jpg")],
          },
          {
            prodId: "RC-CSB-02",
            name: "White Smooth Top Flat",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/cws4.jpg"), require("../assets/guitar-components/cws5.jpg"), require("../assets/guitar-components/cws6.jpg")],
          },
        ],
      },
      {
        id: 19,
        img: require("../assets/guitar-components/dss5.jpg"),
        title: "Dyed Stabilized Bone Scales",
        wsize: ["1/4″x1 1/2″x5″ (127 x 38 x 6.50mm)", "1/4” X1-1/4” X 5” (127 x 32 x 6.50mm)", "1/4” X1-3/8”X 4-1/2” (115 X 35 X6.50mm)", "1/4” X 1-1/4” X 4-1/2” (115 x 32 x 6.50mm)", "1/4”x 1-1/4”x 4-1/4” (108 x 32 x 6.50 mm)", "3/16” x 1-1/4” x 4-1-/8” (105 x 32 x 4.75 mm)", "3/16”x 1” x 3-1/2” (90 x 26 x 4.75 mm)", "More Sizes Available As per requirement"],

        usbData: [
          {
            prodId: "DSB-RC-01",
            name: "Dyed Denim Blue Bone scale",
            size1: " India",
            size2: "100% camel bone made scales",
            images: [require("../assets/guitar-components/dss1.jpg"), require("../assets/guitar-components/dss2.jpg"), require("../assets/guitar-components/dss3.jpg")],
          },
          {
            prodId: "DSB-RC-02",
            name: "Dyed Ivory Color Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss4.jpg"), require("../assets/guitar-components/dss5.jpg"), require("../assets/guitar-components/dss6.jpg")],
          },
          {
            prodId: "DSB-RC-03",
            name: "Dyed Forest Green Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss7.jpg"), require("../assets/guitar-components/dss8.jpg"), require("../assets/guitar-components/dss9.jpg")],
          },
          {
            prodId: "DSB-RC-04",
            name: "Dyed Light Brown Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss10.jpg"), require("../assets/guitar-components/dss11.jpg"), require("../assets/guitar-components/dss12.jpg")],
          },
          {
            prodId: "DSB-RC-05",
            name: "Dyed Gray Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss13.jpg"), require("../assets/guitar-components/dss14.jpg"), require("../assets/guitar-components/dss15.jpg")],
          },
          {
            prodId: "DSB-RC-06",
            name: "Dyed Dark Brown Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss16.jpg"), require("../assets/guitar-components/dss17.jpg"), require("../assets/guitar-components/dss18.jpg")],
          },
          {
            prodId: "DSB-RC-07",
            name: "Dyed Funkey Brown Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss19.jpg"), require("../assets/guitar-components/dss20.jpg")],
          },
          {
            prodId: "DSB-RC-08",
            name: "Dyed Light Amber Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss21.jpg"), require("../assets/guitar-components/dss22.jpg")],
          },
          {
            prodId: "DSB-RC-09",
            name: "Dyed Hoof Brown Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss23.jpg"), require("../assets/guitar-components/dss24.jpg")],
          },
          {
            prodId: "DSB-RC-10",
            name: "Dyed Purple Blue Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss25.jpg"), require("../assets/guitar-components/dss26.jpg")],
          },
          {
            prodId: "DSB-RC-11",
            name: "Dyed Burnt Yellow Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss27.jpg"), require("../assets/guitar-components/dss28.jpg"), require("../assets/guitar-components/dss29.jpg")],
          },
          {
            prodId: "DSB-RC-12",
            name: "Dyed Brown Blue Shade Bone",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss30.jpg"), require("../assets/guitar-components/dss31.jpg")],
          },
          {
            prodId: "DSB-RC-13",
            name: "Dyed Hot Orange Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss32.jpg"), require("../assets/guitar-components/dss33.jpg"), require("../assets/guitar-components/dss34.jpg")],
          },
          {
            prodId: "DSB-RC-14",
            name: "Dyed Taoise bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss35.jpg"), require("../assets/guitar-components/dss36.jpg"), require("../assets/guitar-components/dss37.jpg")],
          },
          // {
          //   prodId: "DSB-RC-15",
          //   name: "Dyed Hot Pink With Purple Shades",
          //   size1: " India",
          //   size2: "100% Camel Bone Made Scales",
          //   images: [require("../assets/guitar-components/dss38.11.jpg")],
          // },
          {
            prodId: "DSB-RC-15",
            name: "Dyed Light Pink Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss39.1.jpg"), require("../assets/guitar-components/dss39.2.jpg")],
          },
          {
            prodId: "DSB-RC-16",
            name: "Dyed Light Green Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss40.1.jpg"), require("../assets/guitar-components/dss40.2.jpg")],
          },
          {
            prodId: "DSB-RC-17",
            name: "Dyed Burnt Brown Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss41.1.jpg"), require("../assets/guitar-components/dss41.2.jpg"), require("../assets/guitar-components/dss41.3.jpg")],
          },
          {
            prodId: "DSB-RC-18",
            name: "Dyed Burnt Khaki Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss42.1.jpg"), require("../assets/guitar-components/dss42.2.jpg")],
          },
          {
            prodId: "DSB-RC-19",
            name: "Dyed Hot Amber Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss43.1.jpg"), require("../assets/guitar-components/dss43.2.jpg"), require("../assets/guitar-components/dss43.3.jpg")],
          },
          {
            prodId: "DSB-RC-20",
            name: "Dyed Light Orange Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss44.1.jpg"), require("../assets/guitar-components/dss44.2.jpg"), require("../assets/guitar-components/dss44.3.jpg")],
          },
          {
            prodId: "DSB-RC-21",
            name: "Dyed Purple Haze Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss45.1.jpg"), require("../assets/guitar-components/dss45.2.jpg"), require("../assets/guitar-components/dss45.3.jpg")],
          },
          {
            prodId: "DSB-RC-22",
            name: "Dyed Ruby Red Bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss46.1.jpg"), require("../assets/guitar-components/dss46.2.jpg"), require("../assets/guitar-components/dss46.3.jpg")],
          },
          {
            prodId: "DSB-RC-23",
            name: "Dyed sky blue bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss47.1.jpg"), require("../assets/guitar-components/dss47.2.jpg")],
          },
          {
            prodId: "DSB-RC-24",
            name: " Dyed Matte Gray bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss48.1.jpg"), require("../assets/guitar-components/dss48.2.jpg")],
          },
          {
            prodId: "DSB-RC-25",
            name: "Dyed Matte Olivine bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss49.1.jpg"), require("../assets/guitar-components/dss49.2.jpg")],
          },
          {
            prodId: "DSB-RC-26",
            name: "Dyed Burnt Orange b0ne scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss50.1.jpg"), require("../assets/guitar-components/dss50.2.jpg"), require("../assets/guitar-components/dss50.3.jpg")],
          },
          {
            prodId: "DSB-RC-27",
            name: "Dyed light Matte Green bone scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss51.1.jpg"), require("../assets/guitar-components/dss51.2.jpg"), require("../assets/guitar-components/dss51.3.jpg")],
          },
          {
            prodId: "DSB-RC-28",
            name: "Dyed brown Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss52.1.jpg"), require("../assets/guitar-components/dss52.2.jpg"), require("../assets/guitar-components/dss52.3.jpg")],
          },
          {
            prodId: "DSB-RC-29",
            name: "Dyed Burnt Light Orange Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss53.1.jpg"), require("../assets/guitar-components/dss53.2.jpg"), require("../assets/guitar-components/dss53.3.jpg")],
          },
          {
            prodId: "DSB-RC-30",
            name: "Dyed Dark Orange Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss54.1.jpg"), require("../assets/guitar-components/dss54.2.jpg"), require("../assets/guitar-components/dss54.3.jpg")],
          },
          {
            prodId: "DSB-RC-31",
            name: "Dyed Dark Green Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss55.1.jpg"), require("../assets/guitar-components/dss55.2.jpg")],
          },
          {
            prodId: "DSB-RC-32",
            name: "Dyed Sapphire Blue Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss56.1.jpg"), require("../assets/guitar-components/dss56.2.jpg"), require("../assets/guitar-components/dss56.3.jpg")],
          },
          {
            prodId: "DSB-RC-33",
            name: "Dyed Matte Brown Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss57.1.jpg"), require("../assets/guitar-components/dss57.2.jpg")],
          },
          {
            prodId: "DSB-RC-34",
            name: "Dyed Dark Brown Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss58.1.jpg"), require("../assets/guitar-components/dss58.2.jpg"), require("../assets/guitar-components/dss58.3.jpg")],
          },
          {
            prodId: "DSB-RC-35",
            name: "Dyed Orange Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss59.1.jpg"), require("../assets/guitar-components/dss59.2.jpg"), require("../assets/guitar-components/dss59.3.jpg")],
          },
          {
            prodId: "DSB-RC-36",
            name: "Dyed Dark Pink Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss60.1.jpg"), require("../assets/guitar-components/dss60.2.jpg"), require("../assets/guitar-components/dss60.3.jpg")],
          },
          {
            prodId: "DSB-RC-37",
            name: "Dyed Forest Green Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss61.1.jpg"), require("../assets/guitar-components/dss61.2.jpg"), require("../assets/guitar-components/dss61.3.jpg")],
          },
          {
            prodId: "DSB-RC-38",
            name: "Dyed Coral Orange Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss62.1.jpg"), require("../assets/guitar-components/dss62.2.jpg")],
          },
          {
            prodId: "DSB-RC-39",
            name: "Dyed Flamingo Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss63.1.jpg"), require("../assets/guitar-components/dss63.2.jpg")],
          },
          {
            prodId: "DSB-RC-40",
            name: "Dyed Dark Grey Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss64.jpg")],
          },
          {
            prodId: "DSB-RC-41",
            name: "Dyed Light Purple Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss65.1.jpg"), require("../assets/guitar-components/dss65.2.jpg"), require("../assets/guitar-components/dss65.3.jpg")],
          },
          {
            prodId: "DSB-RC-42",
            name: "Dyed Light Pink Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss66.1.jpg"), require("../assets/guitar-components/dss66.2.jpg"), require("../assets/guitar-components/dss66.3.jpg")],
          },
          {
            prodId: "DSB-RC-43",
            name: "Dyed Pink Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss67.jpg")],
          },
          {
            prodId: "DSB-RC-44",
            name: "Dyed Orange Bone Scale",
            size1: " India",
            size2: "100% Camel Bone Made Scales",
            images: [require("../assets/guitar-components/dss68.jpg")],
          },
        ],
      },
      {
        id: 20,
        img: require("../assets/guitar-components/djb0.jpg"),
        title: "Dyed Jigged Bone",
        wsize: ["1/4″x1 1/2″x5″ (127 x 38 x 6.50 mm)", "1/4” X1-1/4” X 5” (127 x 32 x 6.50 mm)", "1/4” X1-3/8”X 4-1/2” (115 X 35 X6.50 mm)", "1/4” X 1-1/4” X 4-1/2” (115 x 32 x 6.50mm)", "1/4”x 1-1/4”x 4-1/4” (108 x 32 x 6.50 mm)", "3/16” x 1-1/4” x 4-1-/8” (105 x 32 x 4.75 mm)", "3/16”x 1” x 3-1/2” (90 x 26 x 4.75 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "DJB-RC-01",
            name: "Dyed Pick Jigged Bone Red",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb1.jpg"), require("../assets/guitar-components/djb2.jpg"), require("../assets/guitar-components/djb3.jpg")],
          },
          {
            prodId: "DJB-RC-02",
            name: "Dyed Impala Jigged Antiques",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb4.jpg"), require("../assets/guitar-components/djb5.jpg"), require("../assets/guitar-components/djb6.jpg")],
          },
          {
            prodId: "DJB-RC-03",
            name: "Dyed Pick Jigged MFH Room",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb7.jpg"), require("../assets/guitar-components/djb8.jpg"), require("../assets/guitar-components/djb9.jpg")],
          },
          {
            prodId: "DJB-RC-04",
            name: "Stag Grooved Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb10.jpg"), require("../assets/guitar-components/djb11.jpg"), require("../assets/guitar-components/djb12.jpg")],
          },
          {
            prodId: "DJB-RC-05",
            name: "Antique Stag Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb13.jpg"), require("../assets/guitar-components/djb14.jpg"), require("../assets/guitar-components/djb15.jpg")],
          },
          {
            prodId: "DJB-RC-06",
            name: "Dyed Winter Ruby Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb18.jpg"), require("../assets/guitar-components/djb19.jpg")],
          },
          {
            prodId: "DJB-RC-07",
            name: "Dyed Red Spot Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb27.jpg"), require("../assets/guitar-components/djb28.jpg"), require("../assets/guitar-components/djb29.jpg")],
          },
          {
            prodId: "DJB-RC-08",
            name: "Dyed Red Big Spot Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb35.jpg"), require("../assets/guitar-components/djb36.jpg"), require("../assets/guitar-components/djb37.jpg")],
          },
          {
            prodId: "DJB-RC-09",
            name: "Dyed Green Little Grooved Jigged",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb16.jpg"), require("../assets/guitar-components/djb17.jpg")],
          },
          {
            prodId: "DJB-RC-10",
            name: "Dyed Impala Grooved Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb20.jpg"), require("../assets/guitar-components/djb21.jpg"), require("../assets/guitar-components/djb22.jpg")],
          },
          {
            prodId: "DJB-RC-11",
            name: "Dyed Winter Bottom Jigged Bone Turquoise",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb23.jpg"), require("../assets/guitar-components/djb24.jpg")],
          },
          {
            prodId: "DJB-RC-12",
            name: "Dyed Green Turquoise Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb225.jpg"), require("../assets/guitar-components/djb26.jpg")],
          },
          {
            prodId: "DJB-RC-13",
            name: "Dyed Pink Impala Grooved Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb30.jpg"), require("../assets/guitar-components/djb31.jpg"), require("../assets/guitar-components/djb32.jpg")],
          },
          {
            prodId: "DJB-RC-14",
            name: "Dyed Green Large Pick Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb33.jpg"), require("../assets/guitar-components/djb34.jpg")],
          },
          {
            prodId: "DJB-RC-15",
            name: "dyed amber saw cut jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb38.1.jpg"), require("../assets/guitar-components/djb38.2.jpg"), require("../assets/guitar-components/djb38.3.jpg")]
          },
          {
            prodId: "DJB-RC-16",
            name: "dyed amber antler jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb39.1.jpg"), require("../assets/guitar-components/djb39.2.jpg")]
          },
          {
            prodId: "DJB-RC-17",
            name: "dyed impala pink jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb40.1.jpg"), require("../assets/guitar-components/djb40.2.jpg")]
          },
          {
            prodId: "DJB-RC-18",
            name: "dyed antiques grooved jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb41.1.jpg"), require("../assets/guitar-components/djb41.2.jpg")]
          },
          {
            prodId: "DJB-RC-19",
            name: "amber grooved jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb42.1.jpg"), require("../assets/guitar-components/djb42.2.jpg")]
          },
          {
            prodId: "DJB-RC-20",
            name: "dyed green antler jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb43.1.jpg"), require("../assets/guitar-components/djb43.2.jpg")]
          },
          {
            prodId: "DJB-RC-21",
            name: "dyed red lope jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb44.jpg")]
          },
          {
            prodId: "DJB-RC-22",
            name: "dyed pick jigged green jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb45.1.jpg"), require("../assets/guitar-components/djb45.2.jpg")]
          },
          {
            prodId: "DJB-RC-23",
            name: "amber stag bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb46.1.jpg"), require("../assets/guitar-components/djb46.2.jpg"), require("../assets/guitar-components/djb46.3.jpg")]
          },
          {
            prodId: "DJB-RC-24",
            name: "amber pick jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb47.1.jpg"), require("../assets/guitar-components/djb47.2.jpg"), require("../assets/guitar-components/djb47.3.jpg")]
          },
          {
            prodId: "DJB-RC-25",
            name: "red pick jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb48.1.jpg"), require("../assets/guitar-components/djb48.2.jpg")]
          },
          {
            prodId: "DJB-RC-26",
            name: "grooved jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb49.1.jpg"), require("../assets/guitar-components/djb49.2.jpg")]
          },
          {
            prodId: "DJB-RC-27",
            name: "amber s-stag bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb50.1.jpg"), require("../assets/guitar-components/djb50.2.jpg"), require("../assets/guitar-components/djb50.3.jpg")]
          },
          {
            prodId: "DJB-RC-28",
            name: "natural winter bottom jigged bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb51.1.jpg"), require("../assets/guitar-components/djb51.2.jpg")]
          },
          {
            prodId: "DJB-RC-29",
            name: "yellow amber stag bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb52.1.jpg"), require("../assets/guitar-components/djb52.2.jpg"), require("../assets/guitar-components/djb52.3.jpg")]
          },
          {
            prodId: "DJB-RC-30",
            name: "Camel Bone Pick Jigged Brown",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb53.jpg")]
          },
          {
            prodId: "DJB-RC-31",
            name: "Camel Bone Burnt Impala Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb54.1.jpg"), require("../assets/guitar-components/djb54.2.jpg"), require("../assets/guitar-components/djb54.3.jpg"), require("../assets/guitar-components/djb54.4.jpg")]
          },
          {
            prodId: "DJB-RC-32",
            name: "Stag Bone Jigged Natural",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/djb55.1.jpg"), require("../assets/guitar-components/djb55.2.jpg"), require("../assets/guitar-components/djb55.3.jpg"), require("../assets/guitar-components/djb55.4.jpg")]
          },
        ],
      },
      {
        id: 21,
        img: require("../assets/guitar-components/dsbg0.jpg"),
        title: "Extra Large Bone",
        wsize: ["1/4″x1-1/2″x6″ – (150x38x6.5mm)", "3/8″x1-1/2″x5″ – (127x38x10mm)", "1/4″x1-1/2″x5″ – (127x38x6.5mm)", "Approximate length: 5 – 6 inches", "Approximate width: 1.5 inches", " Approximate thickness: 3/8 inch", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "ELB-RBSW-01",
            name: "Radius-Bone Smooth White",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb1.jpg"), require("../assets/guitar-components/elb11.jpg"), require("../assets/guitar-components/elb111.jpg")],
          },
          {
            prodId: "ELB-RBSW-02",
            name: "Radius-Bone Smooth Polished",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb2.jpg"), require("../assets/guitar-components/elb22.jpg")],
          },
          {
            prodId: "ELB-RBSW-03",
            name: "Dyed Smooth Bone Brunt Yellow",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb3.jpg"), require("../assets/guitar-components/elb33.jpg")],
          },
          {
            prodId: "ELB-RBSW-04",
            name: "Dyed Natural- Brunt Amber Snake Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb4.jpg"), require("../assets/guitar-components/elb44.jpg")],
          },
          {
            prodId: "ELB-RBSW-05",
            name: "Dyed Smooth Bone Gray",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb5.jpg"), require("../assets/guitar-components/elb55.jpg")],
          },
          {
            prodId: "ELB-RBSW-06",
            name: "Dyed Cross Cut Amber- Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb6.jpg"), require("../assets/guitar-components/elb66.jpg")],
          },
          {
            prodId: "ELB-RBSW-07",
            name: "Natural Stag Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb7.jpg"), require("../assets/guitar-components/elb77.jpg")],
          },
          {
            prodId: "ELB-RBSW-08",
            name: "Amber Grooved Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb8.jpg"), require("../assets/guitar-components/elb88.jpg")],
          },
          {
            prodId: "ELB-RBSW-09",
            name: "Natural Stag Bone Pattern-2",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb9.jpg"), require("../assets/guitar-components/elb99.jpg")],
          },
          {
            prodId: "ELB-RBSW-10",
            name: "Winter Bottom- Jigged Bone",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb10.jpg"), require("../assets/guitar-components/elb101.jpg")],
          },
          {
            prodId: "ELB-RBSW-11",
            name: "impala- jigged bone brunt antique",
            size1: " India",
            size2: "100% camel bone scales",
            images: [require("../assets/guitar-components/elb1111.jpg"), require("../assets/guitar-components/elb1112.jpg")],
          },
        ],
      },
    ],
  },
  // Water Buffow Horn
  {
    head: "Water Buffalo Horn",
    headslug: 'water-buffalo-horn',
    dec: "Enhance your instrument's sound with our premium Water Buffalo Horn, crafted from sustainably sourced materials. Our skilled artisans carefully design each component to optimize resonance and sustain, delivering a rich, vibrant tone. Whether crafted from intricate designs, exotic woods, or precious stones, each piece is precision-made to perfectly complement your musical creations, adding depth and character to every performance.",
    mainData: [
      {
        id: 22,
        img: require("../assets/guitar-components/waterbuffalo0.jpg"),
        title: "Water Buffalo Horn Smooth",
        wsize: ["5/8″ x 2″ x 6″ (152 x 52 x 15.50 mm)", "3/8″ x 2″ x 6″ (152 x 52 x 10.00 mm)", "3/8″ x 1-1/2″x 5″ (127 x 38 x 10 mm)", "1/4″x  1-1/2″ x 5″ (127 x 38 x 6.35 mm)", "1/4’x 1-1/4’x 4-1/2″ (115 x 32 x 6.35 mm)", "1/4″x 1-1/4″ x 3-1/2″ (90 x 32 x 6.35 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-WBHS-01",
            name: "Buffalo Horn Brown Strip",
            size1: " India",
            size2: "100% Original Buffalo Horn Craft",
            images: [require("../assets/guitar-components/strip1.jpg"), require("../assets/guitar-components/strip1.jpg")],
          },
          {
            prodId: "RC-WBHS-02",
            name: "Buffalo Horn Gold Strip",
            size1: " India",
            size2: "100% Original Buffalo Horn Craft",
            images: [require("../assets/guitar-components/strip2.jpg"), require("../assets/guitar-components/strip3.jpg")],
          },
          {
            prodId: "RC-WBHS-03",
            name: "Buffalo Horn Red Strip",
            size1: " India",
            size2: "100% Original Buffalo Horn Craft",
            images: [require("../assets/guitar-components/strip4.jpg"), require("../assets/guitar-components/strip5.jpg"), require("../assets/guitar-components/strip6.jpg")],
          },
          {
            prodId: "RC-WBHS-04",
            name: "Buffalo Horn White Strip",
            size1: " India",
            size2: "100% Original Buffalo Horn Craft",
            images: [require("../assets/guitar-components/strip7.jpg"), require("../assets/guitar-components/strip7.jpg")],
          },
          {
            prodId: "RC-WBHS-05",
            name: "Buffalo Horn White Strip",
            size1: " India",
            size2: "100% Original Buffalo Horn Craft",
            images: [require("../assets/guitar-components/strip8.jpg"), require("../assets/guitar-components/strip8.jpg")],
          },
          {
            prodId: "RC-WBHS-06",
            name: "Buffalo Horn Orange Strip",
            size1: " India",
            size2: "100% Original Buffalo Horn Craft",
            images: [require("../assets/guitar-components/strip9.jpg"), require("../assets/guitar-components/strip9.jpg")],
          },
        ],
      },
      {
        id: 23,
        img: require("../assets/guitar-components/waterbuffalo1.jpg"),
        title: "Water Buffalo Horn Jigged",
        wsize: ["1/4″x1 1/2″x5″ (127 x 38 x 6.50 mm)", "1/4” X1-1/4” X 5” (127 x 32 x 6.50 mm)", "1/4” X1-3/8”X 4-1/2” (115 X 35 X6.50 mm)", "1/4” X 1-1/4” X 4-1/2” (115 x 32 x 6.50 mm)", "1/4”x 1-1/4”x 4-1/4” (108 x 32 x 6.50 mm)", "3/16” x 1-1/4” x 4-1-/8” (105 x 32 x 4.75 mm)", "3/16”x 1”  x 3-1/2” (90 x 26 x 4.75 mm)", "More Sizes Available As per requirement"],

        usbData: [
          {
            prodId: "RC-WBHJ-01",
            name: "Buffalo Horn Swirled Jigged Black",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf1.jpg"), require("../assets/guitar-components/buf2.jpg")],
          },
          {
            prodId: "RC-WBHJ-02",
            name: "Buffalo Horn Impala Jigged Red",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf3.jpg"), require("../assets/guitar-components/buf4.jpg")],
          },
          {
            prodId: "RC-WBHJ-03",
            name: "Buffalo Horn Pick Jigged Honey",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf5.jpg"), require("../assets/guitar-components/buf6.jpg")],
          },
          {
            prodId: "RC-WBHJ-04",
            name: "Buffalo Horn burnt Impala Jigged",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf7.jpg"), require("../assets/guitar-components/buf8.jpg")],
          },
          {
            prodId: "RC-WBHJ-05",
            name: "Buffalo Horn Stag Jigged Red",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf9.jpg"), require("../assets/guitar-components/buf10.jpg")],
          },
          {
            prodId: "RC-WBHJ-06",
            name: "Buffalo Horn Impala Jigged Honey",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf11.jpg"), require("../assets/guitar-components/buf11.jpg")],
          },
          {
            prodId: "RC-WBHJ-07",
            name: "Buffalo Horn Pick Jigged Black",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf12.jpg"), require("../assets/guitar-components/buf13.jpg"), require("../assets/guitar-components/buf14.jpg")],
          },
          {
            prodId: "RC-WBHJ-08",
            name: "Buffalo Horn Burnt Stag Jigged",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf15.jpg"), require("../assets/guitar-components/buf16.jpg"), require("../assets/guitar-components/buf17.jpg")],
          },
          {
            prodId: "RC-WBHJ-09",
            name: "Buffalo Horn Impala Jigged Light Yellow",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf18.jpg"), require("../assets/guitar-components/buf19.jpg"), require("../assets/guitar-components/buf20.jpg")],
          },
          {
            prodId: "RC-WBHJ-10",
            name: "Buffalo Horn Stag Grey",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf21.jpg"), require("../assets/guitar-components/buf22.jpg")],
          },
          {
            prodId: "RC-WBHJ-11",
            name: "Buffalo Horn Burnt Jigged Light Yellow",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf23.jpg"), require("../assets/guitar-components/buf24.jpg")],
          },
          {
            prodId: "RC-WBHJ-12",
            name: "Buffalo Horn Impala Jigged Light Brownish Red",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf25.jpg"), require("../assets/guitar-components/buf25.jpg")],
          },
          {
            prodId: "RC-WBHJ-13",
            name: "Buffalo Horn Stag Jigged Brown",
            size1: " India",
            size2: "100% Original Buffalo Horn Scales",
            images: [require("../assets/guitar-components/buf26.jpg"), require("../assets/guitar-components/buf26.jpg")],
          },
        ],
      },
      {
        id: 24,
        img: require("../assets/guitar-components/waterbuffalo2.jpg"),
        title: "Buffalo Natural Bark",
        wsize: ["1/4″x1 1/2″x5″ (127 x 38 x 6.50 mm)", "1/4” X1-1/4” X 5” (127 x 32 x 6.50 mm)", "1/4” X1-3/8”X 4-1/2” (115 X 35 X6.50 mm)", "1/4” X 1-1/4” X 4-1/2” (115 x 32 x 6.50mm)", "1/4”x 1-1/4”x 4-1/4” (108 x 32 x 6.50 mm)", "3/16” x 1-1/4” x 4-1-/8” (105 x 32 x 4.75 mm)", "3/16”x 1” x 3-1/2” (90 x 26 x 4.75 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "BNB-01",
            name: "Buffalo Horn Natural Bark Scales",
            size1: " India",
            size2: "100% Water Buffalo Horn Scales",
            images: [require("../assets/guitar-components/bnb1.jpg"), require("../assets/guitar-components/bnb1.jpg")],
          },
          {
            prodId: "BNB-02",
            name: "Water Buffalo Horn Burnt Bark",
            size1: " India",
            size2: "100% Water Buffalo Horn Scales",
            images: [require("../assets/guitar-components/bnb2.jpg"), require("../assets/guitar-components/bnb2.jpg")],
          },
          {
            prodId: "BNB-03",
            name: "Buffalo Horn Natural Bark Unpolished",
            size1: " India",
            size2: "100% Water Buffalo Horn Scales",
            images: [require("../assets/guitar-components/bnb3.jpg"), require("../assets/guitar-components/bnb3.jpg")],
          },
          {
            prodId: "BNB-04",
            name: "Buffalo Horn Natural Bark",
            size1: " India",
            size2: "100% Water Buffalo Horn Scales",
            images: [require("../assets/guitar-components/bnb4.jpg"), require("../assets/guitar-components/bnb5.jpg")],
          },
        ],
      },
      {
        id: 25,
        img: require("../assets/guitar-components/waterbuffalo3.jpg"),
        title: "Buffalo Horn Rolls & Dowels",
        wsize: ["5″  x 1-1/4″ ( 127 X 32 mm)", "4.5″ x 1-1/8″ (115 X 32 mm)", "4-1/4″ x 1-1/8″ (108 x 29 mm)", "4″ x 1-1/8″ (102 x 29 mm)", "5″ x 3/4″ (127 x 19 mm)", "3-1/2′ x 3/8″ (90 x 10 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-WBHR-01",
            name: "Buffalo Horn Black Roll",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr1.jpg"), require("../assets/guitar-components/bhr1.jpg")],
          },
          {
            prodId: "RC-WBHR-02",
            name: "Buffalo Horn Red Roll",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr2.jpg"), require("../assets/guitar-components/bhr2.jpg")],
          },
          {
            prodId: "RC-WBHR-03",
            name: "Buffalo Horn White Streps Roll",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr3.jpg"), require("../assets/guitar-components/bhr3.jpg")],
          },
          {
            prodId: "RC-WBHR-04",
            name: "Buffalo Horn Brown Roll",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr4.jpg"), require("../assets/guitar-components/bhr4.jpg")],
          },
          {
            prodId: "RC-WBHR-05",
            name: "Buffalo Horn Green Streps Roll",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr55.jpg"), require("../assets/guitar-components/bhr5.jpg"), require("../assets/guitar-components/bhr555.jpg")],
          },
          {
            prodId: "RC-WBHR-06",
            name: "Black Horn Spacer",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr6.jpg"), require("../assets/guitar-components/bhr6.jpg")],
          },
          {
            prodId: "RC-WBHR-07",
            name: "Vintage Brown Horn Spacer",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr7.jpg"), require("../assets/guitar-components/bhr7.jpg")],
          },
          {
            prodId: "RC-WBHR-08",
            name: "Black Shade Horn Spacer",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr8.jpg"), require("../assets/guitar-components/bhr8.jpg")],
          },
          {
            prodId: "RC-WBHR-09",
            name: "Red Shade Horn Spacer",
            size1: " India",
            size2: "100% Buffalo Horn Rolls & Dowels",
            images: [require("../assets/guitar-components/bhr9.jpg"), require("../assets/guitar-components/bhr9.jpg")],
          },
        ],
      },
    ],
  },
  // giraffe-bone-recone-true
  {
    head: "Giraffe Bone Look, Recone True Stone and X-Grip Handle",
    headslug: 'giraffe-bone-recone-true-x-grip',
    dec: "Elevate your performance with our premium Animals, Giraffe Bone Look, Recone True Stone and X-Grip Handle, crafted from expertly selected materials. Our skilled craftsmen meticulously design each element to maximize comfort and control, delivering a confident, expressive show. Whether paired with striking designs, rare materials, or innovative textures, each piece is precision-crafted to perfectly complement your artistic vision, adding nuance and personality to every presentation.",
    mainData: [
      {
        id: 26,
        img: require("../assets/guitar-components/giraffebonelook0.jpg"),
        title: "Giraffe Bone Look",
        wsize: ["127 x 19 x 5 (mm), 146 x 19 x 5 (mm)", "125 x 20 x 5 (mm), 131 x 19 x 6 (mm)", "129 x 21 x 5 (mm), 140 x 19 x 8 (mm)", "155 x 34 x 8 (mm), 140 x 22 x 10 (mm)", "138 x 23 x 9 (mm), 118 x 21 x 11 (mm) ", "131 x 20 x 7 (mm)", "115x32x6.5mm (4-1/2″ x1-1/4″x1/4″)", "115x35x6.5mm (4-1/2″x 1-3/8″ x1/4)", "127x38x6.5mm ( 5″ x 1-1/2″ x 1/4″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "GBL-01",
            name: "Stabilized-Black Orange Shades Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl1.jpg"), require("../assets/guitar-components/gbl2.jpg"), require("../assets/guitar-components/gbl3.jpg")],
          },
          {
            prodId: "GBL-02",
            name: "Stabilized-Brandeis Blue Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl4.jpg"), require("../assets/guitar-components/gbl5.jpg")],
          },
          {
            prodId: "GBL-03",
            name: "Stabilized-Brown With Pink Shades Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl6.jpg"), require("../assets/guitar-components/gbl7.jpg")],
          },
          {
            prodId: "GBL-04",
            name: "Stabilized-Melon Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl8.jpg"), require("../assets/guitar-components/gbl9.jpg"), require("../assets/guitar-components/gbl10.jpg")],
          },
          {
            prodId: "GBL-05",
            name: "Stabilized-Hot Pink Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl11.jpg"), require("../assets/guitar-components/gbl12.jpg"), require("../assets/guitar-components/gbl13.jpg")],
          },
          {
            prodId: "GBL-06",
            name: "Stabilized-Light Melon Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl14.jpg"), require("../assets/guitar-components/gbl15.jpg")],
          },
          {
            prodId: "GBL-07",
            name: "Stabilized-Mid Brown Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl16.jpg"), require("../assets/guitar-components/gbl17.jpg")],
          },
          {
            prodId: "GBL-08",
            name: "Stabilized-Light Turquoise Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl18.jpg"), require("../assets/guitar-components/gbl19.jpg")],
          },
          {
            prodId: "GBL-09",
            name: "Stabilized-Light Amber Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl20.jpg"), require("../assets/guitar-components/gbl21.jpg")],
          },
          {
            prodId: "GBL-10",
            name: "Stabilized-Browner Shades Bone",
            size1: " India",
            size2: "100% Original Bone Handles",
            images: [require("../assets/guitar-components/gbl22.jpg"), require("../assets/guitar-components/gbl23.jpg"), require("../assets/guitar-components/gbl24.jpg")],
          },
        ],
      },
      {
        id: 27,
        img: require("../assets/guitar-components/reconetruestone0.jpg"),
        title: "Recone True Stone",
        wsize: ["3/8″x1-1/2″x6″ – (152x38x10mm)", "3/8″x1-1/2″x5″ – (127x38x10mm)", "1/4″x1-1/2″x5″ – (127x38x6.35mm)", "1/4″x1-1/4″x4-1/2″ – (115x32x6.35mm)", "More Sizes Available As per requirement"],

        usbData: [
          {
            prodId: "RC-RTS-01",
            name: "Recone stone Malachite Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts0.jpg"), require("../assets/guitar-components/rts1.jpg"), require("../assets/guitar-components/rts2.jpg")],
          },
          {
            prodId: "RC-RTS-02",
            name: "Recone Stone Dark Denim Lopics Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts3.jpg"), require("../assets/guitar-components/rts4.jpg"), require("../assets/guitar-components/rts5.jpg")],
          },
          {
            prodId: "RC-RTS-03",
            name: "Recone Stone Brown Spiney Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts6.jpg"), require("../assets/guitar-components/rts7.jpg"), require("../assets/guitar-components/rts8.jpg")],
          },
          {
            prodId: "RC-RTS-04",
            name: "Recone Stone Yellow Josper Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts9.jpg"), require("../assets/guitar-components/rts10.jpg"), require("../assets/guitar-components/rts11.jpg")],
          },
          {
            prodId: "RC-RTS-05",
            name: "Recone Stone White Web On Midnight Green Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts12.jpg"), require("../assets/guitar-components/rts13.jpg"), require("../assets/guitar-components/rts14.jpg")],
          },
          {
            prodId: "RC-RTS-06",
            name: "Recone Stone Yellow Out Black Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts15.jpg"), require("../assets/guitar-components/rts16.jpg"), require("../assets/guitar-components/rts17.jpg")],
          },
          {
            prodId: "RC-RTS-07",
            name: "Recone Stone Red with White Tornado Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts18.jpg"), require("../assets/guitar-components/rts19.jpg"), require("../assets/guitar-components/rts20.jpg")],
          },
          {
            prodId: "RC-RTS-08",
            name: "Recone Stone Black Mountain Cloud Scale",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/rts21.jpg"), require("../assets/guitar-components/rts22.jpg"), require("../assets/guitar-components/rts23.jpg")],
          },
        ],
      },
      {
        id: 28,
        img: require("../assets/guitar-components/xgriphandls0.jpg"),
        title: "X-Grip Handles",
        wsize: ["-----For Scales-----", "3/8″x1-1/2″x6″ – (152x38x10mm)", "3/8″x1-1/2″x5″ – (127x38x10mm)", "1/4″x1-1/4″x4-1/2″ – (115x32x6.35mm)", "1/4″x1-1/4″x4-1/4″ – (108x32x6.35mm)", "1/4″x1-1/2″x5″ – (127x38x6.35mm)", "-----For Blocks-----", "1″x1-1/2″x6″", "1″x1-1/2″x5″", "3/4″x1-1/2″x5″", "3/4″x3/4″x4.5″", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-XGH-01",
            name: "X-Grip-Pearls Coral",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z1.jpg"), require("../assets/guitar-components/z2.jpg"), require("../assets/guitar-components/z3.jpg")],
          },
          {
            prodId: "RC-XGH-02",
            name: "X-Grip-Forest Green",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z4.jpg"), require("../assets/guitar-components/z5.jpg"), require("../assets/guitar-components/z6.jpg")],
          },
          {
            prodId: "RC-XGH-03",
            name: "X-Grip-Pearls Yellow",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z7.jpg"), require("../assets/guitar-components/z8.jpg"), require("../assets/guitar-components/z9.jpg")],
          },
          {
            prodId: "RC-XGH-04",
            name: "X-Grip-Pearls Blue",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z10.jpg"), require("../assets/guitar-components/z11.jpg"), require("../assets/guitar-components/z12.jpg")],
          },
          {
            prodId: "RC-XGH-05",
            name: "X-Grip-Pearls Sapphire",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z13.jpg"), require("../assets/guitar-components/z14.jpg"), require("../assets/guitar-components/z15.jpg")],
          },
          {
            prodId: "RC-XGH-06",
            name: "X-Grip-Pearls Red",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z16.jpg"), require("../assets/guitar-components/z17.jpg"), require("../assets/guitar-components/z18.jpg"), require("../assets/guitar-components/z19.jpg")],
          },
          {
            prodId: "RC-XGH-07",
            name: "X-Grip-Pearls Yellow",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z20.jpg"), require("../assets/guitar-components/z21.jpg"), require("../assets/guitar-components/z22.jpg")],
          },
          {
            prodId: "RC-XGH-08",
            name: "X-Grip-Pearls Coral",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z23.jpg"), require("../assets/guitar-components/z24.jpg")],
          },
          {
            prodId: "RC-XGH-09",
            name: "X-Grip-Pearls Light Red",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z25.jpg"), require("../assets/guitar-components/z26.jpg"), require("../assets/guitar-components/z27.jpg")],
          },
          {
            prodId: "RC-XGH-10",
            name: "X-Grip-Pearls Light Red",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z28.jpg"), require("../assets/guitar-components/z29.jpg"), require("../assets/guitar-components/z30.jpg")],
          },
          {
            prodId: "RC-XGH-11",
            name: "X-Grip-Pearls Matte Sapphire",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z31.jpg"), require("../assets/guitar-components/z32.jpg"), require("../assets/guitar-components/z33.jpg")],
          },
          {
            prodId: "RC-XGH-12",
            name: "X-Grip-Pearls Matte Gold",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z34.jpg"), require("../assets/guitar-components/z34.jpg")],
          },
          {
            prodId: "RC-XGH-13",
            name: "X-Grip-Pearls Orange",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z35.jpg"), require("../assets/guitar-components/z36.jpg")],
          },
          {
            prodId: "RC-XGH-14",
            name: "X-Grip-Pearls Matte Sapphire",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z37.1.jpg"), require("../assets/guitar-components/z37.2.jpg")],
          },
          {
            prodId: "RC-XGH-15",
            name: "X-Grip-Pearls Blue Sapphire",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z38.1.jpg"), require("../assets/guitar-components/z38.2.jpg"), require("../assets/guitar-components/z38.3.jpg"), require("../assets/guitar-components/z38.4.jpg")],
          },
          {
            prodId: "RC-XGH-16",
            name: "X-Grip-Pearls Matte Yellow",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z39.1.jpg"), require("../assets/guitar-components/z39.2.jpg"), require("../assets/guitar-components/z39.3.jpg")],
          },
          {
            prodId: "RC-XGH-17",
            name: "X-Grip-Pearls Pink",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z40.1.jpg"), require("../assets/guitar-components/z40.2.jpg"), require("../assets/guitar-components/z40.3.jpg")],
          },
          {
            prodId: "RC-XGH-18",
            name: "X-Grip-Pearls Dark Grey",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z41.1.jpg"), require("../assets/guitar-components/z41.2.jpg"), require("../assets/guitar-components/z41.3.jpg")],
          },
          {
            prodId: "RC-XGH-19",
            name: "X-Grip-Pearls Matte Olivine",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z42.1.jpg"), require("../assets/guitar-components/z42.2.jpg")],
          },
          {
            prodId: "RC-XGH-20",
            name: "X-Grip-Pearls Light Orange",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z43.1.jpg"), require("../assets/guitar-components/z43.2.jpg"), require("../assets/guitar-components/z43.3.jpg")],
          },
          {
            prodId: "RC-XGH-21",
            name: "X-Grip-Pearls Light Sapphire",
            size1: " India",
            size2: "100% Original Handles",
            images: [require("../assets/guitar-components/z44.1.jpg"), require("../assets/guitar-components/z44.2.jpg"), require("../assets/guitar-components/z44.3.jpg")],
          },
        ],
      },
    ],
  },
  // Zebu,Sheep,Stabilized Wood Horn Handles 
  {
    head: "Ox-Zebu, Sheep Horn Handles and Stabilized Wood Handle",
    headslug: 'zebu-sheep-wood-horn-handle',
    dec: "Elevate your performance with our premium Sheep Horn Handles, Ox-Zebu Horn Handles and Stabilized Wood Handle, crafted from expertly selected materials. Our skilled craftsmen meticulously design each element to maximize comfort and control, delivering a confident, expressive show. Whether paired with striking designs, rare materials, or innovative textures, each piece is precision-crafted to perfectly complement your artistic vision, adding nuance and personality to every presentation.",
    mainData: [
      {
        id: 29,
        img: require("../assets/guitar-components/oxzebu1.jpg"),
        title: "Ox-Zebu Horn Handles",
        wsize: ["¼’x 1-1/2”x 5” (127 x 38 x 6.35 mm)", "¼”x 1-1/4”x 4-1/2” (115 x 32 x 6.35 m)", "5/32” x 1” x 3.5” (90 x 26 x 5mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-OZH-01",
            name: "Ox Horn Natural Black With Blond Horn Scales",
            size1: "India",
            size2: "100% Zebu Horn Handles",
            images: [require("../assets/guitar-components/ozh1.jpg"), require("../assets/guitar-components/ozh2.jpg")],
          },
          {
            prodId: "RC-OZH-02",
            name: "Zebu Horn Natural Bark",
            size1: "India",
            size2: "100% Zebu Horn Handles",
            images: [require("../assets/guitar-components/ozh3.jpg"), require("../assets/guitar-components/ozh4.jpg"), require("../assets/guitar-components/ozh5.jpg")],
          },
          {
            prodId: "RC-OZH-03",
            name: "Zebu Horn Natural Color Polished Scale",
            size1: "India",
            size2: "100% Zebu Horn Handles",
            images: [require("../assets/guitar-components/ozh6.jpg"), require("../assets/guitar-components/ozh7.jpg"), require("../assets/guitar-components/ozh8.jpg")],
          },
        ],
      },
      {
        id: 30,
        img: require("../assets/guitar-components/sheephorn1.jpg"),
        title: "Sheep Horn Handles",
        wsize: ["3/8″x1-1/2″x6″ – (152x38x10mm)", "3/8″x1-1/2″x5″ – (127x38x10mm)", "1/4″x1-1/2″x5″ – (127x38x6.35mm)", "1/4″x1-1/4″x4-1/2″ – (115x32x6.35mm)", "More Sizes Available As per requirement"],

        usbData: [
          {
            prodId: "RC-SHH-01",
            name: "Natural Sheep Horn Bark Scales",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/shh1.jpg"), require("../assets/guitar-components/shh2.jpg"), require("../assets/guitar-components/shh3.jpg")],
          },

        ],
      },
      {
        id: 31,
        img: require("../assets/guitar-components/woodhandle1.jpg"),
        title: "Stabilized Wood Handle",
        wsize: ["-----For Scales-----", "5/8″ x 2″x 6″ (152 mm x 52 x 15 mm)", "3/8″x1-1/2″5″ (127 x 38 x 10 mm)", "1/4″ x 1-1/2″ x 5″ (127 x 38 x 6.5 mm)", "1/4″ x 1-1/4″ x 41-/2″ (6.5 mm x 32 x 6.5 mm)", "-----For Blocks-----", "1″x1-1/2″x6″", "1″x1-1/2″x5″", "3/4″x1-1/2″x5″", "3/4″x3/4″x4.5″", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-SWH-01",
            name: "Rose Wood Knife Black Scales",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh1.jpg"), require("../assets/guitar-components/swh2.jpg"), require("../assets/guitar-components/swh3.jpg")],
          },
          {
            prodId: "RC-SWH-02",
            name: "Ebony Wood Knife Black Scales",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh4.jpg"), require("../assets/guitar-components/swh5.jpg"), require("../assets/guitar-components/swh6.jpg")],
          },
          {
            prodId: "RC-SWH-03",
            name: "Teak Wood Scales",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh7.jpg"), require("../assets/guitar-components/swh8.jpg"), require("../assets/guitar-components/swh9.jpg")],
          },
          {
            prodId: "RC-SWH-04",
            name: "Walnut Wood Scales",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh10.jpg"), require("../assets/guitar-components/swh11.jpg"), require("../assets/guitar-components/swh12.jpg"), require("../assets/guitar-components/swh13.jpg")],
          },
          {
            prodId: "RC-SWH-05",
            name: "Mango Wood Knife Scales",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh14.jpg"), require("../assets/guitar-components/swh15.jpg"), require("../assets/guitar-components/swh16.jpg")],
          },
          {
            prodId: "RC-SWH-06",
            name: "Iron Wood Block  ",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh17.jpg"), require("../assets/guitar-components/swh18.jpg")],
          },
          {
            prodId: "RC-SWH-07",
            name: "Ebony Wood Block",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh19.jpg"), require("../assets/guitar-components/swh20.jpg"), require("../assets/guitar-components/swh21.jpg")],
          },
          {
            prodId: "RC-SWH-08",
            name: "Black Palm Wood Blocks",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh22.jpg"), require("../assets/guitar-components/swh233.jpg"), require("../assets/guitar-components/swh24.jpg")],
          },
          {
            prodId: "RC-SWH-09",
            name: "Rose Wood Block",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh25.jpg"), require("../assets/guitar-components/swh26.jpg"), require("../assets/guitar-components/swh27.jpg")],
          },
          {
            prodId: "RC-SWH-10",
            name: "Blood Wood Block",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh28.jpg"), require("../assets/guitar-components/swh29.jpg"), require("../assets/guitar-components/swh30.jpg")],
          },
          {
            prodId: "RC-SWH-11",
            name: "Red Wood Block",
            size1: " India",
            size2: "100% Original Wood Handles",
            images: [require("../assets/guitar-components/swh31.jpg"), require("../assets/guitar-components/swh32.jpg"), require("../assets/guitar-components/swh33.jpg")],
          },

        ],
      },
    ],
  },
  // Teflon Bone Folder
  {
    head: "Teflon Bone Folder",
    headslug: 'teflon-bone-folder',
    dec: "Elevate your bookbinding experience with our premium Teflon Bone Folder, crafted from expertly selected materials. Our skilled craftsmen meticulously design each element to maximize precision and control, delivering a confident, professional finish. Whether paired with delicate papers, rare bookboards, or innovative embellishments, each folder is precision-crafted to perfectly complement your artistic vision, adding nuance and personality to every book",
    mainData: [
      {
        id: 32,
        img: require("../assets/guitar-components/twbf1.jpg"),
        title: "White Bone Folder",
        wsize: ["4″x5/16″-(102x16mm)", "5″x3/4″x(125x19mm)", "6″x3/7″x(150x19mm)", "7″x7/8″x(178x22mm)", '8″x7/8″x(200x22mm)', "6″x-150mm, 7″x-178mm", "6″x3/4″(150x19mm)", "7″x7/8″(178x22mm)", "8″x7/8″(200x22mm)", "9″x7/8″(200x22mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-WBF-01",
            name: "One Pointed Other Point Round End Bone Folder",
            size1: "India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tfwb1.jpg"), require("../assets/guitar-components/tfwb2.jpg"), require("../assets/guitar-components/tfwb3.jpg"), require("../assets/guitar-components/tfwb4.jpg"), require("../assets/guitar-components/tfwb5.jpg"), require("../assets/guitar-components/tfwb7.jpg"), require("../assets/guitar-components/tfwb8.jpg"), require("../assets/guitar-components/tfwb9.jpg")],
          },
          {
            prodId: "RC-WBF-02",
            name: "Long Pointed Bone Folder",
            size1: "India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tfwb10.jpg"), require("../assets/guitar-components/tfwb11.jpg"), require("../assets/guitar-components/tfwb12.jpg"), require("../assets/guitar-components/tfwb13.jpg"), require("../assets/guitar-components/tfwb14.jpg"), require("../assets/guitar-components/tfwb15.jpg")],
          },
          {
            prodId: "RC-WBF-03",
            name: "L-Corner Shape Bone Folder",
            size1: "India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tfwb16.jpg"), require("../assets/guitar-components/tfwb17.jpg"), require("../assets/guitar-components/tfwb18.jpg")],
          },
          {
            prodId: "RC-WBF-04",
            name: "Both Point Round End Bone Folder",
            size1: "India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tfwb19.jpg"), require("../assets/guitar-components/tfwb20.jpg"), require("../assets/guitar-components/tfwb21.jpg")],
          },

        ],
      },
      {
        id: 33,
        img: require("../assets/guitar-components/twbf2.jpg"),
        title: "Bent Bone Folder",
        wsize: ["5″x1″ (200x25mm)", "6″x3/4inch (150mmx20mm)", "8″x1″inch (200mmx25mm)", "More Sizes Available As per requirement"],

        usbData: [
          {
            prodId: "RC-BBF-01",
            name: "Mild Bow Shapes- Bent Folder",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/bent1.jpg"), require("../assets/guitar-components/bent2.jpg"), require("../assets/guitar-components/bent3.jpg")],
          },
          {
            prodId: "RC-BBF-02",
            name: "normac- bent folder, creaser",
            size1: " India",
            size2: "100% Original Stone Handles",
            images: [require("../assets/guitar-components/bent4.jpg"), require("../assets/guitar-components/bent5.jpg"), require("../assets/guitar-components/bent6.jpg"), require("../assets/guitar-components/bent7.jpg")],
          },
        ],
      },
      {
        id: 34,
        img: require("../assets/guitar-components/twbf3.jpg"),
        title: "Batic Bone Folder",
        wsize: ["4” x 5/16” ( 102 mm x 16 mm)", "5” x ¾” (125 mm x 19 mm)", "5-/2” x 5/16” (140 mm x 16 mm)", "6” x ¾” (150 mm x 19 mm)", "7” x 7/8” (178 mm x 22 mm)", "8” x 1” (200 mm x 25.5 mm)", "9” x 1” (225 mm x 25.5 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-TBBF-01",
            name: "Rings Design Vintage Brown Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/batik1.jpg"), require("../assets/guitar-components/batik2.jpg"), require("../assets/guitar-components/batik3.jpg"), require("../assets/guitar-components/batik4.jpg"), require("../assets/guitar-components/batik5.jpg")],
          },
          {
            prodId: "RC-TBBF-02",
            name: "Rhombus Dotin Design Vintage Brown Bone folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/batik6.jpg"), require("../assets/guitar-components/batik6.jpg")],
          },
          {
            prodId: "RC-TBBF-03",
            name: "Infinite Design Dark Brown Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/batik7.jpg"), require("../assets/guitar-components/batik8.jpg"), require("../assets/guitar-components/batik9.jpg")],
          },
          {
            prodId: "RC-TBBF-04",
            name: "Giraffe Pattern Brown Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/batik10.jpg"), require("../assets/guitar-components/batik11.jpg")],
          },
          {
            prodId: "RC-TBBF-05",
            name: "White Infinite Design Brown Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/batik12.jpg"), require("../assets/guitar-components/batik12.jpg")],
          },
          {
            prodId: "RC-TBBF-06",
            name: "White Doted Design Vintage Wood Brown Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/batik13.jpg"), require("../assets/guitar-components/batik13.jpg")],
          },
          {
            prodId: "RC-TBBF-08",
            name: "White Zig-Zag Design Brown Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/batik14.jpg"), require("../assets/guitar-components/batik14.jpg")],
          },
        ],
      },
      {
        id: 35,
        img: require("../assets/guitar-components/twbf4.jpg"),
        title: "Dyed Bone Folder",
        wsize: ["4” x 5/16” ( 102 mm x 16 mm)", "5” x ¾” (125 mm x 19 mm)", "5-/2” x 5/16” (140 mm x 16 mm)", "6” x ¾” (150 mm x 19 mm)", "7” x 7/8” (178 mm x 22 mm)", "8” x 1” (200 mm x 25.5 mm)", "9” x 1” (225 mm x 25.5 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-DBF-01",
            name: "Black Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf1.jpg"), require("../assets/guitar-components/tdbf2.jpg")],
          },
          {
            prodId: "RC-DBF-02",
            name: "Deep Violet Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf3.jpg"), require("../assets/guitar-components/tdbf3.jpg")],
          },
          {
            prodId: "RC-DBF-03",
            name: "Coral Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf4.jpg"), require("../assets/guitar-components/tdbf4.jpg")],
          },
          {
            prodId: "RC-DBF-04",
            name: "Blue Dyed Bone folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf5.jpg"), require("../assets/guitar-components/tdbf5.jpg")],
          },
          {
            prodId: "RC-DBF-05",
            name: "Orange With White Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf6.jpg"), require("../assets/guitar-components/tdbf7.jpg")],
          },
          {
            prodId: "RC-DBF-06",
            name: "Dark Brown Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf8.jpg"), require("../assets/guitar-components/tdbf8.jpg")],
          },
          {
            prodId: "RC-DBF-07",
            name: "Purple With White Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf9.jpg"), require("../assets/guitar-components/tdbf9.jpg")],
          },
          {
            prodId: "RC-DBF-08",
            name: "Wood Brown Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf10.jpg"), require("../assets/guitar-components/tdbf11.jpg")],
          },
          {
            prodId: "RC-DBF-09",
            name: "Grey With White Shade Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf12.jpg"), require("../assets/guitar-components/tdbf13.jpg")],
          },
          {
            prodId: "RC-DBF-10",
            name: "Sky Blue Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf14.jpg"), require("../assets/guitar-components/tdbf15.jpg")],
          },
          {
            prodId: "RC-DBF-11",
            name: "Navy Blue with Purple Shade Dyed Bone Folder",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf16.jpg"), require("../assets/guitar-components/tdbf17.jpg")],
          },
          {
            prodId: "RC-DBF-12",
            name: "Both Curved Green Bone folder with Black Spots",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/DSC_1077-1-scaled.jpg"), require("../assets/guitar-components/DSC_1077-1-scaled.jpg")],
          },
          {
            prodId: "RC-DBF-13",
            name: "Both Curved Red Bone Folder With Black Spots",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf18.jpg"), require("../assets/guitar-components/tdbf18.jpg")],
          },
          {
            prodId: "RC-DBF-14",
            name: "Hot Meganta Pink Bone Folder with Light Copper Spots",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf19.jpg"), require("../assets/guitar-components/tdbf19.jpg")],
          },
          {
            prodId: "RC-DBF-15",
            name: "Long Point end Green Bone Folder with Black Spots",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf20.jpg"), require("../assets/guitar-components/tdbf20.jpg")],
          },
          {
            prodId: "RC-DBF-16",
            name: "Long Point end Yellow Bone Folder with Black Spots",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/tdbf21.jpg"), require("../assets/guitar-components/tdbf21.jpg")],
          },
        ],
      },
      {
        id: 351,
        img: require("../assets/guitar-components/wbwe-home.jpg"),
        title: "White Bone With Engraving",
        wsize: ["4″x5/16″-(102x16mm)", "5″x3/4″x(125x19mm)", "6″x3/7″x(150x19mm)", "6″x-150mm, 7″x-178mm", "6″x3/4″(150x19mm)", "7″x7/8″(178x22mm)", "8″x7/8″(200x22mm)", "9″x7/8″(200x22mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-WBWE-01",
            name: "White Bone Folder With Watching Owl Engraved In One Pointed End",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/wbwe-1.jpg")],
          },
          {
            prodId: "RC-WBWE-02",
            name: "White Bone Folder With Watching Wolf Engraved One Pointed End",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/wbwe-2.jpg")],
          },
          {
            prodId: "RC-WBWE-03",
            name: "White Bone Folder With Titanic Ship Engraved Both Curved End",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/wbwe-3.jpg")],
          },
          {
            prodId: "RC-WBWE-04",
            name: "White Bone Folder With Running Fox Engraved Both Curved End",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/wbwe-4.jpg")],
          },
          {
            prodId: "RC-WBWE-05",
            name: "White Bone Folder With Walking Bear Engraved One Pointed End",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/wbwe-5.jpg")],
          },
          {
            prodId: "RC-WBWE-06",
            name: "White Bone Folder With Snake Yawning Engraved, Horse Face Engraved, Watching    Deer Engraved and Hunting Eagle Engraved One Pointed End",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/wbwe-home.jpg"), require("../assets/guitar-components/wbwe-6.jpg")],
          },
          {
            prodId: "RC-WBWE-07",
            name: "White Bone Folder With Watching Wolf Engraved, Watching Owl Engraved and Walking Bear Engraved One Pointed End",
            size1: " India",
            size2: "100% Original Bone Folder",
            images: [require("../assets/guitar-components/wbwe-7.jpg")],
          },
        ],
      },
    ],
  },
  // Teflon Folder
  {
    head: "Teflon Folder",
    headslug: 'teflon-folder',
    dec: "Our Teflon folder are made of non-stick PTFE material 100% paver white a grade hig quality Teflon . Customers tell us that one of the biggest benefits of our Large Teflon folder is the non-stick properties, which means that adhesives, inks and paints will not stick to it. This is not the case with our bone folder; it will only get smoother and shinier with age while making clean up a snap. Made of 100% Teflon, More flexible than a traditional bone folder, Glue will not adhere to our Teflon Bone Folder, Won’t scuff paper or cloth, Won’tleave a sheen, Non-Scratch and Non-Glaze, Non-Stick",
    mainData: [
      {
        id: 36,
        img: require("../assets/guitar-components/teflonfolder0.jpg"),
        title: "Teflon Folder",
        usbData: [
          {
            prodId: "RC-TF-01",
            name: "Teflon Folding Rib",
            size1: "All Size Available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/taffold1.jpg"), require("../assets/guitar-components/taffold2.jpg"), require("../assets/guitar-components/taffold3.jpg")]
          },
          {
            prodId: "RC-TF-02",
            name: "White Teflon Lifter",
            size1: "(160x20x8mm)",
            size2: "6-1/8″ x 3/4″",
            images: [require("../assets/guitar-components/taffold4.jpg"), require("../assets/guitar-components/taffold5.jpg"), require("../assets/guitar-components/taffold6.jpg"),]
          },
          {
            prodId: "RC-TF-03",
            name: "Teflon Large Folder",
            size1: "(160mmx20mmx8mm)",
            size2: "6-3/8inchx3/4″",
            images: [require("../assets/guitar-components/taffold7.jpg"), require("../assets/guitar-components/taffold8.jpg"), require("../assets/guitar-components/taffold9.jpg"), require("../assets/guitar-components/taffold10.jpg")]
          },
          {
            prodId: "RC-TF-04",
            name: "Small Teflon folder",
            size1: "(150mmx16mmx6.5mm)",
            size2: "6inchx3/4″ ",
            images: [require("../assets/guitar-components/taffold11.jpg"), require("../assets/guitar-components/taffold12.jpg"), require("../assets/guitar-components/taffold13.jpg"), require("../assets/guitar-components/taffold14.jpg"), require("../assets/guitar-components/taffold15.jpg"), require("../assets/guitar-components/taffold16.jpg")]
          },
          {
            prodId: "RC-TF-05",
            name: "mild bow shapes cut teflon folder",
            size1: "(160mmx20mmx8mm)",
            size2: "6-3/8″x3/4″ ",
            images: [require("../assets/guitar-components/taffold17.jpg"), require("../assets/guitar-components/taffold18.jpg")]
          },
          {
            prodId: "RC-TF-06",
            name: "Ergo Square Teflon Folder",
            size1: "(160mmx20mmx8mm)",
            size2: "2 inch x 1–1/2″ inch",
            images: [require("../assets/guitar-components/taffold19.jpg")]
          },
          {
            prodId: "RC-TF-07",
            name: "teflon spectula",
            size1: "(200mmx38mmx6mm)",
            size2: "8″x1-1/2″",
            images: [require("../assets/guitar-components/taffold20.jpg")]
          },
          {
            prodId: "RC-TF-08",
            name: "teflon burinisiter",
            size1: "(150mmx10mm)",
            size2: "6″x3/8″ ",
            images: [require("../assets/guitar-components/taffold21.jpg"), require("../assets/guitar-components/taffold22.jpg"), require("../assets/guitar-components/taffold23.jpg")]
          },
          {
            prodId: "RC-TF-09",
            name: "Mini teflon folder",
            size1: "(52x32mm)",
            size2: "2″ x 1-1/4″",
            images: [require("../assets/guitar-components/taffold24.jpg"), require("../assets/guitar-components/taffold24.jpg")]
          },
        ],
      },

    ],
  },
  // Horn folder
  {
    head: "Horn Folder",
    headslug: 'horn-folder',
    dec: "Buffalo black horn and brown horn, along with natural blond horn folders, are meticulously handcrafted from water buffalo in India. These folders produce a thin, flexible tool ideal for scoring, folding, and burnishing paper. Each carved folder embodies a distinct, elegant Indian design, showcasing the exquisite artistry of skilled artisans.Hand - carved with precision, these folders reflect traditional craftsmanship, making each piece a unique work of art.Perfect for paper crafters and artists seeking both functionality and beauty in their tools.",
    mainData: [
      {
        id: 37,
        img: require("../assets/guitar-components/hornfolder0.jpg"),
        title: "Horn Folder",
        usbData: [
          {
            prodId: "RC-HF-01",
            name: "Horn Creaser Large",
            size1: "(150mm x 20mm)",
            size2: "6″x3/4″",
            images: [require("../assets/guitar-components/hf1.jpg"), require("../assets/guitar-components/hf2.jpg")]
          },
          {
            prodId: "RC-HF-02",
            name: "Horn Folder Long Pointed",
            size1: "(175 mm long)",
            size2: "7 inch",
            images: [require("../assets/guitar-components/hf3.jpg")]
          },
          {
            prodId: "RC-HF-03",
            name: "One Pointed Black Horn Folder",
            size1: "(150×20 mm)",
            size2: "6″ x 3/4″ inch",
            images: [require("../assets/guitar-components/hf4.jpg")]
          },
          {
            prodId: "RC-HF-04",
            name: "Deluxe Horn Creaser Large",
            size1: "(160×20 mm)",
            size2: "6-1/4′ x7/8″inch",
            images: [require("../assets/guitar-components/hf5.jpg")]
          },
          {
            prodId: "RC-HF-05",
            name: "Mild Bow Shapes Longer Horn Creaser",
            size1: "(160 mm x 22mm)",
            size2: "6-1/4″x7/8″ inch ",
            images: [require("../assets/guitar-components/hf6.jpg")]
          },
          {
            prodId: "RC-HF-06",
            name: "Caramel Brown Horn Folder",
            size1: "(150-175 mm x 20 mm)",
            size2: "6-7″ x 3/4″ inch ",
            images: [require("../assets/guitar-components/hf7.jpg")]
          },
        ],
      },

    ],
  },
  //Wood Folder
  {
    head: "Wood Folder",
    headslug: 'wood-folder',
    dec: "Wood folders, crafted from premium quality timber, are meticulously handcrafted to offer both durability and elegance. These folders are designed for scoring, folding, and burnishing paper with exceptional precision. The natural grain of the wood ensures that each folder is uniquely beautiful, showcasing a blend of classic craftsmanship and modern utility. The finely carved details highlight the artistry of skilled woodworkers, making each piece a distinct work of art.",
    mainData: [
      {
        id: 38,
        img: require("../assets/guitar-components/woodfolder0.jpg"),
        title: "Wood Folder",
        usbData: [
          {
            prodId: "RC-WF-01",
            name: "Rose wood standard folder",
            size1: "(135 mm x 22 mm)",
            size2: "5-3/4″ x 7/8″ inch",
            images: [require("../assets/guitar-components/wf0.jpg")]
          },
          {
            prodId: "RC-WF-02",
            name: "Walnut wood booth end round folder",
            size1: " (150 mm x 22 mm – 200 mm x 25 mm)",
            size2: "6″ x 7/8″ , 8″ x 1″ inch",
            images: [require("../assets/guitar-components/wf1.jpg")]
          },
          {
            prodId: "RC-WF-02",
            name: "Rose wood Long point wood folder",
            size1: "(150mm – 175mm long)",
            size2: "6 inch long & 7 inch long ",
            images: [require("../assets/guitar-components/wf2.jpg")]
          },

        ],
      },

    ],
  },
  //Agate Burnisher
  {
    head: "Agate Burnisher Book Binding",
    headslug: 'agate-burnisher',
    dec: "Agate burnishers are used to smooth out genuine gold leaf (any metal leaf) after it has been adhered to a surface through water gilding, giving the gilded surface an attention-grabbing luster. The process of bookbinding requires many raw materials such as paper, threads, tape, boards and fabric. All these items are available in the market in different quality levels and grades. Perfect binding involves collating all the pages or signatures of a book, roughening and flattening the edge of the spine area, and then applying a flexible adhesive and attaching a paper cover to the spine. Paperback novels are one example of perfect binding.",
    mainData: [
      {
        id: 39,
        img: require("../assets/guitar-components/agate-burnisher0.jpg"),
        title: "Agate Burnisher Book Binding",
        usbData: [
          {
            prodId: "RC-AB-01",
            name: "Botswana Agate Burnisher",
            size1: "6″ length, 7″ length",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ab1.jpg"), require("../assets/guitar-components/ab2.jpg"), require("../assets/guitar-components/ab3.jpg")]
          },
          {
            prodId: "RC-AB-02",
            name: "Moss Agate Burnisher",
            size1: "6″ length, 7″ length",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/ab4.jpg"), require("../assets/guitar-components/ab5.jpg"), require("../assets/guitar-components/ab6.jpg")]
          },
        ],
      },

    ],
  },
  //Beads Crafts

  //pandent
  {
    head: "Pandent Beads Crafts",
    headslug: 'pandent-beads',
    dec: "Pendent beads crafts feature expertly handcrafted beads with vibrant colors and intricate designs. Each pendant is a unique art piece, blending traditional craftsmanship with modern style. Perfect for personalized jewelry, these pendants offer a distinctive touch to any outfit, celebrating both creativity and skilled artistry in every piece.",
    mainData: [
      {
        id: 40,
        img: require("../assets/guitar-components/pandent0.jpg"),
        title: "Pandent Beads Craft",
        usbData: [
          {
            prodId: "RC-PBC-01",
            name: "pandent-01",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc1.jpg"), require("../assets/guitar-components/pbc2.jpg"), require("../assets/guitar-components/pbc3.jpg")]
          },
          {
            prodId: "RC-PBC-02",
            name: "pandent-02",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc4.jpg"), require("../assets/guitar-components/pbc5.jpg"), require("../assets/guitar-components/pbc6.jpg")]
          },
          {
            prodId: "RC-PBC-03",
            name: "pandent-03",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc7.jpg"), require("../assets/guitar-components/pbc8.jpg"), require("../assets/guitar-components/pbc9.jpg")]
          },
          {
            prodId: "RC-PBC-04",
            name: "pandent-04",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc10.jpg"), require("../assets/guitar-components/pbc11.jpg"), require("../assets/guitar-components/pbc12.jpg")]
          },
          {
            prodId: "RC-PBC-05",
            name: "pandent-05",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc13.jpg"), require("../assets/guitar-components/pbc14.jpg"), require("../assets/guitar-components/pbc15.jpg")]
          },
          {
            prodId: "RC-PBC-06",
            name: "pandent-06",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc116.jpg"), require("../assets/guitar-components/pbc17.jpg")]
          },
          {
            prodId: "RC-PBC-07",
            name: "pandent-07",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc18.jpg"), require("../assets/guitar-components/pbc19.jpg")]
          },
          {
            prodId: "RC-PBC-08",
            name: "pandent-08",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc20.jpg"), require("../assets/guitar-components/pbc21.jpg"), require("../assets/guitar-components/pbc22.jpg")]
          },
          {
            prodId: "RC-PBC-09",
            name: "pandent-09",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc23.jpg"), require("../assets/guitar-components/pbc25.jpg"), require("../assets/guitar-components/pbc26.jpg")]
          },
          {
            prodId: "RC-PBC-10",
            name: "pandent-10",
            size1: "All Size available",
            size2: "All Size Available",
            images: [require("../assets/guitar-components/pbc27.jpg"), require("../assets/guitar-components/pbc28.jpg")]
          },
        ],
      },

    ],
  },

  // Bone || pen blank & turning block

  {
    head: "Bone Blank & Turning Block",
    headslug: 'bone-pen-blank',
    dec: "Bone pen blanks and turning blocks showcase meticulously crafted pieces, ideal for custom pen making and woodworking projects. Each blank is a testament to skilled artisanship, combining durability with natural elegance. With a smooth finish and unique grain patterns, these materials provide a distinctive look and feel, adding a touch of refinement to your handcrafted items.",
    mainData: [
      {
        id: 58,
        img: require("../assets/guitar-components/penbone14.3.jpg"),
        title: "Bone Pen Blank & Turning Block",
        wsize: ["6″ x 1/2″ x 1/2″ (152mm x 13mm)", "5″ x 1/2″ x 1/2″(127mm x 13mm)", "6″ x 1/2″ – ( 150 x 12.5 mm )", "5″ x 1/2″ (127 x 12.5 mm)", "7″ x 5/8″ (180 mm x 8 mm)", "3.5″ x 3/8″ (90 x 10 mm)", "4″ x 5/16″ (102 mm 8 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-BPB-01",
            name: "White Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone1.1.jpg"), require("../assets/guitar-components/penbone1.2.jpg"), require("../assets/guitar-components/penbone1.3.jpg")]
          },
          {
            prodId: "RC-BPB-02",
            name: "Vintage Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone2.1.jpg"), require("../assets/guitar-components/penbone2.2.jpg")]
          },
          {
            prodId: "RC-BPB-03",
            name: "Turquoise Cyan With White Shades Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone3.1.jpg"), require("../assets/guitar-components/penbone3.2.jpg"), require("../assets/guitar-components/penbone3.3.jpg")]
          },
          {
            prodId: "RC-BPB-04",
            name: "Light Pink White Shades Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone4.1.jpg"), require("../assets/guitar-components/penbone4.2.jpg"), require("../assets/guitar-components/penbone4.3.jpg")]
          },
          {
            prodId: "RC-BPB-05",
            name: "Apricot Orange With White Shades Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone5.1.jpg"), require("../assets/guitar-components/penbone5.2.jpg"), require("../assets/guitar-components/penbone5.3.jpg")]
          },
          {
            prodId: "RC-BPB-06",
            name: "Hot Pink With White Shades Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone6.1.jpg"), require("../assets/guitar-components/penbone6.2.jpg"), require("../assets/guitar-components/penbone6.3.jpg")]
          },
          {
            prodId: "RC-BPB-07",
            name: "Royal Blue With White Shades Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone7.1.jpg"), require("../assets/guitar-components/penbone7.2.jpg"), require("../assets/guitar-components/penbone7.3.jpg")]
          },
          {
            prodId: "RC-BPB-08",
            name: "Dyed Dark Peach Pink Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone14.1.jpg"), require("../assets/guitar-components/penbone14.2.jpg"), require("../assets/guitar-components/penbone14.3.jpg")]
          },
          {
            prodId: "RC-BPB-09",
            name: "Dyed Mustard Yellow Bone Pen Blank",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/penbone19.1.jpg"), require("../assets/guitar-components/penbone19.2.jpg"), require("../assets/guitar-components/penbone19.3.jpg")]
          },
        ],
      },

    ],
  },
  // Horn || pen blank & turning block
  {
    head: "Horn Blank & Turning Block",
    headslug: 'horn-pen-blank',
    dec: "Horn blanks and turning blocks offer beautifully crafted pieces, perfect for custom projects in pen making and woodworking. Each blank reflects skilled artisanship, bringing together durability and natural elegance. With a smooth finish and unique texture, these materials give your handcrafted items a distinctive look and feel, adding a refined touch to any creation.",
    mainData: [
      {
        id: 59,
        img: require("../assets/guitar-components/hornpen1.1.jpg"),
        title: "Horn Pen Blank & Turning Block",
        wsize: ["3/4″ x 6″  ( In 19mm x 150mm)", "3/4″ x 5″  ( In 19mm x 127mm)", "3/4″ x 51/4″ ( In 19mm x 134mm)", "3/4″ x 5″   ( In 19mm x 127mm)", "5/16″ x 5″  ( In 16mm x 127mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-HPB-01",
            name: "Black Horn Pen Blank",
            size2: "100% Original Horn Pen Blank",
            images: [require("../assets/guitar-components/hornpen1.1.jpg"), require("../assets/guitar-components/hornpen1.2.jpg"), require("../assets/guitar-components/hornpen1.3.jpg")]
          },
          {
            prodId: "RC-HPB-03",
            name: "Red With Strips Horn Pen Blank",
            size2: "100% Original Horn Pen Blank",
            images: [require("../assets/guitar-components/hornpen2.jpg")]
          },
          {
            prodId: "RC-HPB-04",
            name: "Brown Horn Pen Blank",
            size2: "100% Original Horn Pen Blank",
            images: [require("../assets/guitar-components/hornpen3.jpg")]
          },
          {
            prodId: "RC-HPB-04",
            name: "Vintage Horn Pen Blank",
            size2: "100% Original Horn Pen Blank",
            images: [require("../assets/guitar-components/hornpen4.jpg")]
          },
        ],
      },

    ],
  },

  // Wood || pen blank & turning block
  {
    head: "Wood Blank & Turning Block",
    headslug: 'wood-pen-blank',
    dec: "Wood pen blanks and turning blocks offer beautifully crafted pieces, perfect for custom projects in pen making and woodworking. Each blank showcases skilled artisanship, blending durability with natural elegance. With a smooth finish and unique grain patterns, these materials provide your handcrafted items with a distinctive look and feel, adding a refined touch to every creation.",
    mainData: [
      {
        id: 60,
        img: require("../assets/guitar-components/woodpen5.2.jpg"),
        title: "Wood Pen Blank & Turning Block",
        wsize: ["3/4″ x 6″  ( In 19mm x 150mm)", "3/4″ x 5″  ( In 19mm x 127mm)", "3/4″ x 51/4″ ( In 19mm x 134mm)", "3/4″ x 5″   ( In 19mm x 127mm)", "5/16″ x 5″  ( In 16mm x 127mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-WPB-01",
            name: "Walnut Wood Round Pen Blank",
            size2: "100% Wood Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/woodpen1.1.jpg"), require("../assets/guitar-components/woodpen1.2.jpg"), require("../assets/guitar-components/woodpen1.3.jpg")]
          },
          {
            prodId: "RC-WPB-02",
            name: "Rose Wood Round Pen Blank",
            size2: "100% Wood Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/woodpen2.1.jpg"), require("../assets/guitar-components/woodpen2.2.jpg"), require("../assets/guitar-components/woodpen2.3.jpg")]
          },
          {
            prodId: "RC-WPB-03",
            name: "Walnut Wood Square Pen Blank",
            size2: "100% Wood Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/woodpen4.1.jpg")]
          },
          {
            prodId: "RC-WPB-04",
            name: "Ebony Blue Wood Square Pen Blank",
            size2: "100% Wood Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/woodpen5.1.jpg"), require("../assets/guitar-components/woodpen5.2.jpg")]
          },
          {
            prodId: "RC-WPB-05",
            name: "Ebony Wood Square Pen Blank",
            size2: "100% Wood Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/woodpen6.1.jpg"), require("../assets/guitar-components/woodpen6.2.jpg")]
          },
          {
            prodId: "RC-WPB-06",
            name: "Black Palm Wood Square Pen Blank",
            size2: "100% Wood Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/woodpen7.1.jpg"), require("../assets/guitar-components/woodpen7.2.jpg")]
          },
          {
            prodId: "RC-WPB-07",
            name: "Ebony Red Wood Square Pen Blank",
            size2: "100% Wood Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/woodpen8.1.jpg"), require("../assets/guitar-components/woodpen8.2.jpg")]
          },
        ],
      },

    ],
  },

  // Wood || pen blank & turning block
  {
    head: "X-Grip Blank & Turning Block",
    headslug: 'x-grip-pen-blank',
    dec: "We use pen blanks for making seam rippers, sewing stiletto’s, safety pin helpers, key rings, light pulls, coffee scoops, razor handles and stands and the list goes on. The cutoffs become magnets or get glued together to make a new blank. This is a double ended seam ripper.",
    mainData: [
      {
        id: 61,
        img: require("../assets/guitar-components/x-grippen11.1.jpg"),
        title: "X-Grip Pen Blank & Turning Block",
        wsize: ["3/4″ x 6″  ( In 19mm x 150mm)", "3/4″ x 5″  ( In 19mm x 127mm)", "3/4″ x 51/4″ ( In 19mm x 134mm)", "3/4″ x 5″   ( In 19mm x 127mm)", "5/16″ x 5″  ( In 16mm x 127mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-X-Grip-PB-01",
            name: "X-Grip Violet White Round Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen1.1.jpg"), require("../assets/guitar-components/x-grippen1.2.jpg"), require("../assets/guitar-components/x-grippen1.3.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-02",
            name: "X-Grip Mustard Yellow Mixed Grey Round Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen2.1.jpg"), require("../assets/guitar-components/x-grippen2.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-03",
            name: "X-Grip Lava Red Round Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen3.1.jpg"), require("../assets/guitar-components/x-grippen3.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-04",
            name: "X-Grip Red Maroon Diamond Mix Pearl Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen4.1.jpg"), require("../assets/guitar-components/x-grippen4.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-05",
            name: "X-Grip Sky Blue With Cloud Mixed Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen5.1.jpg"), require("../assets/guitar-components/x-grippen5.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-06",
            name: "X-Grip Sunglow Yellow With Black Line Shade Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen6.1.jpg"), require("../assets/guitar-components/x-grippen6.2.jpg"), require("../assets/guitar-components/x-grippen6.3.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-07",
            name: "X-Grip Cerulean Cyan Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen7.1.jpg"), require("../assets/guitar-components/x-grippen7.2.jpg"), require("../assets/guitar-components/x-grippen7.3.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-08",
            name: "X-Grip Forest Green Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen8.1.jpg"), require("../assets/guitar-components/x-grippen8.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-09",
            name: "X-Grip Forest Green Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen9.1.jpg"), require("../assets/guitar-components/x-grippen9.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-10",
            name: "X-Grip Prussian Blue Mixed White Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen10.1.jpg"), require("../assets/guitar-components/x-grippen10.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-11",
            name: "X-Grip Turquoise Pearl Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen11.1.jpg"), require("../assets/guitar-components/x-grippen11.2.jpg")]
          },
          {
            prodId: "RC-X-Grip-PB-12",
            name: "X-Grip Cotton Candy Pink Long Square Pen Blank",
            size2: "100% X-Grip Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/x-grippen12.1.jpg"), require("../assets/guitar-components/x-grippen12.2.jpg")]
          },
        ],
      },

    ],
  },

  // Wood || pen blank & turning block
  {
    head: "Recone Stone Blank & Turning Block",
    headslug: 'recone-stone-pen-blank',
    dec: "Recone stone blanks and turning blocks offer exquisitely crafted materials, ideal for custom projects in pen making and woodworking. Each blank reflects expert craftsmanship, combining durability with natural sophistication. With a smooth finish and unique stone-like patterns, these materials give your handcrafted items a distinctive look and a refined touch.",
    mainData: [
      {
        id: 62,
        img: require("../assets/guitar-components/reconstone5.2.jpg"),
        title: "Recone Stone Pen Blank & Turning Block",
        wsize: ["3/4″ x 6″  ( In 19mm x 150mm)", "3/4″ x 5″  ( In 19mm x 127mm)", "3/4″ x 51/4″ ( In 19mm x 134mm)", "3/4″ x 5″   ( In 19mm x 127mm)", "5/16″ x 5″  ( In 16mm x 127mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-RSPB-01",
            name: "Recone Stone Yellow Jasper Pen Blank",
            size2: "100% Recone Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/reconstone1.1.jpg"), require("../assets/guitar-components/reconstone1.2.jpg")]
          },
          {
            prodId: "RC-RSPB-02",
            name: "Recone Stone Deep Blue Sea Pen Blank",
            size2: "100% Recone Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/reconstone2.1.jpg"), require("../assets/guitar-components/reconstone2.2.jpg"), require("../assets/guitar-components/reconstone2.3.jpg")]
          },
          {
            prodId: "RC-RSPB-03",
            name: "Recone Stone Brown Caramel Pen Blank",
            size2: "100% Recone Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/reconstone3.1.jpg"), require("../assets/guitar-components/reconstone3.2.jpg"), require("../assets/guitar-components/reconstone3.3.jpg")]
          },
          {
            prodId: "RC-RSPB-04",
            name: "Recone Stone Arizona Green Pen Blank",
            size2: "100% Recone Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/reconstone4.1.jpg"), require("../assets/guitar-components/reconstone4.2.jpg")]
          },
          {
            prodId: "RC-RSPB-05",
            name: "Recone Stone Black & White Web Pen Blank",
            size2: "100% Recone Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/reconstone5.1.jpg"), require("../assets/guitar-components/reconstone5.2.jpg")]
          },
          {
            prodId: "RC-RSPB-06",
            name: "Recone Stone White With Black Nerves Pen Blank",
            size2: "100% Recone Pen Blank & Turning Blocks",
            images: [require("../assets/guitar-components/reconstone6.1.jpg"), require("../assets/guitar-components/reconstone6.2.jpg")]
          },
        ],
      },

    ],
  },
  //Beads Crafts
  {
    head: "Buffalo Horn Hair Pipe Beads",
    headslug: 'horn-beads',
    dec: "Real buffalo horn hair pipe beads are skillfully handcrafted from genuine buffalo horn, offering a natural, earthy aesthetic. These beads, known for their durability and unique patterns, are ideal for creating distinctive jewelry and accessories. Each bead is meticulously carved to highlight the rich texture and warm tones of the horn, making every piece a one-of-a-kind addition to your collection. Perfect for crafting intricate designs, these beads combine traditional craftsmanship with modern appeal, adding a touch of authenticity and elegance to any creation.",
    mainData: [
      {
        id: 41,
        img: require("../assets/guitar-components/hornbads0.jpg"),
        title: "Horn Hair Beads",
        usbData: [
          {
            prodId: "RC-HHB-01",
            name: "Buffalo Horn Red Strip Beads",
            size1: "All Size available",
            size2: "0.5 inch long",
            images: [require("../assets/guitar-components/hb1.1.jpg"), require("../assets/guitar-components/hb1.2.jpg"), require("../assets/guitar-components/hb1.3.jpg"), require("../assets/guitar-components/hb1.4.jpg")]
          },
          {
            prodId: "RC-HHB-02",
            name: "Buffalo Horn Black Strip Beads",
            size1: "All Size available",
            size2: "0.5 inch long",
            images: [require("../assets/guitar-components/hb2.1.jpg"), require("../assets/guitar-components/hb2.2.jpg"), require("../assets/guitar-components/hb2.3.jpg")]
          },
          {
            prodId: "RC-HHB-03",
            name: "Buffalo Horn Coral-Red strip Beads",
            size1: "All Size available",
            size2: "1 inch long",
            images: [require("../assets/guitar-components/hb3.1.jpg"), require("../assets/guitar-components/hb3.2.jpg"), require("../assets/guitar-components/hb3.3.jpg")]
          },
          {
            prodId: "RC-HHB-04",
            name: "Buffalo Horn Red Strip Beads",
            size1: "All Size available",
            size2: "1 inch long",
            images: [require("../assets/guitar-components/hb4.1.jpg"), require("../assets/guitar-components/hb4.2.jpg"), require("../assets/guitar-components/hb4.3.jpg"), require("../assets/guitar-components/hb4.4.jpg"), require("../assets/guitar-components/hb4.5.jpg")]
          },
          {
            prodId: "RC-HHB-05",
            name: "Buffalo Horn Black Strip Beads",
            size1: "All Size available",
            size2: "1 inch long",
            images: [require("../assets/guitar-components/hb5.1.jpg"), require("../assets/guitar-components/hb5.2.jpg"), require("../assets/guitar-components/hb5.3.jpg"), require("../assets/guitar-components/hb5.4.jpg"), require("../assets/guitar-components/hb5.5.jpg")]
          },
          {
            prodId: "RC-HHB-06",
            name: "Buffalo Horn Gold With Black Strip Beads",
            size1: "All Size available",
            size2: "1 inch long",
            images: [require("../assets/guitar-components/hb6.1.jpg"), require("../assets/guitar-components/hb6.2.jpg"), require("../assets/guitar-components/hb6.3.jpg"), require("../assets/guitar-components/hb6.4.jpg")]
          },
          {
            prodId: "RC-HHB-07",
            name: "Buffalo Horn Gold Strip Beads",
            size1: "All Size available",
            size2: "0.5 inch long",
            images: [require("../assets/guitar-components/hb7.1.jpg"), require("../assets/guitar-components/hb7.2.jpg"), require("../assets/guitar-components/hb7.3.jpg"), require("../assets/guitar-components/hb7.4.jpg")]
          },
          {
            prodId: "RC-HHB-08",
            name: "Buffalo Horn Gold Strip Beads",
            size1: "All Size available",
            size2: "1 inch long",
            images: [require("../assets/guitar-components/hb8.1.jpg"), require("../assets/guitar-components/hb8.2.jpg")]
          },
          {
            prodId: "RC-HHB-09",
            name: "Buffalo Horn Gold Strip Beads",
            size1: "All Size available",
            size2: "1 inch long",
            images: [require("../assets/guitar-components/hb9.1.jpg"), require("../assets/guitar-components/hb9.2.jpg"), require("../assets/guitar-components/hb9.3.jpg")]
          },
          {
            prodId: "RC-HHB-10",
            name: "Buffalo Horn Black Strip Beads",
            size1: "All Size available",
            size2: "1.5 inch long",
            images: [require("../assets/guitar-components/hb10.1.jpg"), require("../assets/guitar-components/hb10.2.jpg")]
          },
          {
            prodId: "RC-HHB-11",
            name: "Buffalo Horn Black Strip Beads",
            size1: "All Size available",
            size2: "1.5 inch long",
            images: [require("../assets/guitar-components/hb11.1.jpg"), require("../assets/guitar-components/hb11.2.jpg")]
          },
          {
            prodId: "RC-HHB-12",
            name: "Buffalo Horn Yellow Strip Beads",
            size1: "All Size available",
            size2: "1.5 inch long",
            images: [require("../assets/guitar-components/hb12.1.jpg"), require("../assets/guitar-components/hb12.2.jpg"), require("../assets/guitar-components/hb12.3.jpg")]
          },
          {
            prodId: "RC-HHB-13",
            name: "Buffalo Horn Yellow Strip Beads",
            size1: "All Size available",
            size2: "1.5 inch long",
            images: [require("../assets/guitar-components/hb13.1.jpg"), require("../assets/guitar-components/hb13.2.jpg"), require("../assets/guitar-components/hb13.3.jpg"), require("../assets/guitar-components/hb13.4.jpg")]
          },
        ],
      },

    ],
  },
  //Bone Beads
  {
    head: "Buffalo Bone Hair Pipe Beads",
    headslug: 'bone-beads',
    dec: "Real bone hair pipe beads are meticulously crafted from authentic bone, offering a unique and natural texture. Each bead is hand-carved to reveal intricate patterns and a warm, organic feel. Ideal for creating distinctive jewelry and accessories, these beads combine traditional craftsmanship with contemporary style. Their durability and unique appearance make them perfect for adding a touch of authenticity and elegance to any design. Each bead is a one-of-a-kind piece, showcasing the artistry and skill involved in transforming natural bone into beautiful, functional adornments.",
    mainData: [
      {
        id: 42,
        img: require("../assets/guitar-components/bonebeads0.jpg"),
        title: "Bone Hair Beads",
        usbData: [
          {
            prodId: "RC-BHB-01",
            name: "pink marble bone hair pipe beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf1.1.jpg"), require("../assets/guitar-components/bhf1.2.jpg"), require("../assets/guitar-components/bhf1.3.jpg"), require("../assets/guitar-components/bhf1.4.jpg")]
          },
          {
            prodId: "RC-BHB-02",
            name: "brown marble bone hair pipe beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf2.1.jpg"), require("../assets/guitar-components/bhf2.2.jpg"), require("../assets/guitar-components/bhf2.3.jpg"), require("../assets/guitar-components/bhf2.4.jpg")]
          },
          {
            prodId: "RC-BHB-03",
            name: "red marble bone hair pipe beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf3.1.jpg"), require("../assets/guitar-components/bhf3.2.jpg"), require("../assets/guitar-components/bhf3.3.jpg"), require("../assets/guitar-components/bhf3.4.jpg")]
          },
          {
            prodId: "RC-BHB-04",
            name: "maroom marble bone hair pipe beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf4.1.jpg"), require("../assets/guitar-components/bhf4.2.jpg"), require("../assets/guitar-components/bhf4.3.jpg")]
          },
          {
            prodId: "RC-BHB-05",
            name: "purple marble bone hair pipe beads",
            size1: "All Size available",
            size2: "2 inch",
            images: [require("../assets/guitar-components/bhf5.1.jpg"), require("../assets/guitar-components/bhf5.2.jpg"), require("../assets/guitar-components/bhf5.3.jpg")]
          },
          {
            prodId: "RC-BHB-06",
            name: "yellow marble bone hair pipe beads",
            size1: "All Size available",
            size2: "1 inch",
            images: [require("../assets/guitar-components/bhf6.1.jpg"), require("../assets/guitar-components/bhf6.2.jpg")]
          },
          {
            prodId: "RC-BHB-07",
            name: "green marble bone hair pipe beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf7.1.jpg"), require("../assets/guitar-components/bhf7.2.jpg"), require("../assets/guitar-components/bhf7.3.jpg"), require("../assets/guitar-components/bhf7.4.jpg")]
          },
          {
            prodId: "RC-BHB-08",
            name: "purple marble bone hair pipe beads",
            size1: "All Size available",
            size2: "1 inch",
            images: [require("../assets/guitar-components/bhf8.1.jpg"), require("../assets/guitar-components/bhf8.2.jpg"), require("../assets/guitar-components/bhf8.3.jpg")]
          },
          {
            prodId: "RC-BHB-09",
            name: "blue bone hair pipe swirl beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf9.1.jpg"), require("../assets/guitar-components/bhf9.2.jpg"), require("../assets/guitar-components/bhf9.3.jpg")]
          },
          {
            prodId: "RC-BHB-10",
            name: " purple marble bone hair pipe beads",
            size1: "All Size available",
            size2: "1.5 inch",
            images: [require("../assets/guitar-components/bhf10.1.jpg"), require("../assets/guitar-components/bhf10.2.jpg"), require("../assets/guitar-components/bhf10.3.jpg")]
          },
          {
            prodId: "RC-BHB-11",
            name: " yellow marble bone hair pipe beads",
            size1: "All Size available",
            size2: "2 inch",
            images: [require("../assets/guitar-components/bhf11.1.jpg"), require("../assets/guitar-components/bhf11.2.jpg"), require("../assets/guitar-components/bhf11.3.jpg")]
          },
          {
            prodId: "RC-BHB-12",
            name: "sky blue Bone Hair Pipe tube Beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf12.1.jpg"), require("../assets/guitar-components/bhf12.2.jpg"), require("../assets/guitar-components/bhf12.3.jpg")]
          },
          {
            prodId: "RC-BHB-13",
            name: "Maroom Bone Hair Pipe tube Beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf13.1.jpg"), require("../assets/guitar-components/bhf13.2.jpg"), require("../assets/guitar-components/bhf13.3.jpg")]
          },
          {
            prodId: "RC-BHB-14",
            name: "black bone hair pipe tube beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf14.1.jpg"), require("../assets/guitar-components/bhf14.2.jpg"), require("../assets/guitar-components/bhf14.3.jpg")]
          },
          {
            prodId: "RC-BHB-15",
            name: "yellow bone hair pipe tube beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf15.1.jpg"), require("../assets/guitar-components/bhf15.2.jpg"), require("../assets/guitar-components/bhf15.3.jpg")]
          },
          {
            prodId: "RC-BHB-16",
            name: "white bone hair pipe tube beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf16.1.jpg"), require("../assets/guitar-components/bhf16.2.jpg"), require("../assets/guitar-components/bhf16.3.jpg")]
          },
          {
            prodId: "RC-BHB-17",
            name: "Dark Cofee with Ivory Color Beads",
            size1: "All Size available",
            size2: "1 inch",
            images: [require("../assets/guitar-components/bhf17.1.jpg"), require("../assets/guitar-components/bhf17.2.jpg"), require("../assets/guitar-components/bhf17.3.jpg"), require("../assets/guitar-components/bhf17.4.jpg")]
          },

        ],
      },
      {
        id: 43,
        img: require("../assets/guitar-components/bhf29.1.jpg"),
        title: "Native American Beads",
        usbData: [
          {
            prodId: "RC-NAB-01",
            name: "Wavy Line & Dots White & Black Rondelle Spacers Bone Beads",
            size1: "8mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf18.jpg")]
          },
          {
            prodId: "RC-NAB-02",
            name: "Cylindrical Beads Pink",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf19.jpg")]
          },
          {
            prodId: "RC-NAB-03",
            name: "Orange Bone Beads: Silver Black Spot Rondelle Spacers",
            size1: "6x5mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf20.jpg")]
          },
          {
            prodId: "RC-NAB-04",
            name: "X on Fire : Red, White & Black Round Bone Beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf21.jpg")]
          },
          {
            prodId: "RC-NAB-05",
            name: "Speckled Rondelle Bone Beads",
            size1: "5x4mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf22.jpg")]
          },
          {
            prodId: "RC-NAB-06",
            name: "Bone Spacer Beads Turquoise Tube Shaped",
            size1: " 5x4mm ",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf23.jpg")]
          },
          {
            prodId: "RC-NAB-07",
            name: "Bone Spacer Beads Purple Tube Shaped",
            size1: "5x4mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf24.jpg")]
          },
          {
            prodId: "RC-NAB-08",
            name: "Hand Carved Melon Bone Beads, Boho Yoga Jewelry Making Supplies",
            size1: " 11x9mm (24 Beads)",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf25.jpg")]
          },
          {
            prodId: "RC-NAB-09",
            name: "Hand Carved Target Bone Beads Rondelle Spacers",
            size1: "11x9mm (24 Beads)",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf26.jpg")]
          },
          {
            prodId: "RC-NAB-10",
            name: "Hand-Carved Skull Bone Beads: Cobalt Blue Sugar Skulls",
            size1: " All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf27.jpg")]
          },
          {
            prodId: "RC-NAB-11",
            name: "Earthy Carved Bone Beads Spacers, Saucer Rondelles (Cornflower)",
            size1: " 7mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf28.jpg")]
          },
          {
            prodId: "RC-NAB-12",
            name: "Bone heishi beads from India in bright jazzy colours! 22 strand (8 colours!)",
            size1: " 7mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf29.jpg"), require("../assets/guitar-components/bhf29.1.jpg")]
          },
          {
            prodId: "RC-NAB-13",
            name: "Hand-Carved Skull Bone Beads Natural Cream Sugar Skulls",
            size1: "9x15mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf30.jpg")]
          },
          {
            prodId: "RC-NAB-14",
            name: "Pink & Black Serration Hand Carved Bone Beads",
            size1: "10x3mm (68+ Pieces)",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf31.jpg")]
          },
          {
            prodId: "RC-NAB-15",
            name: "Unknown Name",
            size1: "10x3mm (68+ Pieces)",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf32.1.jpg"), require("../assets/guitar-components/bhf32.2.jpg"), require("../assets/guitar-components/bhf32.3.jpg")]
          },
          {
            prodId: "RC-NAB-16",
            name: "Brown bone beads in rich shades",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf33.1.jpg"), require("../assets/guitar-components/bhf33.2.jpg")]
          },
          {
            prodId: "RC-NAB-17",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf34.1.jpg"), require("../assets/guitar-components/bhf34.2.jpg")]
          },
          {
            prodId: "RC-NAB-18",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf35.jpg")]
          },
          {
            prodId: "RC-NAB-19",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf36.jpg")]
          },
          {
            prodId: "RC-NAB-20",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf37.1.jpg"), require("../assets/guitar-components/bhf37.2.jpg")]
          },
          {
            prodId: "RC-NAB-21",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf38.jpg")]
          },
          {
            prodId: "RC-NAB-22",
            name: "White Ivory Ox Bone Round Rondelle Beads",
            size1: "3mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf39.jpg")]
          },
          {
            prodId: "RC-NAB-23",
            name: "Carved Ox Bone Rondelle Beads | Slash Carved Bone Beads | Medium Brown",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf40.jpg")]
          },
          {
            prodId: "RC-NAB-24",
            name: "Carved Ox Bone Rondelle Beads | White Slash Carved Bone Beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf41.jpg")]
          },
          {
            prodId: "RC-NAB-25",
            name: "Carved Ox Bone Rondelle Beads | Slash Carved Bone Beads | White Light Brown",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf42.jpg")]
          },
          {
            prodId: "RC-NAB-26",
            name: "Ox bone beads, jewelry making beads, white",
            size1: "10mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf43.jpg")]
          },
          {
            prodId: "RC-NAB-27",
            name: "Ox brown bone beads, jewelry making beads",
            size1: "10mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf44.jpg")]
          },
          {
            prodId: "RC-NAB-28",
            name: "Comma Barrel: Black & White Hand Painted Bone Beads",
            size1: "6x8mm (22pieces)",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf46.jpg")]
          },
          {
            prodId: "RC-NAB-29",
            name: "Cobalt X: Hand Carved Bone Beads",
            size1: "8x6mm (22pieces)",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf47.jpg")]
          },
          {
            prodId: "RC-NAB-30",
            name: "Cornflower Blue Gold Line Barrel: Bone Beads",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf48.jpg")]
          },
          {
            prodId: "RC-NAB-31",
            name: "Cream Discs: Bone Beads",
            size1: "5×2.5mm (80pieces)",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf49.jpg")]
          },
          {
            prodId: "RC-NAB-32",
            name: "Burgundy Ladybug: Polka Dotted Maroon Bone Beads",
            size1: "8×6mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf50.jpg")]
          },
          {
            prodId: "RC-NAB-33",
            name: "White & Black Infinity Circles: Handmade Bone Beads",
            size1: "8×6mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf51.jpg")]
          },
          {
            prodId: "RC-NAB-34",
            name: "Earthy Carved Bone Beads, Boho Spacers, Saucer Rondelles (Marmalade)",
            size1: "7mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf52.jpg")]
          },
          {
            prodId: "RC-NAB-35",
            name: "Earthy Carved Bone Beads, Boho Spacers, Saucer Rondelles (Oat)",
            size1: "7mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf53.jpg")]
          },
          {
            prodId: "RC-NAB-36",
            name: "Earthy Carved Bone Beads, Boho Spacers, Saucer Rondelles (Sage)",
            size1: "7mm",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf54.jpg")]
          },
          {
            prodId: "RC-NAB-37",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf55.jpg")]
          },
          {
            prodId: "RC-NAB-38",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf56.jpg")]
          },
          {
            prodId: "RC-NAB-39",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf57.jpg")]
          },
          {
            prodId: "RC-NAB-40",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf58.jpg")]
          },
          {
            prodId: "RC-NAB-41",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf59.jpg")]
          },
          {
            prodId: "RC-NAB-42",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf60.jpg")]
          },
          {
            prodId: "RC-NAB-43",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf61.jpg")]
          },
          {
            prodId: "RC-NAB-44",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf62.jpg")]
          },
          {
            prodId: "RC-NAB-45",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf63.jpg")]
          },
          {
            prodId: "RC-NAB-46",
            name: "Unknown Name",
            size1: "All Size available",
            size2: "All Size available",
            images: [require("../assets/guitar-components/bhf64.jpg")]
          },
        ],
      },
    ],
  },
  //Dominoies
  {
    head: "Dominoes Set",
    headslug: 'dominoes-set',
    dec: "Many folks have asked us to expand our original 6x6 Dominos game into a 9x9 configuration and we aim the please! In this edition we added 27 new tiles (for a total of 55 hand carved dominos/set) essentially doubling the amount of dominos/set. Made from ethically sourced cow/buffalo bone, these dominos are travel sized slightly smaller than modern day but more accurate to how they would have been sized in the past. Each features a polished bone surface with a spot in circle motif that has been found in Viking and Roman games historically; and as far as we know is unique to our shop. The dominos are approx 1.25 x 0.6. Please note since they are made from natural bone and not machine made, each domino has slight differences in color/texture etc, but we like to think this makes the set more authentic to how it would have been hundreds of years ago.",
    mainData: [
      {
        id: 44,
        img: require("../assets/guitar-components/baffalohorndominoesfront1.png"),
        title: "Buffalo Horn Dominoes",
        wsize: ["Real Buffalo horn black Dominoes Set- 28 Piece Double-Six Ivory Domino Tiles Set without spinner, Classic Numbers Table Game with black horn Carrying/Storage Case by Hey! Play! (2-4 Players)", " 48 mm long x 23 mm wide x 8 mm", "thickness,(in inches 1.899″ x .930″ x.318″)", "48 mm long x 23 mm wide x  6 mm", "thickness (in Inches  1.899″ x .930″ x1/4″)", "48 mm long x 23 mm wide x  4.5 mm", "thickness (in Inches  1.899″ x .930″ x 3/16″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-BHDS-01",
            name: "Buffalo horn black Dominoes",
            size2: "100% Buffalo Horn Dominoes",
            images: [require("../assets/guitar-components/baffalohorndominoesfront2.png.png"), require("../assets/guitar-components/baffalohorndominoesfront1.png"), require("../assets/guitar-components/baffalohorndominoesfront2.11.jpg")]
          },


        ],
      },
      {
        id: 45,
        img: require("../assets/guitar-components/civilwar0.jpg"),
        title: "Civil War Bone Dominoes",
        wsize: ["Original antique set of civil war era dominoes with brass spinners c1865.", "Each domino has an ebony base with a bovine bone top.", "The set is complete with 28 dominoes in very good condition.", " 48 mm long x 23 mm wide x 8 mm", "thickness,(in inches 1.899″ x .930″ x.318″)", "48 mm long x 23 mm wide x  6 mm", "thickness (in Inches  1.899″ x .930″ x1/4″)", "48 mm long x 23 mm wide x  4.5 mm", "thickness (in Inches  1.899″ x .930″ x 3/16″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CWBD-01",
            name: "Civil War Era Bone Dominoes",
            size2: "100% Bone Dominoes",
            images: [require("../assets/guitar-components/civilwar1.jpg"), require("../assets/guitar-components/civilwar2.jpg"), require("../assets/guitar-components/civilwar3.jpg")]
          },

        ],
      },
      {
        id: 46,
        img: require("../assets/guitar-components/camelbone1.jpg"),
        title: "Camel Bone Dominoes ",
        wsize: ["Real Camel Bone Ivory Dominoes Set- 28 Piece Double-Six Ivory Domino Tiles Set with metal Spinners, Classic Numbers Table Game with white Perl Intimation ivory Resin Carrying/Storage Case by Hey! Play! (2-4 Players)", " 48 mm long x 23 mm wide x 8 mm", "thickness,(in inches 1.899″ x .930″ x.318″)", "48 mm long x 23 mm wide x  6 mm", "thickness (in Inches  1.899″ x .930″ x1/4″)", "48 mm long x 23 mm wide x  4.5 mm", "thickness (in Inches  1.899″ x .930″ x 3/16″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CBDS-01",
            name: "Spinner Doted Camel Bone Dominoes",
            size2: "100% Bone Dominoes",
            images: [require("../assets/guitar-components/camelbone1.jpg"), require("../assets/guitar-components/camelbone2.jpg")]
          },
          {
            prodId: "RC-CBDS-02",
            name: "Plan Camel Bone Dominoes",
            size2: "100% Bone Dominoes",
            images: [require("../assets/guitar-components/camelbone3.jpg"), require("../assets/guitar-components/camelbone4.jpg")]
          },
          {
            prodId: "RC-CBDS-03",
            name: "Roman Style Camel Bone Dominoes",
            size2: "100% Bone Dominoes",
            images: [require("../assets/guitar-components/camelbone5.jpg"), require("../assets/guitar-components/camelbone6.jpg"), require("../assets/guitar-components/camelbone6.11.jpg"), require("../assets/guitar-components/camelbone6.22.jpg")]
          },

        ],
      },

      {
        id: 47,
        img: require("../assets/guitar-components/dominoes00.png"),
        title: "Medieval Bone & Horn Dominoes",
        wsize: ["The dominos are approx 1.25x0.6.", "Set Of dominoes double six(28 Pieces) and dominoes double nine(55 Pieces).", "Ethically Sourced: Made from ethically sourced buffalo bone, ensuring a guilt-free gaming experience.", " 48 mm long x 23 mm wide x 8 mm", "thickness,(in inches 1.899″ x .930″ x.318″)", "48 mm long x 23 mm wide x  6 mm", "thickness (in Inches  1.899″ x .930″ x1/4″)", "48 mm long x 23 mm wide x  4.5 mm", "thickness (in Inches  1.899″ x .930″ x 3/16″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-MBDS-01",
            name: "Medieval Bone Dominoes Set (Double six)",
            size2: "100% Buffalo Bone Dominoes",
            images: [require("../assets/guitar-components/mbdsimg1.png"), require("../assets/guitar-components/mbdsimg2.png"), require("../assets/guitar-components/mbdsimg3.png"), require("../assets/guitar-components/mbdsimg4.png")]
          },
          {
            prodId: "RC-MHDS-02",
            name: "Medieval Horn Dominoes 28pcs Set (Double six)",
            size2: "100% Buffalo Horn Dominoes",
            images: [require("../assets/guitar-components/bhmd1.png"), require("../assets/guitar-components/bhmd11.png"),]
          },
          {
            prodId: "RC-MHDS-03",
            name: "Medieval Horn Dominoes Set (Double nine)",
            size2: "100% Buffalo Horn Dominoes",
            images: [require("../assets/guitar-components/bhdmn1.png"), require("../assets/guitar-components/bhmdn2.png"), require("../assets/guitar-components/bhdn333.jpg")]
          },
        ],
      },
      {
        id: 471,
        img: require("../assets/guitar-components/pwdhome1.jpg"),
        title: "Buffalo Horn Natural Brunt Dominoes",
        wsize: ["The dominos are approx 1.25x0.6.", "Set Of dominoes double six(28 Pieces) and dominoes double nine(55 Pieces).", "Ethically Sourced: Made from ethically sourced buffalo bone, ensuring a guilt-free gaming experience.", " 48 mm long x 23 mm wide x 8 mm", "thickness,(in inches 1.899″ x .930″ x.318″)", "48 mm long x 23 mm wide x  6 mm", "thickness (in Inches  1.899″ x .930″ x1/4″)", "48 mm long x 23 mm wide x  4.5 mm", "thickness (in Inches  1.899″ x .930″ x 3/16″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-BHNBDS-01",
            name: "Buffalo Horn Natural Brunt Dominoes",
            size2: "100% Buffalo Horn Dominoes",
            images: [require("../assets/guitar-components/pwdhome1.jpg")]
          },
        ],
      },
      {
        id: 472,
        img: require("../assets/guitar-components/umbd01.png"),
        title: "Unique Medieval Bone Dominoes",
        size2: "100% Bone Dominoes",
        wsize: ["The dominos are approx 1.25x0.6.", "Set Of dominoes double six(28 Pieces) and dominoes double nine(55 Pieces).", "Ethically Sourced: Made from ethically sourced buffalo bone, ensuring a guilt-free gaming experience.", " 48 mm long x 23 mm wide x 8 mm", "thickness,(in inches 1.899″ x .930″ x.318″)", "48 mm long x 23 mm wide x  6 mm", "thickness (in Inches  1.899″ x .930″ x1/4″)", "48 mm long x 23 mm wide x  4.5 mm", "thickness (in Inches  1.899″ x .930″ x 3/16″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-UMBDS-01",
            name: "Unique Medieval Bone Domino Set(Double nine)",
            size2: "100% Buffalo Dominoes",
            images: [require("../assets/guitar-components/umbd01.png")]
          },
          {
            prodId: "RC-UMBDS-02",
            name: "Unique Medieval Bone Domino Set(Double six)",
            size2: "100% Buffalo Dominoes",
            images: [require("../assets/guitar-components/umbd02.png")]
          },
        ],
      },
    ],
  },
  //Horn Shoe Horn
  {
    head: "Shoe Horn",
    headslug: 'shoe-horn',
    dec: "Easily adjust the fit of your shoes with our premium animal horn shoe trees. Our skilled craftsmen have made these shoe trees using sustainably sourced animal horn, which helps your shoes to be easily put on and taken off. Whether your shoes are of any style, our shoe tree fits perfectly with them and takes care of your shoes.",
    mainData: [
      {
        id: 48,
        img: require("../assets/guitar-components/horn-shoe-horn2.jpg"),
        title: "Horn Shoe Horn",
        usbData: [
          {
            prodId: "RC-HSH-01",
            name: "Little Shoe Horn Vintage Black Shades With Leather Chord",
            size1: "150mm, 200mm, 330mm, 400mm",
            size2: "6inch, 8inch, 13inch, 16inch",
            images: [require("../assets/guitar-components/horn-shoe-horn1.jpg"), require("../assets/guitar-components/horn-shoe-horn2.jpg")]
          },
          {
            prodId: "RC-HSH-02",
            name: "Straight Shoe Horn With Leather Chord",
            size1: "150mm, 200mm, 330mm, 400mm",
            size2: "6inch, 8inch, 13inch, 16inch",
            images: [require("../assets/guitar-components/horn-shoe-horn3.jpg"), require("../assets/guitar-components/horn-shoe-horn4.jpg")]
          },
          {
            prodId: "RC-HSH-03",
            name: "Straight Shoe Horn Made with Real Horn Handmade",
            size1: "330mm, 400mm",
            size2: "13inch, 16inch",
            images: [require("../assets/guitar-components/horn-shoe-horn5.jpg"), require("../assets/guitar-components/horn-shoe-horn6.jpg")]
          },
          {
            prodId: "RC-HSH-04",
            name: "straight shoe horn black color with real horn handmade",
            size1: "330mm, 400mm",
            size2: " 13inch, 16inch",
            images: [require("../assets/guitar-components/horn-shoe-horn7.jpg"), require("../assets/guitar-components/horn-shoe-horn8.jpg")]
          },
          {
            prodId: "RC-HSH-05",
            name: "Black Shoe Horn With Leather Chord",
            size1: " 330mm, 400mm",
            size2: " 13inch, 16inch",
            images: [require("../assets/guitar-components/horn-shoe-horn12.jpg")]
          },
        ],
      },
      {
        id: 49,
        img: require("../assets/guitar-components/horn-shoe-horn9.jpg"),
        title: "Wood Shoe Horn",
        usbData: [
          {
            prodId: "RC-WSH-01",
            name: "Walnut Wood Shoe Horn",
            size1: "330mm, 400mm",
            size2: "13inch, 16inch",
            images: [require("../assets/guitar-components/horn-shoe-horn9.jpg"), require("../assets/guitar-components/horn-shoe-horn10.jpg"), require("../assets/guitar-components/horn-shoe-horn11.jpg")]
          },
          {
            prodId: "RC-WSH-02",
            name: "Ebony Wood Shoe Horn With Leather Chord",
            size1: "330mm, 400mm",
            size2: "13inch, 16inch",
            images: [require("../assets/guitar-components/woodshoehorn5.jpg")]
          },
          {
            prodId: "RC-WSH-03",
            name: "Rose Wood Shoe Horn One Point",
            size1: "330mm, 400mm",
            size2: "13inch, 16inch",
            images: [require("../assets/guitar-components/woodshoehorn6.jpg")]
          },
        ],
      },
      {
        id: 50,
        img: require("../assets/guitar-components/manwithhorn.jpg"),
        title: "Bone Shoe Horn",
        usbData: [
          {
            prodId: "RC-BSH-01",
            name: "Shoehorn made with genuine horn and bone Long Handle",
            size1: "All size available",
            size2: " 17inch",
            images: [require("../assets/guitar-components/boneshoehorn1.jpg")]
          },
          {
            prodId: "RC-BSH-02",
            name: "White Bone Shoe Horn With Square Chord",
            size1: "All size available",
            size2: "10″(Inch), 8″(Inch), 7″(Inch)",
            images: [require("../assets/guitar-components/boneshoehorn2.jpg"), require("../assets/guitar-components/boneshoehorn2.1.jpg"), require("../assets/guitar-components/boneshoehorn2.2.jpg"), require("../assets/guitar-components/boneshoehorn2.3.jpg")]
          },
          {
            prodId: "RC-BSH-03",
            name: "Green Bone Shoe Horn With Square Chord",
            size1: "All size available",
            size2: "10″(Inch), 8″(Inch), 7″(Inch)",
            images: [require("../assets/guitar-components/boneshoehorn3.1.jpg"), require("../assets/guitar-components/boneshoehorn3.2.jpg"), require("../assets/guitar-components/boneshoehorn3.3.jpg"), require("../assets/guitar-components/boneshoehorn3.4.jpg")]
          },
          {
            prodId: "RC-BSH-04",
            name: "Black Bone Shoe Horn With Square Chord",
            size1: "All size available",
            size2: "10″(Inch), 8″(Inch), 7″(Inch)",
            images: [require("../assets/guitar-components/boneshoehorn4.1.jpg"), require("../assets/guitar-components/boneshoehorn4.2.jpg"), require("../assets/guitar-components/boneshoehorn4.3.jpg"), require("../assets/guitar-components/boneshoehorn4.4.jpg")]
          },
        ],
      },
    ],
  },

  //Bone clasp
  {
    head: "Bone Clasp",
    headslug: 'bone-clasp',
    dec: "Bone clasps are useful to add the finishing touch to Japanese bookbinding styles and can be used in creative ways. These genuine bone clasps are one inch in length and come in a package of 12.",
    mainData: [
      {
        id: 51,
        img: require("../assets/guitar-components/boneclasp0.jpg"),
        title: "Bone Clasp",
        wsize: ["Bone clasps are useful to add the finishing touch to Japanese bookbinding styles and can be used in creative ways. These genuine bone clasps are one inch in length and come in a package of 12.", "2,1 cm – 21.42 mm – 7/8 Inch", " 2,6 cm – 26.52 mm – 1 Inch", "3,4 cm – 34.68 mm – 1-3/8 inch", "4 cm – 40.8 mm – 1-1/2 Inch", "Made In India", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-BC-01",
            name: "Small White Bone Clasp",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp1.jpg"), require("../assets/guitar-components/boneclasp2.jpg"), require("../assets/guitar-components/boneclasp3.jpg")]
          },
          {
            prodId: "RC-BC-02",
            name: "Dyed Red Brownish Bone Clasp",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp4.jpg"), require("../assets/guitar-components/boneclasp5.jpg")]
          },
          {
            prodId: "RC-BC-03",
            name: "Dyed Green Bone Clasp",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp6.jpg"), require("../assets/guitar-components/boneclasp7.jpg"), require("../assets/guitar-components/boneclasp8.jpg")]
          },
          {
            prodId: "RC-BC-04",
            name: "Dyed Denim Blue Bone Clasp",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp9.jpg"), require("../assets/guitar-components/boneclasp9.1.jpg")]
          },
          {
            prodId: "RC-BC-05",
            name: "Dyed Pink Bone Clasp",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp10.jpg"), require("../assets/guitar-components/boneclasp10.1.jpg")]
          },
          {
            prodId: "RC-BC-06",
            name: "Dyed African Violet Bone Clasps",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp11.jpg"), require("../assets/guitar-components/boneclasp11.1.jpg"), require("../assets/guitar-components/boneclasp11.2.jpg"), require("../assets/guitar-components/boneclasp11.3.jpg")]
          },
          {
            prodId: "RC-BC-07",
            name: "Dyed Dark Blue Bone Clasp",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp12.jpg"), require("../assets/guitar-components/boneclasp12.1.jpg")]
          },
          {
            prodId: "RC-BC-08",
            name: "Dyed Grey Bone Clasp",
            size2: "100% Original Bone Craft",
            images: [require("../assets/guitar-components/boneclasp13.jpg"), require("../assets/guitar-components/boneclasp13.1.jpg")]
          },
        ],
      },

    ],
  },

  //stag bone button
  {
    head: "Stag Bone Button",
    headslug: 'stag-bone-button',
    dec: "We offer a range of stag bone buttons in different sizes and shapes to suit your specific needs. From small shank buttons to large flat buttons, we have something for everyone. Whether you're looking to add a subtle touch to a bespoke suit or create a statement piece with a bold, oversized button, our stag bone buttons are the perfect choice. With our wide selection, you're sure to find the perfect button to elevate your design and make it truly unforgettable",
    mainData: [
      {
        id: 52,
        img: require("../assets/guitar-components/bonebtn0.jpg"),
        title: "Stag Bone Button",
        wsize: ["12L- 07.65 mm(0.30 inch) And 14L- 08.90 mm(0.35 inch)", " 16L- 10.20 mm(0.40 inch) And 18L- 11.40 mm(0.45 inch)", "20L- 12.70 mm(0.50 inch) And 22L- 14.00 mm(0.55 inch)", "24L- 15.30 mm(0.60 inch) And 26L- 16.50 mm(0.65 inch)", "28L- 17.80 mm(0.70 inch) And 30L- 19.10 mm(0.75 inch)", "32L- 20.40 mm(0.80 inch) And 34L- 21.60 mm(0.85 inch)", "36L- 22.90 mm(0.90 inch) And 38L- 24.20 mm(0.95 inch)", "40L- 25.40 mm(1.00 inch) And 42L- 26.70 mm(1.05 inch)", "44L- 28.00 mm(1.10 inch) And 46L- 29.30 mm(1.15 inch)", "48L- 30.60 mm(1.20 inch) And 50L- 31.90 mm(1.25 inch)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-SBB-01",
            // name: "Small White Bone Clasp",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn1.jpg"), require("../assets/guitar-components/bonebtn2.jpg")]
          },
          {
            prodId: "RC-SBB-02",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn3.jpg"), require("../assets/guitar-components/bonebtn4.jpg"), require("../assets/guitar-components/bonebtn5.jpg")]
          },
          {
            prodId: "RC-SBB-03",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn6.jpg"), require("../assets/guitar-components/bonebtn7.jpg"), require("../assets/guitar-components/bonebtn8.jpg")]
          },
          {
            prodId: "RC-SBB-04",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn9.jpg"), require("../assets/guitar-components/bonebtn10.jpg"), require("../assets/guitar-components/bonebtn11.jpg"), require("../assets/guitar-components/bonebtn12.jpg")]
          },
          {
            prodId: "RC-SBB-05",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn13.jpg"), require("../assets/guitar-components/bonebtn14.jpg"), require("../assets/guitar-components/bonebtn15.jpg")]
          },
          {
            prodId: "RC-SBB-06",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn16.jpg"), require("../assets/guitar-components/bonebtn17.jpg"), require("../assets/guitar-components/bonebtn18.jpg")]
          },
          {
            prodId: "RC-SBB-07",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn19.jpg"), require("../assets/guitar-components/bonebtn20.jpg"), require("../assets/guitar-components/bonebtn21.jpg")]
          },
          {
            prodId: "RC-SBB-08",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn22.jpg"), require("../assets/guitar-components/bonebtn23.jpg"), require("../assets/guitar-components/bonebtn24.jpg")]
          },
          {
            prodId: "RC-SBB-09",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn25.jpg"), require("../assets/guitar-components/bonebtn26.jpg"), require("../assets/guitar-components/bonebtn27.jpg")]
          },
          {
            prodId: "RC-SBB-10",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn28.jpg"), require("../assets/guitar-components/bonebtn29.jpg"), require("../assets/guitar-components/bonebtn30.jpg"), require("../assets/guitar-components/bonebtn31.jpg")]
          },
          {
            prodId: "RC-SBB-11",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn33.jpg"), require("../assets/guitar-components/bonebtn34.jpg"), require("../assets/guitar-components/bonebtn35.jpg")]
          },
          {
            prodId: "RC-SBB-12",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn36.jpg"), require("../assets/guitar-components/bonebtn37.jpg"), require("../assets/guitar-components/bonebtn38.jpg"), require("../assets/guitar-components/bonebtn39.jpg")]
          },
          {
            prodId: "RC-SBB-13",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn40.jpg"), require("../assets/guitar-components/bonebtn41.jpg"), require("../assets/guitar-components/bonebtn42.jpg")]
          },
          {
            prodId: "RC-SBB-14",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn43.jpg"), require("../assets/guitar-components/bonebtn44.jpg"), require("../assets/guitar-components/bonebtn45.jpg"), require("../assets/guitar-components/bonebtn46.jpg")]
          },
          {
            prodId: "RC-SBB-15",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn47.jpg"), require("../assets/guitar-components/bonebtn49.jpg"), require("../assets/guitar-components/bonebtn50.jpg"), require("../assets/guitar-components/bonebtn51.jpg")]
          },
          {
            prodId: "RC-SBB-16",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn52.jpg"), require("../assets/guitar-components/bonebtn53.jpg"), require("../assets/guitar-components/bonebtn54.jpg")]
          },
          {
            prodId: "RC-SBB-17",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn55.jpg"), require("../assets/guitar-components/bonebtn56.jpg"), require("../assets/guitar-components/bonebtn57.jpg"), require("../assets/guitar-components/bonebtn58.jpg")]
          },
          {
            prodId: "RC-SBB-18",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn59.jpg"), require("../assets/guitar-components/bonebtn60.jpg"), require("../assets/guitar-components/bonebtn61.jpg"), require("../assets/guitar-components/bonebtn62.jpg")]
          },
          {
            prodId: "RC-SBB-19",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn63.jpg"), require("../assets/guitar-components/bonebtn64.jpg"), require("../assets/guitar-components/bonebtn65.jpg"), require("../assets/guitar-components/bonebtn66.jpg")]
          },
          {
            prodId: "RC-SBB-20",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn67.jpg"), require("../assets/guitar-components/bonebtn68.jpg"), require("../assets/guitar-components/bonebtn69.jpg"), require("../assets/guitar-components/bonebtn70.jpg"), require("../assets/guitar-components/bonebtn71.jpg"), require("../assets/guitar-components/bonebtn72.jpg"), require("../assets/guitar-components/bonebtn73.jpg")]
          },
          {
            prodId: "RC-SBB-21",
            size2: "100% Buffalo Bone button",
            images: [require("../assets/guitar-components/bonebtn74.jpg")]
          },
        ],
      },

    ],
  },

  // Viking Craft
  // Bone Dice
  {
    head: "Bone Dice",
    headslug: 'bone-dice',
    dec: "Bone dice are crafted from genuine camel bone, offering a unique and eco-friendly gaming experience. Available in various colors, these natural dice are a perfect addition to any tabletop game. Their earthy tone and organic texture evoke a sense of nostalgia and connection to nature. Each die is carefully handcrafted to ensure a precise roll, making every game a thrilling experience. The natural imperfections of the bone add character to each die, making them a true collector's item for gamers and nature enthusiasts alike.",
    mainData: [
      {
        id: 53,
        img: require("../assets/guitar-components/bone-dice3.3.jpg"),
        title: "Bone Dice",
        wsize: ["8mm x 8mm", "10mm x 10mm", "11mm x 11mm", "12mm x 12mm", "14mm x 14  mm", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "BD-RC-01",
            name: "Roman Style White Dyed Bone Dice with Black Circle Dots",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice1.1.jpg"), require("../assets/guitar-components/bone-dice1.2.jpg"), require("../assets/guitar-components/bone-dice1.3.jpg"), require("../assets/guitar-components/bone-dice1.4.jpg")]
          },
          {
            prodId: "BD-RC-02",
            name: "Roman Style White Dyed Bone Dice with Black Dots",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice2.jpg")]
          },
          {
            prodId: "BD-RC-03",
            name: "Roman Style White Dyed Bone Dice with Black and Brown Dots",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice3.1.jpg"), require("../assets/guitar-components/bone-dice3.2.jpg"), require("../assets/guitar-components/bone-dice3.3.jpg")]
          },
          {
            prodId: "BD-RC-04",
            name: "White Dyed Bone Dice with Black Dots",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice4.1.jpg"), require("../assets/guitar-components/bone-dice4.2.jpg"), require("../assets/guitar-components/bone-dice4.3.jpg")]
          },
          {
            prodId: "BD-RC-05",
            name: "Bone Dice Roman style old Vinatge brown",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice5.jpg")]
          },
          {
            prodId: "BD-RC-06",
            name: "Bone dice Roman style Dark Brown",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice6.jpg")]
          },
          {
            prodId: "BD-RC-07",
            name: "Bone dice Roman style light Red",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice7.jpg")]
          },
          {
            prodId: "BD-RC-08",
            name: "Bone dice Roman style Blood red",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice8.jpg")]
          },
          {
            prodId: "BD-RC-09",
            name: "Bone dice Roman style yellow",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice9.jpg")]
          },
          {
            prodId: "BD-RC-10",
            name: "Bone dice navy blue roman style",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice10.jpg")]
          },
          {
            prodId: "BD-RC-11",
            name: "Bone Dice Roman style Green",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice11.jpg")]
          },
          {
            prodId: "BD-RC-12",
            name: "Bone Dice civil war Vintage",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice12.jpg")]
          },
          {
            prodId: "BD-RC-13",
            name: "Bone Dice Roman style Orange",
            size2: "100% Original Bone Dice",
            images: [require("../assets/guitar-components/bone-dice13.jpg")]
          },
        ],
      },

    ],
  },

  // Bone comb
  {
    head: "Viking Combs",
    headslug: 'viking-combs',
    dec: "Experience the ancient art of Viking grooming with our handcrafted bone combs. Made from 100% organic resins, these combs feature seamless teeth, handles, and tails for effortless detangling and styling. Anti-static and heat resistant, they prevent split ends and add shine to your locks. Embrace the traditional Viking way of hair care with our premium bone combs, perfect for both everyday use and special occasions.",
    mainData: [
      {
        id: 555,
        img: require("../assets/guitar-components/vikingcomb-home.jpg"),
        title: "Viking Comb",
        wsize: ["3.5″ Inch (Long)", "3″ Inch", "4″ Inch (Long)", "7″ Inch (Long)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "VC-RC-01",
            name: "Folding Viking Bone Comb With Case",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/viking-comb1.1.jpg"), require("../assets/guitar-components/viking-comb1.2.jpg")]
          },
          {
            prodId: "VC-RC-02",
            name: "Curved Holding Viking Bone Comb",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/viking-comb2.1.jpg"), require("../assets/guitar-components/viking-comb2.2.jpg")]
          },
          {
            prodId: "VC-RC-03",
            name: "Both Side Teeth Viking Bone Comb",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/viking-comb3.1.jpg"), require("../assets/guitar-components/viking-comb3.2.jpg")]
          },
          {
            prodId: "VC-RC-04",
            name: "Tri Angle Head Holding Viking Bone Comb",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/viking-comb4.1.jpg")]
          },
          {
            prodId: "VC-RC-05",
            name: "Dou Straight Head Viking Bone Comb",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/viking-comb5.jpg")]
          },
        ],
      },
      {
        id: 54,
        img: require("../assets/guitar-components/bone-combs11.jpg"),
        title: "Bone Comb",
        wsize: ["3.5″ Inch (Long)", "3″ Inch", "4″ Inch (Long)", "7″ Inch (Long)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "BC-RC-01",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb1.1.jpg"), require("../assets/guitar-components/bone-comb1.2.jpg")]
          },
          {
            prodId: "BC-RC-02",
            name: "Tri Angle Head Holding Viking Bone Comb",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb3.1.jpg"), require("../assets/guitar-components/bone-comb3.2.jpg"), require("../assets/guitar-components/bone-comb3.3.jpg"), require("../assets/guitar-components/bone-comb3.4.jpg")]
          },
          {
            prodId: "BC-RC-03",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb4.1.jpg"), require("../assets/guitar-components/bone-comb4.2.jpg")]
          },
          {
            prodId: "BC-RC-04",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb5.1.jpg"), require("../assets/guitar-components/bone-comb5.2.jpg")]
          },
          {
            prodId: "BC-RC-05",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb6.1.jpg"), require("../assets/guitar-components/bone-comb6.2.jpg")]
          },
          {
            prodId: "BC-RC-06",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb7.1.jpg"), require("../assets/guitar-components/bone-comb7.3.jpg")]
          },
          {
            prodId: "BC-RC-07",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-combnew.jpg"), require("../assets/guitar-components/bone-comb8.2.jpg")]
          },
          {
            prodId: "BC-RC-08",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb9.1.jpg"), require("../assets/guitar-components/bone-comb9.2.jpg"), require("../assets/guitar-components/bone-comb9.3.jpg")]
          },
          {
            prodId: "BC-RC-09",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb10.1.jpg"), require("../assets/guitar-components/bone-comb10.2.jpg"), require("../assets/guitar-components/bone-comb10.3.jpg"), require("../assets/guitar-components/bone-comb10.4.jpg")]
          },
          {
            prodId: "BC-RC-10",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb11.1.jpg"), require("../assets/guitar-components/bone-comb11.2.jpg"), require("../assets/guitar-components/bone-comb11.3.jpg")]
          },
          {
            prodId: "BC-RC-11",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb12.1.jpg"), require("../assets/guitar-components/bone-comb12.2.jpg")]
          },
          {
            prodId: "BC-RC-12",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb13.1.jpg"), require("../assets/guitar-components/bone-comb13.2.jpg"), require("../assets/guitar-components/bone-comb13.3.jpg"), require("../assets/guitar-components/bone-comb13.4.jpg")]
          },
          {
            prodId: "BC-RC-13",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb14.1.jpg"), require("../assets/guitar-components/bone-comb14.2.jpg"), require("../assets/guitar-components/bone-comb14.4.jpg"), require("../assets/guitar-components/bonecomblass.jpg")]
          },
          {
            prodId: "BC-RC-14",
            name: "",
            size2: "100% Original Bone Combs",
            images: [require("../assets/guitar-components/bone-comb15.1.jpg"), require("../assets/guitar-components/bone-comb15.22.jpg"), require("../assets/guitar-components/bone-comb15.3.jpg"), require("../assets/guitar-components/bone-comb15.4.jpg"), require("../assets/guitar-components/bone-comb15.5.jpg")]
          },
        ],
      },
      {
        id: 566,
        img: require("../assets/guitar-components/horncombhomepage.jpg"),
        title: "Horn Comb",
        wsize: ["6.5″Inch x 1.5″ x 1/4″Inch 162mm x38mm x 6mm", "6″Inch x 1.65”Inch x 1/4″ 150mm x42mm x6mm", "71/4″x 1.63″ x 1/4″inch(Handles 3.5Inch 182mm x 6mm)", "6-1/4″ X1-3/8″X 5/32″ Inch 156mm X 35 mm X 4mm", "5.70″ X 1.25″ X5/32″ Inch 145mm X 145mm X 32mm X 4mm", "2.74″ X .93″ X 5/32″ Inch 68mm X 23mm X 4mm", "3.90″ X2.35″ X3/16″ 100mm X 58mm X 5mm", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "HC-RC-01",
            name: "Natural Horn Dresser Large Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncomb1.1.jpg"), require("../assets/guitar-components/horrncomb1.2.jpg"), require("../assets/guitar-components/horrncomb1.3.jpg"), require("../assets/guitar-components/horrncomb1.4.jpg")]
          },
          {
            prodId: "HC-RC-02",
            name: "Dragon Style Shampoo Horn Comb Large",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncomb2.1.jpg"), require("../assets/guitar-components/horrncomb2.2.jpg"), require("../assets/guitar-components/horrncomb2.3.jpg"), require("../assets/guitar-components/horrncomb2.4.jpg")]
          },
          {
            prodId: "HC-RC-03",
            name: "Natural Horn Dresser Comb With Handles",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncomb3.1.jpg"), require("../assets/guitar-components/horrncomb3.2.jpg"), require("../assets/guitar-components/horrncomb3.3.jpg")]
          },
          {
            prodId: "HC-RC-04",
            name: "Natural Horn Dresser Comb With Handles",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncomb4.1.jpg"), require("../assets/guitar-components/horrncomb4.2.jpg"), require("../assets/guitar-components/horrncomb4.3.jpg")]
          },
          {
            prodId: "HC-RC-05",
            name: "Natural Horn Straight Wider Tooth Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncomb5.1.jpg"), require("../assets/guitar-components/horrncomb5.2.jpg"), require("../assets/guitar-components/horrncomb5.3.jpg")]
          },
          {
            prodId: "HC-RC-06",
            name: "Natural Horn Mustache Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncom6.1.jpg"), require("../assets/guitar-components/horrncom6.2.jpg"), require("../assets/guitar-components/horrncom6.3.jpg"), require("../assets/guitar-components/horrncom6.4.jpg")]
          },
          {
            prodId: "HC-RC-07",
            name: "Natural Horn Small Pocket Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncom7.1.jpg"), require("../assets/guitar-components/horrncom7.2.jpg"), require("../assets/guitar-components/horrncom7.3.jpg")]
          },
          {
            prodId: "HC-RC-08",
            name: "Natural Horn Double Sided Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncom8.1.jpg"), require("../assets/guitar-components/horrncom8.2.jpg"), require("../assets/guitar-components/horrncom8.3.jpg")]
          },
          {
            prodId: "HC-RC-09",
            name: "Natural Large Horn Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncom9.1.jpg"), require("../assets/guitar-components/horrncom9.2.jpg")]
          },
          {
            prodId: "HC-RC-10",
            name: "Vintage Look Mustache Folding Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncom10.1.jpg"), require("../assets/guitar-components/horrncom10.2.jpg"), require("../assets/guitar-components/horrncom10.3.jpg")]
          },
          {
            prodId: "HC-RC-11",
            name: "Black Horn Comb",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncom11.1.jpg"), require("../assets/guitar-components/horrncom11.2.jpg"), require("../assets/guitar-components/horrncom11.3.jpg")]
          },
          {
            prodId: "HC-RC-12",
            name: "Black Folding Viking Horn Comb With Case",
            size2: "100% Original Horn Combs",
            images: [require("../assets/guitar-components/horrncom12.1.jpg"), require("../assets/guitar-components/horrncom12.2.jpg"), require("../assets/guitar-components/horrncom12.3.jpg"), require("../assets/guitar-components/horrncom12.4.jpg")]
          },
        ],
      },

    ],
  },

  // drinking horn

  {
    head: "Drinking Horn",
    headslug: 'drinking-horn',
    dec: "Experience the charm of our beautifully crafted drinking horn, made from genuine buffalo and ox horns. Each horn is meticulously polished and features a brass rim for an elegant finish. These drinking horns are authentic Bovidae horns, carefully removed from the bone core, cleaned, and polished to perfection. Ideal for mead, ale, or your favorite beverage, they add a rustic touch to any gathering. Embrace a piece of history with this unique vessel, perfect for celebrations or as a stunning decorative item. Elevate your drinking experience with a horn that blends tradition and craftsmanship beautifully. Enjoy your beverages in style",
    mainData: [
      {
        id: 57,
        img: require("../assets/guitar-components/drinking-horn1.jpg"),
        title: "Drinking Horn",
        wsize: ["100 ml", "200 ml", "300 ml", "400 ml", "500 ml", "600 ml", "700 ml", "800 ml", "900 ml", "1000 ml", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "DH-RC-01",
            name: "Plain Drinking Horn",
            size2: "100% Original Horn Craft",
            images: [require("../assets/guitar-components/drnkhrn1.jpg")]
          },
          {
            prodId: "DH-RC-02",
            name: "Metal Rim and Tip Drinking Horn",
            size2: "100% Original Horn Craft",
            images: [require("../assets/guitar-components/drnkhrn2.jpg")]
          },
          {
            prodId: "DH-RC-03",
            name: "Karveen  Drinking Horn",
            size2: "100% Original Horn Craft",
            images: [require("../assets/guitar-components/drnkhrn3.jpg")]
          },
          {
            prodId: "DH-RC-04",
            name: "Blowing Horn",
            size2: "100% Original Horn Craft",
            images: [require("../assets/guitar-components/drnkhrn4.jpg")]
          },
          {
            prodId: "DH-RC-05",
            name: "Powder Horn",
            size2: "100% Original Horn Craft",
            images: [require("../assets/guitar-components/drnkhrn5.jpg")]
          },
        ],
      },
    ],
  },

  // viking craft || Weaping plate

  {
    head: "Bone Weaving Plate",
    headslug: 'bone-weaving-plate',
    dec: "Replica of a weaving plate made of genuine bone, crafted with precision and inspired by traditional weaving techniques. These plates are ideal for textile and crafting projects, showcasing the elegance and durability of bone. Designed with a smooth finish and unique natural patterns, they draw on historic craftsmanship while offering a refined touch to your handmade creations.",
    mainData: [
      {
        id: 63,
        img: require("../assets/guitar-components/bh-wp1.jpeg"),
        title: "Bone Weaving Plate",
        wsize: ["4 x 4 cm", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-BWP-01",
            name: "4 Hole White Bone Weaving Plate",
            size2: "100% Original Bone Weaving Plate",
            images: [require("../assets/guitar-components/bh-wp1.jpeg")]
          },
        ],
      },
    ],
  },
  // viking craft || Viking Cloak Pins
  {
    head: "Viking Cloak Pins",
    headslug: 'viking-cloak-pins',
    dec: "Replica Viking cloak pins made from authentic materials, crafted with precision and inspired by traditional Viking designs. These pins are ideal for securing cloaks, garments, or adding a unique historical touch to your attire. Each pin showcases the durability and elegance of Viking craftsmanship, with a smooth finish and intricate patterns that bring a refined authenticity to any outfit.",
    mainData: [
      {
        id: 64,
        img: require("../assets/guitar-components/vcp1.png"),
        title: "Viking Cloak Pins",
        wsize: ["Length 13 – 15cm (5 – 6 inches)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-VCP-01",
            name: "Viking Bone Cloak Pins",
            size2: "100% Original Viking Bone Craft",
            images: [require("../assets/guitar-components/vcp1.png")]
          },
        ],
      },
    ],
  },
  // viking craft || Bone Needle
  {
    head: "Bone Needle",
    headslug: 'bone-needle',
    dec: "Sewing needles are crafted from solid bone and have slotted eyes which are better suited for slippery threads like wool than round holes. Bone needles have been used since the stone age and were still common well into the Medieval period, especially for commoners. Bone needles were not only inexpensive when compared to metal needles, but they also work quite well for sewing wool.",
    mainData: [
      {
        id: 65,
        img: require("../assets/guitar-components/bonennedle1.png"),
        title: "Bone Needle",
        wsize: ["Overall Length: Approximately 3 1/2”", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-BoneNeedle-01",
            name: "White Bone Needle",
            size2: "100% Original Bone Needle",
            images: [require("../assets/guitar-components/bonennedle1.png")]
          },
        ],
      },
    ],
  },

  //native american craft  || Bone Spacer
  {
    head: "Bone Spacer",
    headslug: 'bone-spacer',
    dec: "Replica Native American bone spacers made from authentic materials, crafted with precision and inspired by traditional Native American designs. These spacers are ideal for jewelry making, crafting, or adding a unique cultural touch to your creations. Each spacer showcases the durability and elegance of bone craftsmanship, with a smooth finish and intricate patterns that bring a refined authenticity to any design.",
    mainData: [
      {
        id: 66,
        img: require("../assets/guitar-components/bonespacer3.jpeg"),
        title: "Bone Spacer",
        wsize: ["2 Hole", "3 Hole", "4 Hole", "These are 1/8 inch thickness", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-NABS-01",
            name: "4 Hole White Bone Spacer",
            size2: "100% Original Bone Spacer",
            images: [require("../assets/guitar-components/bonespacer1.png")]
          },
          {
            prodId: "RC-NABS-02",
            name: "3 Hole White Bone Spacer",
            size2: "100% Original Bone Spacer",
            images: [require("../assets/guitar-components/bonespacer2.jpeg")]
          },
          {
            prodId: "RC-NABS-03",
            name: "2 Hole Antique Black Bone Spacer",
            size2: "100% Original Bone Spacer",
            images: [require("../assets/guitar-components/bonespacer3.jpeg")]
          },
          {
            prodId: "RC-NABS-04",
            name: "4 Hole Antique Black Bone Spacer",
            size2: "100% Original Bone Spacer",
            images: [require("../assets/guitar-components/bonespacer4.jpeg")]
          },
        ],
      },
    ],
  },
  //native american craft  || Horn Spacer
  {
    head: "Horn Spacer",
    headslug: 'horn-spacer',
    dec: "Replica Native American horn spacers made from authentic materials, crafted with precision and inspired by traditional Native American designs. These spacers are ideal for jewelry making, crafting, or adding a unique cultural touch to your creations. Each spacer showcases the durability and elegance of horn craftsmanship, with a smooth finish and intricate patterns that bring a refined authenticity to any design.",
    mainData: [
      {
        id: 67,
        img: require("../assets/guitar-components/hornspacer1.1.jpg"),
        title: "Horn Spacer",
        wsize: ["All kind of Horn spacer", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-NAHS-01",
            name: "Horn Spacer",
            size2: "100% Original Horn Spacer",
            images: [require("../assets/guitar-components/hornspacer1.1.jpg")]
          },
        ],
      },
    ],
  },
  //native american craft  || Buffalo Teeth
  {
    head: "Buffalo Teeth",
    headslug: 'buffalo-teeth',
    dec: "Buffalo teeth are used for necklaces and crafting. These are from the water buffalo/bison, that usually have holes drilled in them. You will also notice that the teeth are more round then flat on the ends of the tooth and not as big.",
    mainData: [
      {
        id: 68,
        img: require("../assets/guitar-components/bufalloteeth1.2.jpeg"),
        title: "Buffalo Teeth",
        wsize: ["All kind of Buffalo Teeth", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-NABT-01",
            name: "Drilled White Buffalo Teeth",
            size2: "100% Original Buffalo Teeth",
            images: [require("../assets/guitar-components/bufalloteeth1.jpeg"), require("../assets/guitar-components/bufalloteeth1.2.jpeg")]
          },
        ],
      },
    ],
  },
  // Antique Bone Knife
  {
    head: "Antique Knife",
    headslug: 'antique-bone-knife',
    dec: " Traditionally Smooth describes this bright Antique Bone handle displaying elegant tones ranging from wheat to light brown. Features Tru-Sharp™ Surgical Steel Blades, Case Bomb Script Shield and Fluted Bolsters.The assortment includes handles made from materials like bone, wood, and resin, reflecting a rich tapestry of craftsmanship and heritage. These knives not only serve as practical tools but also as collector's items, each telling a story of its era and the meticulous art of knife making.",
    mainData: [
      {
        id: 55,
        img: require("../assets/guitar-components/CHAKU-4.jpg"),
        title: "Antique Bone Knife Handle",
        wsize: ["All Kind Antique Bone Knife Available.", "Traditionally smooth describes this bright antique bone.", "Handle displaying elegant tones ranging light brown.", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-ABK-01",
            // name: "Small White Bone Clasp",
            size2: "100% Antique Bone Knife",
            images: [require("../assets/guitar-components/knife1.jpg"), require("../assets/guitar-components/knife1.1.jpg"), require("../assets/guitar-components/knife1.2.jpg"), require("../assets/guitar-components/knife1.3.jpg"), require("../assets/guitar-components/knife1.4.jpg"), require("../assets/guitar-components/knife1.5.jpg"), require("../assets/guitar-components/knife1.6.jpg"), require("../assets/guitar-components/knife1.7.jpg"), require("../assets/guitar-components/knife1.8.jpg"), require("../assets/guitar-components/knife1.9.jpg"), require("../assets/guitar-components/knife1.10.jpg"), require("../assets/guitar-components/knife1.11.jpg")]
          },
          {
            prodId: "RC-ABK-02",
            size2: "100% Antique Bone Knife",
            images: [require("../assets/guitar-components/knife2.jpg"), require("../assets/guitar-components/knife2.1.jpg"), require("../assets/guitar-components/knife2.2.jpg"), require("../assets/guitar-components/knife2.3.jpg"), require("../assets/guitar-components/knife2.4.jpg"), require("../assets/guitar-components/knife2.5.jpg"), require("../assets/guitar-components/knife2.6.jpg"), require("../assets/guitar-components/knife2.7.jpg"), require("../assets/guitar-components/knife2.8.jpg"), require("../assets/guitar-components/knife2.9.jpg"), require("../assets/guitar-components/knife2.10.jpg"), require("../assets/guitar-components/knife2.11.jpg"), require("../assets/guitar-components/knife2.12.jpg")]
          },
          {
            prodId: "RC-ABK-03",
            size2: "100% Antique Bone Knife",
            images: [require("../assets/guitar-components/knife3.6.jpg"), require("../assets/guitar-components/knife3.jpg"), require("../assets/guitar-components/knife3.1.jpg"), require("../assets/guitar-components/knife3.2.jpg"), require("../assets/guitar-components/knife3.3.jpg"), require("../assets/guitar-components/knife3.4.jpg"), require("../assets/guitar-components/knife3.5.jpg")]
          },
          {
            prodId: "RC-ABK-04",
            size2: "100% Antique Bone Knife",
            images: [require("../assets/guitar-components/knife4.jpg"), require("../assets/guitar-components/knife4.1.jpg"), require("../assets/guitar-components/knife4.2.jpg")]
          },
          {
            prodId: "RC-ABK-05",
            size2: "100% Antique Bone Knife",
            images: [require("../assets/guitar-components/knife6.jpg"), require("../assets/guitar-components/knife6.1.jpg"), require("../assets/guitar-components/knife6.2.jpg"), require("../assets/guitar-components/knife6.3.jpg"), require("../assets/guitar-components/knife6.4.jpg"), require("../assets/guitar-components/knife6.5.jpg"), require("../assets/guitar-components/knife6.6.jpg"), require("../assets/guitar-components/knife6.7.jpg")]
          },
          {
            prodId: "RC-ABK-06",
            size2: "100% Antique Bone Knife",
            images: [require("../assets/guitar-components/knife7.jpg")]
          },
        ],
      },
      {
        id: 56,
        img: require("../assets/guitar-components/knife5.4.jpg"),
        title: "Antique Horn Knife Handle",
        wsize: ["All Kind Antique Horn Knife Available.", "Traditionally smooth describes this bright antique Horn.", "Handle displaying elegant tones ranging light brown.", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-AHK-01",
            size2: "100% Antique Horn Knife",
            images: [require("../assets/guitar-components/knife5.jpg"), require("../assets/guitar-components/knife5.1.jpg"), require("../assets/guitar-components/knife5.2.jpg"), require("../assets/guitar-components/knife5.3.jpg"), require("../assets/guitar-components/knife5.4.jpg")]
          },

        ],
      },

    ],
  },

  //native american craft  || cue ferrules
  {
    head: "Cue Ferrules",
    headslug: 'cue-ferrules',
    dec: "For such a small item, ferrules play a huge role in the way that your pool cue performs.  Replacing your ferrule can be tricky, especially if you don’t have a lathe to work with.  We stock some of the most popular resin, Ivorine and phenolic ferrules, giving you the ability to repair or upgrade your pool cue shaft.",
    mainData: [
      {
        id: 69,
        img: require("../assets/guitar-components/cueferrels1jpeg.jpeg"),
        title: "Cue Ferrules",
        wsize: ["13.5+ mm x 31.5 mm (Inches .540″ x 1.25″)", "16 mm x 26 mm (Inches 5/8″ x 1″)", "16 mm x 30 mm (Inches  5/8″ x 1-1/8″)", "16 mm x 33 mm (Inches 5/8″ x 1.29″) ", "16 mm x 40 mm ( Inches 5/8″ x 1.5748)", "551″ (14+ mm) 1.25″ (31.5 mm)", "14 mm x 31.5 mm (Inches  .551″ x  1.25″)", "14 mm x 26 mm (inches  .551 x 1″)", "14 mm x 33 mm (Inches  .551″ x  1.29″ ", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CTCF-01",
            name: "Buffalo Horn Cue Ferrules",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/cueferrels1jpeg.jpeg"), require("../assets/guitar-components/cueferrels1.2jpeg.jpeg"), require("../assets/guitar-components/cueferrels1.3jpeg.jpeg")]
          },
          {
            prodId: "RC-CTCF-02",
            name: "Bone Cue Ferrules",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/cueferrels2.jpeg"), require("../assets/guitar-components/cueferrels2.1.jpeg"), require("../assets/guitar-components/cueferrels2.2.jpeg")]
          },
          {
            prodId: "RC-CTCF-03",
            name: "Teflon Cue Ferrules",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/cueferrels3.jpeg")]
          },
        ],
      },
    ],
  },
  //native american craft  || joint-collor
  {
    head: "Joint Collar - Cue Components",
    headslug: 'joint-collor',
    dec: "For such a small component, the joint collar plays a crucial role in the performance and feel of your pool cue. Replacing or upgrading your joint collar can be a precise task, especially without the proper tools. We offer a variety of high-quality joint collars made from durable materials, allowing you to repair or enhance your cue with ease. Whether you’re looking for a specific design or superior craftsmanship, our selection of joint collars ensures an optimal fit and improved cue performance.For such a small item, ferrules play a huge role in the way that your pool cue performs.  Replacing your ferrule can be tricky, especially if you don’t have a lathe to work with.",
    mainData: [
      {
        id: 70,
        img: require("../assets/guitar-components/jointcollor2.jpeg"),
        title: "Joint Collor",
        wsize: ["25.5 mm x 25.5 mm (Inches 1″  x 1″)", "25.5 mm x 33 mm (Inches  1″ x 1-1/3″)", "25.5 mm x 35 mm (Inches  1″ x 1-3/8″)", "25.5 mm x 40 mm ( Inches 1-3/8″ x 1-1/2″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CTJC-01",
            name: "Black Horn Cue Joint Collar",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/jointcollor1.jpeg")]
          },
          {
            prodId: "RC-CTJC-02",
            name: "Teflon Cue Joint Collar",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/jointcollor2.jpeg")]
          },
        ],
      },
    ],
  },
  //native american craft  || Butt caps
  {
    head: "Butt Caps - Cue Components",
    headslug: 'butt-caps',
    dec: "Replacing or upgrading your butt cap can be a delicate task, especially without the right tools. We offer a wide selection of high-quality butt caps made from durable materials, allowing you to repair or enhance your cue’s functionality and appearance. Whether you're restoring an old cue or customizing a new one, our butt caps provide a perfect fit and a polished finish to complete your cue's design.",
    mainData: [
      {
        id: 79,
        img: require("../assets/guitar-components/buttcaps1.jpeg"),
        title: "Butt Caps",
        wsize: ["35 mm x 26 mm (Inches 1-3/8″  x 1″)", "35 mm x 29 mm (Inches  1-3/8″ x 1-1/8″)", "35 mm x 32 mm (Inches 5/8″  x 1-1/4″)", "30 mm x 35 mm ( Inches 1-1/8″ x 1-3/8″)", "35 mm x 38 mm ( Inches 1-3/8″ x 1-1/2″)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CTBC-01",
            name: "Horn Black Cue Butt Caps",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/buttcaps1.jpeg"), require("../assets/guitar-components/buttcaps1.1.jpeg"), require("../assets/guitar-components/buttcaps1.2.jpeg")]
          },
          {
            prodId: "RC-CTBC-02",
            name: "Teflon Cue Butt Caps",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/buttcaps2.jpeg")]
          },
        ],
      },
    ],
  },
  //native american craft  || Inlay Slabs
  {
    head: "Inlay Slabs - Cue Components",
    headslug: 'inlay-slabs-cue-components',
    dec: "Inlay slabs are essential for adding intricate designs and unique character to your pool cue. These components allow for precise customization, enhancing both the visual appeal and value of your cue. Crafted from high-quality materials, our inlay slabs are available in a variety of patterns and finishes, perfect for repairs or bespoke cue designs. Whether you're restoring a classic cue or creating a custom masterpiece, our inlay slabs provide the ideal solution for adding a touch of elegance and craftsmanship.",
    mainData: [
      {
        id: 71,
        img: require("../assets/guitar-components/inlayslab2.3.jpeg"),
        title: "Inlay Slabs",
        wsize: ["8″ long x 7/8″ wide x 3/16″mm ", "Thickness (200 mm x 23 mm x 4 mm)", " 12″x 2″x 5/32mm – 300mm x 52 x 5mm", "8″ x 2″ x 3/16″ (200 x52 x4 mm)", "8″ x 2″ x 3/16″ (200 x52 x4 mm)", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CTIS-01",
            name: "Teflon Cue Inlay Slabs",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/inlayslab1.jpeg")]
          },
          {
            prodId: "RC-CTIS-02",
            name: "Dyed Stabilized White Bone Cue Inlay Slabs",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/inlayslab2.1.jpeg"), require("../assets/guitar-components/inlayslab2.2.jpeg"), require("../assets/guitar-components/inlayslab2.3.jpeg")]
          },
          {
            prodId: "RC-CTIS-03",
            name: "Red Rose Horn Cue Inlay Slab",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/inlayslab3.jpeg")]
          },
          {
            prodId: "RC-CTIS-04",
            name: "Tea Green Horn Cue Inlay Slab",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/inlayslab4.jpeg")]
          },
          {
            prodId: "RC-CTIS-05",
            name: "Yellow Horn Cue Inlay Slab",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/inlayslab5.jpeg")]
          },
          {
            prodId: "RC-CTIS-06",
            name: "Black Horn Cue Inlay Slab",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/inlayslab6.jpeg")]
          },
        ],
      },
    ],
  },
  //native american craft  || rods & dowels
  {
    head: "Rods & Dowels - Cue Components",
    headslug: 'rods-dowels-cue-components',
    dec: "A cue is (1) a signal prompting an event or action, especially in a performance; and (2) the long stick used to strike the cue ball in billiards and pool. The word also works as a verb meaning give a cue. A queue is (1) a line of people waiting for something, and (2) a hair braid worn down the back of the neck.",
    mainData: [
      {
        id: 72,
        img: require("../assets/guitar-components/cuestick000001.jpg"),
        title: "Rods & Dowels ",
        wsize: ["All kind of Rods & Dowels - Cue Components", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-CTIS-01",
            name: "Rods & Dowels Components",
            size2: "100% Original Items",
            images: [require("../assets/guitar-components/cuestick000001.jpg")]
          },
        ],
      },
    ],
  },
  //  || Home Decor
  {
    head: "Home Decor",
    headslug: 'home-decor',
    dec: "The decoration and look of the house play a major role in determining the mood of the place. The décor of the house also has an effect on the mood of the people living in the house, so it is important to pay attention to the décor. A good looking house is good for getting rid of anxiety and stress.",
    mainData: [
      {
        id: 73,
        img: require("../assets/guitar-components/homedecor4.2.jpg"),
        title: "Home Decor",
        wsize: ["7″ x 7″", "All kind of Rods & Dowels - Cue Components", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-HD-01",
            name: "Bone White Jewelry Net Engraved Box",
            size2: "100% Original Handicraft Items",
            images: [require("../assets/guitar-components/homedecor1.1.jpg"), require("../assets/guitar-components/homedecor1.2.jpg"), require("../assets/guitar-components/homedecor1.3.jpg")]
          },
          {
            prodId: "RC-HD-02",
            name: "Bone White Net Engraved Minar Power Lamp",
            size2: "100% Original Handicraft Items",
            images: [require("../assets/guitar-components/homedecor2.1.jpg"), require("../assets/guitar-components/homedecor2.2.jpg"), require("../assets/guitar-components/homedecor2.3.jpg")]
          },
          {
            prodId: "RC-HD-03",
            name: "Bone White Net Engraved Hexa Jewelry Box",
            size2: "100% Original Handicraft Items",
            images: [require("../assets/guitar-components/homedecor3.1.jpg"), require("../assets/guitar-components/homedecor3.2.jpg"), require("../assets/guitar-components/homedecor3.3.jpg")]
          },
          {
            prodId: "RC-HD-04",
            name: "Bone White Net With Elephant Engraved Hexa Jewelry Box",
            size2: "100% Original Handicraft Items",
            images: [require("../assets/guitar-components/homedecor4.1.jpg"), require("../assets/guitar-components/homedecor4.2.jpg")]
          },
        ],
      },
    ],
  },
  //  || piono & organ keys
  {
    head: "Piono & Organ Keys",
    headslug: 'piono-organ-keys',
    dec: "White bone key tops. Set contains 52 bone heads, 50 bone tails, and two wide bone tails. This 52 count piano set is ideal for folks who desire a natural material that is an alternative and less expensive material to ivory. The heads are a full 1 inch by 2 inch and the tails are .600″ + by 4 inches. The wide tails (A & C key) are a full 1 inch by 4 inch. A few extra keys included at no extra charge.Thickness will vary slightly from piece to piece with most being .110″ thick. Bone is ideal for folks who desire a natural white top material yet who wish to avoid ivory. Bone has a look and feel that differs from ivory and many players and owners like this look and feel better.",
    mainData: [
      {
        id: 74,
        img: require("../assets/guitar-components/pkok20.4.jpg"),
        title: "Piano Keys & Organ Keys",
        wsize: ["(1/8″ x 1″ x 6″), 160” (4mm)", "1/2″ X 1/2″ X 5 ” length (12.7mm X 12.7mm X 127 mm)", "600 ” X 4″ X .100″", "1″ X 2 ” X .100″", "100″/600″/4 Inches", "1 ” X 4 ” X .100″", "(110 X 1 X 6)Inches", " Heads are a full 1″ X 2″ and tails are .600″+ X 4″", "More Sizes Available As per requirement"],
        usbData: [
          {
            prodId: "RC-PKOK-01",
            name: "Bone Piano Keys 2 piece 52 count set",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok1.1.jpeg"), require("../assets/guitar-components/pkok1.2.jpeg"), require("../assets/guitar-components/pkok1.3.jpeg")]
          },
          {
            prodId: "RC-PKOK-02",
            name: "Bone Piano Key (One piece key top)",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok2.jpeg"), require("../assets/guitar-components/pkok3.1.jpeg"), require("../assets/guitar-components/pkok3.2.jpeg")]
          },
          {
            prodId: "RC-PKOK-03",
            name: "Bone Harpsichord Square Blank",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok4.jpeg"), require("../assets/guitar-components/pkok5.jpeg")]
          },
          {
            prodId: "RC-PKOK-04",
            name: "Bone Harpsichord Or Clavichord Sharps",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok6.1.jpeg"), require("../assets/guitar-components/pkok6.2.jpeg"), require("../assets/guitar-components/pkok6.3.jpeg"), require("../assets/guitar-components/pkok7.1.jpeg"), require("../assets/guitar-components/pkok7.2.jpeg")]
          },
          {
            prodId: "RC-PKOK-05",
            name: "Bone Piano Keys (Heads)",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok8.1.jpeg"), require("../assets/guitar-components/pkok8.2.jpeg"), require("../assets/guitar-components/pkok9.1.jpeg"), require("../assets/guitar-components/pkok9.2.jpeg")]
          },
          {
            prodId: "RC-PKOK-06",
            name: "Bone Piano Key (Tails)",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok10.1.jpg"), require("../assets/guitar-components/pkok10.2.jpg"), require("../assets/guitar-components/pkok11.jpg")]
          },
          {
            prodId: "RC-PKOK-07",
            name: "Bone Piano Keys (Wide tails)",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok12.1.jpg"), require("../assets/guitar-components/pkok12.2.jpg"), require("../assets/guitar-components/pkok13.1.jpg"), require("../assets/guitar-components/pkok13.2.jpg")]
          },
          {
            prodId: "RC-PKOK-08",
            name: "Bone Organ Keys 1 piece 40 count set",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok14.jpg"), require("../assets/guitar-components/pkok15.jpg")]
          },
          {
            prodId: "RC-PKOK-09",
            name: "Bone Harpsichord Keys 2 piece 36 count set",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok16.jpg"), require("../assets/guitar-components/pkok17.jpg")]
          },
          {
            prodId: "RC-PKOK-10",
            name: "Bone Piano Keys 1 piece 60 count set",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok18.jpg"), require("../assets/guitar-components/pkok19.jpg")]
          },
          {
            prodId: "RC-PKOK-11",
            name: "Dyed Stabilized Bone Amber Organ key and Piano key",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok20.1.jpg"), require("../assets/guitar-components/pkok20.2.jpg"), require("../assets/guitar-components/pkok20.3.jpg"), require("../assets/guitar-components/pkok20.4.jpg")]
          },
          {
            prodId: "RC-PKOK-12",
            name: "Dyed Stabilized Bone Brown Organ Key and Piano Key",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok21.1.jpg"), require("../assets/guitar-components/pkok21.2.jpg"), require("../assets/guitar-components/pkok21.3.jpg"), require("../assets/guitar-components/pkok21.4.jpg")]
          },
          {
            prodId: "RC-PKOK-13",
            name: "Dyed Stabilized Bone Grey-Blue organ key and piano key",
            size2: "100% Original Piano & Organ Bone Keys",
            images: [require("../assets/guitar-components/pkok22.1.jpg"), require("../assets/guitar-components/pkok22.2.jpg")]
          },
        ],
      },
    ],
  },


  {
    head: "Belt Buckles",
    headslug: 'belt-buckle',
    dec: "Great buckle with an interesting scrolled outline features a crisp casting of the Bavarian coat of arms at the centre, and for belt against a textured background. rrFits wide belt  separately; or any belt of that width.",
    mainData: [
      {
        id: 75,
        img: require("../assets/guitar-components/belt1.jpg"),
        title: "Belt Buckles",
        wsize: ["Stylish buckle design.", "Features a scrolled outline.", "Crisp casting detail.", "Bavarian coat of arms in the centre.", "Textured background for contrast.", "Made for wide belts.", "Belt fits separately.", "Suitable for any belt of that width."],
        usbData: [
          {
            prodId: "RC-BB-01",
            name: "Deer Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt1.jpg")]
          },
          {
            prodId: "RC-BB-02",
            name: "Warrior Viking Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt3.jpg")]
          },
          {
            prodId: "RC-BB-03",
            name: "Thor Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt4.jpg")]
          },
          {
            prodId: "RC-BB-04",
            name: "Elk Vintage Belt Buckle ",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt5.jpg")]
          },
          {
            prodId: "RC-BB-05",
            name: "Antique Silver Bat Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt6.jpg")]
          },
          {
            prodId: "RC-BB-06",
            name: "Vintage Elk Head Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt7.jpg")]
          },
          {
            prodId: "RC-BB-07",
            name: " Silver Oktoberfest Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt8.jpg")]
          },
          {
            prodId: "RC-BB-08",
            name: "Longcreek Deer Belt Buckle ",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt9.jpg")]
          },
          {
            prodId: "RC-BB-09",
            name: "Lion Vintage Crown Belt Buckle ",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt10.jpg")]
          },
          {
            prodId: "RC-BB-10",
            name: "Handcrafted Oval Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt11.jpg")]
          },
          {
            prodId: "RC-BB-11",
            name: "Deer Elk Wildlife Scene Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt14.jpg")]
          },
          {
            prodId: "RC-BB-12",
            name: "Classic Crown Lion Armor Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt15.jpg")]
          },
          {
            prodId: "RC-BB-13",
            name: "VINTAGE 1974 BUCK DEER BELT BUCKLE B",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt16.jpg")]
          },
          {
            prodId: "RC-BB-14",
            name: "Deer Elk Belts Buckle Metal Vintage",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt17.jpg")]
          },
          {
            prodId: "RC-BB-15",
            name: "Oval Bavarian Crest Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt19.jpg")]
          },
          {
            prodId: "RC-BB-16",
            name: "Celtic Viking Belt Buckle ",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt22.jpg")]
          },
          {
            prodId: "RC-BB-17",
            name: "Elk Trophy Belt Buckle ",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt23.jpg")]
          },
          {
            prodId: "RC-BB-18",
            name: "Classic Western Cowboy Fashion Belt Buckle",
            size2: "100% Original Belt Buckle",
            images: [require("../assets/guitar-components/belt24.jpg")]
          },

        ],
      },
    ],
  },
];

export { ConstantData, OurProductData };

